//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.17.0.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AccountServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    isTenantAvailable(body: IsTenantAvailableInput | undefined): Observable<IsTenantAvailableOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/IsTenantAvailable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsTenantAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsTenantAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IsTenantAvailableOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IsTenantAvailableOutput>;
        }));
    }

    protected processIsTenantAvailable(response: HttpResponseBase): Observable<IsTenantAvailableOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IsTenantAvailableOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param email (optional) 
     * @param userId (optional) 
     * @return Success
     */
    userNameOrEmailExist(email: string | undefined, userId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Account/UserNameOrEmailExist?";
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserNameOrEmailExist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserNameOrEmailExist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUserNameOrEmailExist(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    sendConfirmationEmail(userId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Account/SendConfirmationEmail?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendConfirmationEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendConfirmationEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSendConfirmationEmail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param token (optional) 
     * @return Success
     */
    confirmEmail(userId: number | undefined, token: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Account/ConfirmEmail?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processConfirmEmail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    forgotPassword(body: ForgotPasswordDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Account/ForgotPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForgotPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForgotPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processForgotPassword(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param token (optional) 
     * @param newPassword (optional) 
     * @return Success
     */
    setNewPasswordAfterReset(userId: number | undefined, token: string | undefined, newPassword: string | undefined): Observable<ResetPasswordResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Account/SetNewPasswordAfterReset?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        if (newPassword === null)
            throw new Error("The parameter 'newPassword' cannot be null.");
        else if (newPassword !== undefined)
            url_ += "newPassword=" + encodeURIComponent("" + newPassword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetNewPasswordAfterReset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetNewPasswordAfterReset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResetPasswordResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResetPasswordResultDto>;
        }));
    }

    protected processSetNewPasswordAfterReset(response: HttpResponseBase): Observable<ResetPasswordResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResetPasswordResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fiscalCode (optional) 
     * @return Success
     */
    getCompanyInfoFromAppCore(fiscalCode: string | undefined): Observable<AppCoreCompanyDto> {
        let url_ = this.baseUrl + "/api/services/app/Account/GetCompanyInfoFromAppCore?";
        if (fiscalCode === null)
            throw new Error("The parameter 'fiscalCode' cannot be null.");
        else if (fiscalCode !== undefined)
            url_ += "fiscalCode=" + encodeURIComponent("" + fiscalCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyInfoFromAppCore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyInfoFromAppCore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppCoreCompanyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppCoreCompanyDto>;
        }));
    }

    protected processGetCompanyInfoFromAppCore(response: HttpResponseBase): Observable<AppCoreCompanyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppCoreCompanyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    register(body: RegisterInput | undefined): Observable<RegisterOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegisterOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegisterOutput>;
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<RegisterOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    toggleNotificationSubscription(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Account/ToggleNotificationSubscription";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processToggleNotificationSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToggleNotificationSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processToggleNotificationSubscription(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AdminDashboardServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    get(): Observable<AdminDashboardReportDto> {
        let url_ = this.baseUrl + "/api/services/app/AdminDashboard/Get";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdminDashboardReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdminDashboardReportDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AdminDashboardReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdminDashboardReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class BannerServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param pageName (optional) 
     * @return Success
     */
    getAll(pageName: string | undefined): Observable<BannerDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Banner/GetAll?";
        if (pageName === null)
            throw new Error("The parameter 'pageName' cannot be null.");
        else if (pageName !== undefined)
            url_ += "pageName=" + encodeURIComponent("" + pageName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BannerDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BannerDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<BannerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BannerDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param bannerStaticCode (optional) 
     * @return Success
     */
    hideBanners(bannerStaticCode: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Banner/HideBanners?";
        if (bannerStaticCode === null)
            throw new Error("The parameter 'bannerStaticCode' cannot be null.");
        else if (bannerStaticCode !== undefined)
            url_ += "bannerStaticCode=" + encodeURIComponent("" + bannerStaticCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHideBanners(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHideBanners(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processHideBanners(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CompanyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param serialNumber (optional) 
     * @return Success
     */
    assignMasterUser(serialNumber: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Company/AssignMasterUser?";
        if (serialNumber === null)
            throw new Error("The parameter 'serialNumber' cannot be null.");
        else if (serialNumber !== undefined)
            url_ += "serialNumber=" + encodeURIComponent("" + serialNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignMasterUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignMasterUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAssignMasterUser(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getCompanyByUserId(userId: number | undefined): Observable<CompanyExtendedDto> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetCompanyByUserId?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyByUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyExtendedDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyExtendedDto>;
        }));
    }

    protected processGetCompanyByUserId(response: HttpResponseBase): Observable<CompanyExtendedDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyExtendedDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateCompanyDto | undefined): Observable<CompanyDto> {
        let url_ = this.baseUrl + "/api/services/app/Company/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CompanyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param sectorId (optional) 
     * @param regionId (optional) 
     * @param businessName (optional) 
     * @param fiscalCode (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, sectorId: number | undefined, regionId: number | undefined, businessName: string | undefined, fiscalCode: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CompanyDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Company/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sectorId === null)
            throw new Error("The parameter 'sectorId' cannot be null.");
        else if (sectorId !== undefined)
            url_ += "SectorId=" + encodeURIComponent("" + sectorId) + "&";
        if (regionId === null)
            throw new Error("The parameter 'regionId' cannot be null.");
        else if (regionId !== undefined)
            url_ += "RegionId=" + encodeURIComponent("" + regionId) + "&";
        if (businessName === null)
            throw new Error("The parameter 'businessName' cannot be null.");
        else if (businessName !== undefined)
            url_ += "BusinessName=" + encodeURIComponent("" + businessName) + "&";
        if (fiscalCode === null)
            throw new Error("The parameter 'fiscalCode' cannot be null.");
        else if (fiscalCode !== undefined)
            url_ += "FiscalCode=" + encodeURIComponent("" + fiscalCode) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CompanyDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CompanyUserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param includeMasterUser (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, companyId: number, includeMasterUser: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<BaseUserDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CompanyUser/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined and cannot be null.");
        else
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (includeMasterUser === null)
            throw new Error("The parameter 'includeMasterUser' cannot be null.");
        else if (includeMasterUser !== undefined)
            url_ += "IncludeMasterUser=" + encodeURIComponent("" + includeMasterUser) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BaseUserDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BaseUserDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<BaseUserDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseUserDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ConfigurationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeUiTheme(body: ChangeUiThemeInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/ChangeUiTheme";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeUiTheme(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeUiTheme(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeUiTheme(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getGoToWebinarConfig(): Observable<GoToWebinarSetting> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/GetGoToWebinarConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGoToWebinarConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGoToWebinarConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GoToWebinarSetting>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GoToWebinarSetting>;
        }));
    }

    protected processGetGoToWebinarConfig(response: HttpResponseBase): Observable<GoToWebinarSetting> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GoToWebinarSetting.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ContractServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ContractDto> {
        let url_ = this.baseUrl + "/api/services/app/Contract/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContractDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContractDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ContractDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContractDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param contractId (optional) 
     * @return Success
     */
    downloadOverview(contractId: number | undefined): Observable<FileDownloadDto> {
        let url_ = this.baseUrl + "/api/services/app/Contract/DownloadOverview?";
        if (contractId === null)
            throw new Error("The parameter 'contractId' cannot be null.");
        else if (contractId !== undefined)
            url_ += "contractId=" + encodeURIComponent("" + contractId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDownloadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDownloadDto>;
        }));
    }

    protected processDownloadOverview(response: HttpResponseBase): Observable<FileDownloadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownloadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateContractDto | undefined): Observable<ContractDto> {
        let url_ = this.baseUrl + "/api/services/app/Contract/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContractDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContractDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ContractDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContractDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param contractId (optional) 
     * @param file (optional) 
     * @return Success
     */
    createFile(contractId: number | undefined, file: FileParameter | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Contract/CreateFile?";
        if (contractId === null)
            throw new Error("The parameter 'contractId' cannot be null.");
        else if (contractId !== undefined)
            url_ += "contractId=" + encodeURIComponent("" + contractId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processCreateFile(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param applicationIds (optional) 
     * @param beneficiaryIds (optional) 
     * @param facilitationIds (optional) 
     * @param regionIds (optional) 
     * @param eligibleExpenditureIds (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, applicationIds: number[] | undefined, beneficiaryIds: number[] | undefined, facilitationIds: number[] | undefined, regionIds: number[] | undefined, eligibleExpenditureIds: number[] | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ContractBaseDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Contract/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (applicationIds === null)
            throw new Error("The parameter 'applicationIds' cannot be null.");
        else if (applicationIds !== undefined)
            applicationIds && applicationIds.forEach(item => { url_ += "ApplicationIds=" + encodeURIComponent("" + item) + "&"; });
        if (beneficiaryIds === null)
            throw new Error("The parameter 'beneficiaryIds' cannot be null.");
        else if (beneficiaryIds !== undefined)
            beneficiaryIds && beneficiaryIds.forEach(item => { url_ += "BeneficiaryIds=" + encodeURIComponent("" + item) + "&"; });
        if (facilitationIds === null)
            throw new Error("The parameter 'facilitationIds' cannot be null.");
        else if (facilitationIds !== undefined)
            facilitationIds && facilitationIds.forEach(item => { url_ += "FacilitationIds=" + encodeURIComponent("" + item) + "&"; });
        if (regionIds === null)
            throw new Error("The parameter 'regionIds' cannot be null.");
        else if (regionIds !== undefined)
            regionIds && regionIds.forEach(item => { url_ += "RegionIds=" + encodeURIComponent("" + item) + "&"; });
        if (eligibleExpenditureIds === null)
            throw new Error("The parameter 'eligibleExpenditureIds' cannot be null.");
        else if (eligibleExpenditureIds !== undefined)
            eligibleExpenditureIds && eligibleExpenditureIds.forEach(item => { url_ += "EligibleExpenditureIds=" + encodeURIComponent("" + item) + "&"; });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContractBaseDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContractBaseDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ContractBaseDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContractBaseDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FileServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param fileId (optional) 
     * @return Success
     */
    downloadFile(fileId: number | undefined): Observable<FileDownloadDto> {
        let url_ = this.baseUrl + "/api/services/app/File/DownloadFile?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDownloadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDownloadDto>;
        }));
    }

    protected processDownloadFile(response: HttpResponseBase): Observable<FileDownloadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownloadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return Success
     */
    getFile(fileId: number | undefined): Observable<FileExtendedDto> {
        let url_ = this.baseUrl + "/api/services/app/File/GetFile?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileExtendedDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileExtendedDto>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<FileExtendedDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileExtendedDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return Success
     */
    getVideo(fileId: number | undefined): Observable<VideoFileDto> {
        let url_ = this.baseUrl + "/api/services/app/File/GetVideo?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVideo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVideo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VideoFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VideoFileDto>;
        }));
    }

    protected processGetVideo(response: HttpResponseBase): Observable<VideoFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VideoFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FileMigratorToolServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    migrateAllFiles(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/FileMigratorTool/MigrateAllFiles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMigrateAllFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMigrateAllFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processMigrateAllFiles(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class GoToServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getGoToToken(): Observable<GoToTokenDto> {
        let url_ = this.baseUrl + "/api/services/app/GoTo/GetGoToToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGoToToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGoToToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GoToTokenDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GoToTokenDto>;
        }));
    }

    protected processGetGoToToken(response: HttpResponseBase): Observable<GoToTokenDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GoToTokenDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createGoToToken(body: CreateGoToTokenDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GoTo/CreateGoToToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateGoToToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateGoToToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateGoToToken(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteGoToToken(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GoTo/DeleteGoToToken?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteGoToToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteGoToToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteGoToToken(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class InfocicaApplicationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllAvailableForLoggedUser(): Observable<InfocicaApplicationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/InfocicaApplication/GetAllAvailableForLoggedUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAvailableForLoggedUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAvailableForLoggedUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InfocicaApplicationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InfocicaApplicationDto[]>;
        }));
    }

    protected processGetAllAvailableForLoggedUser(response: HttpResponseBase): Observable<InfocicaApplicationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InfocicaApplicationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, maxResultCount: number | undefined): Observable<InfocicaApplicationDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/InfocicaApplication/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InfocicaApplicationDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InfocicaApplicationDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<InfocicaApplicationDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InfocicaApplicationDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<InfocicaApplicationDto> {
        let url_ = this.baseUrl + "/api/services/app/InfocicaApplication/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InfocicaApplicationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InfocicaApplicationDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<InfocicaApplicationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InfocicaApplicationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class InfocicaBeneficiaryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllAvailableForLoggedUser(): Observable<InfocicaBeneficiaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/InfocicaBeneficiary/GetAllAvailableForLoggedUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAvailableForLoggedUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAvailableForLoggedUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InfocicaBeneficiaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InfocicaBeneficiaryDto[]>;
        }));
    }

    protected processGetAllAvailableForLoggedUser(response: HttpResponseBase): Observable<InfocicaBeneficiaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InfocicaBeneficiaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, maxResultCount: number | undefined): Observable<InfocicaBeneficiaryDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/InfocicaBeneficiary/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InfocicaBeneficiaryDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InfocicaBeneficiaryDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<InfocicaBeneficiaryDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InfocicaBeneficiaryDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<InfocicaBeneficiaryDto> {
        let url_ = this.baseUrl + "/api/services/app/InfocicaBeneficiary/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InfocicaBeneficiaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InfocicaBeneficiaryDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<InfocicaBeneficiaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InfocicaBeneficiaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class InfocicaEligibleExpenditureServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllAvailableForLoggedUser(): Observable<InfocicaEligibleExpenditureDto[]> {
        let url_ = this.baseUrl + "/api/services/app/InfocicaEligibleExpenditure/GetAllAvailableForLoggedUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAvailableForLoggedUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAvailableForLoggedUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InfocicaEligibleExpenditureDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InfocicaEligibleExpenditureDto[]>;
        }));
    }

    protected processGetAllAvailableForLoggedUser(response: HttpResponseBase): Observable<InfocicaEligibleExpenditureDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InfocicaEligibleExpenditureDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, maxResultCount: number | undefined): Observable<InfocicaEligibleExpenditureDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/InfocicaEligibleExpenditure/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InfocicaEligibleExpenditureDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InfocicaEligibleExpenditureDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<InfocicaEligibleExpenditureDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InfocicaEligibleExpenditureDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<InfocicaEligibleExpenditureDto> {
        let url_ = this.baseUrl + "/api/services/app/InfocicaEligibleExpenditure/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InfocicaEligibleExpenditureDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InfocicaEligibleExpenditureDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<InfocicaEligibleExpenditureDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InfocicaEligibleExpenditureDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class InfocicaFacilitationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllAvailableForLoggedUser(): Observable<InfocicaFacilitationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/InfocicaFacilitation/GetAllAvailableForLoggedUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAvailableForLoggedUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAvailableForLoggedUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InfocicaFacilitationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InfocicaFacilitationDto[]>;
        }));
    }

    protected processGetAllAvailableForLoggedUser(response: HttpResponseBase): Observable<InfocicaFacilitationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InfocicaFacilitationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, maxResultCount: number | undefined): Observable<InfocicaFacilitationDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/InfocicaFacilitation/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InfocicaFacilitationDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InfocicaFacilitationDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<InfocicaFacilitationDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InfocicaFacilitationDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<InfocicaFacilitationDto> {
        let url_ = this.baseUrl + "/api/services/app/InfocicaFacilitation/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InfocicaFacilitationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InfocicaFacilitationDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<InfocicaFacilitationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InfocicaFacilitationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class InfocicaProvinceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, maxResultCount: number | undefined): Observable<InfocicaProvinceDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/InfocicaProvince/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InfocicaProvinceDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InfocicaProvinceDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<InfocicaProvinceDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InfocicaProvinceDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<InfocicaProvinceDto> {
        let url_ = this.baseUrl + "/api/services/app/InfocicaProvince/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InfocicaProvinceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InfocicaProvinceDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<InfocicaProvinceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InfocicaProvinceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class InfocicaRegionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllAvailableForLoggedUser(): Observable<InfocicaRegionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/InfocicaRegion/GetAllAvailableForLoggedUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAvailableForLoggedUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAvailableForLoggedUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InfocicaRegionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InfocicaRegionDto[]>;
        }));
    }

    protected processGetAllAvailableForLoggedUser(response: HttpResponseBase): Observable<InfocicaRegionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InfocicaRegionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, maxResultCount: number | undefined): Observable<InfocicaRegionDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/InfocicaRegion/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InfocicaRegionDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InfocicaRegionDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<InfocicaRegionDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InfocicaRegionDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<InfocicaRegionDto> {
        let url_ = this.baseUrl + "/api/services/app/InfocicaRegion/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InfocicaRegionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InfocicaRegionDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<InfocicaRegionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InfocicaRegionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NewsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<NewsDto> {
        let url_ = this.baseUrl + "/api/services/app/News/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NewsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NewsDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<NewsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NewsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllNewsForHome(): Observable<NewsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/News/GetAllNewsForHome";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllNewsForHome(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllNewsForHome(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NewsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NewsDto[]>;
        }));
    }

    protected processGetAllNewsForHome(response: HttpResponseBase): Observable<NewsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NewsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    downloadFeedRSSNews(): Observable<FeedRSSNewsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/News/DownloadFeedRSSNews";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadFeedRSSNews(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadFeedRSSNews(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FeedRSSNewsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FeedRSSNewsDto[]>;
        }));
    }

    protected processDownloadFeedRSSNews(response: HttpResponseBase): Observable<FeedRSSNewsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FeedRSSNewsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<NewsDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/News/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NewsDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NewsDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<NewsDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NewsDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ParticipationModeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param isPickableByUser (optional) 
     * @return Success
     */
    getAll(isPickableByUser: boolean | undefined): Observable<ParticipationModeDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ParticipationMode/GetAll?";
        if (isPickableByUser === null)
            throw new Error("The parameter 'isPickableByUser' cannot be null.");
        else if (isPickableByUser !== undefined)
            url_ += "IsPickableByUser=" + encodeURIComponent("" + isPickableByUser) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParticipationModeDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParticipationModeDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ParticipationModeDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParticipationModeDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PlannedEventServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<PlannedEventDto> {
        let url_ = this.baseUrl + "/api/services/app/PlannedEvent/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PlannedEventDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PlannedEventDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PlannedEventDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlannedEventDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdatePlannedEventDto | undefined): Observable<PlannedEventDto> {
        let url_ = this.baseUrl + "/api/services/app/PlannedEvent/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PlannedEventDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PlannedEventDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PlannedEventDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlannedEventDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    discard(body: Int64EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PlannedEvent/Discard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDiscard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDiscard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDiscard(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    subscribe(body: SubscribePlannedEventDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PlannedEvent/Subscribe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubscribe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubscribe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSubscribe(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    unsubscribe(body: Int64EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PlannedEvent/Unsubscribe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnsubscribe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnsubscribe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnsubscribe(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setNotificationRead(body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PlannedEvent/SetNotificationRead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetNotificationRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetNotificationRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetNotificationRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param isExpired (optional) 
     * @param includeDiscarded (optional) 
     * @param highlightEventId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(isExpired: boolean | undefined, includeDiscarded: boolean | undefined, highlightEventId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedPlannedEventResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PlannedEvent/GetAll?";
        if (isExpired === null)
            throw new Error("The parameter 'isExpired' cannot be null.");
        else if (isExpired !== undefined)
            url_ += "IsExpired=" + encodeURIComponent("" + isExpired) + "&";
        if (includeDiscarded === null)
            throw new Error("The parameter 'includeDiscarded' cannot be null.");
        else if (includeDiscarded !== undefined)
            url_ += "IncludeDiscarded=" + encodeURIComponent("" + includeDiscarded) + "&";
        if (highlightEventId === null)
            throw new Error("The parameter 'highlightEventId' cannot be null.");
        else if (highlightEventId !== undefined)
            url_ += "HighlightEventId=" + encodeURIComponent("" + highlightEventId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedPlannedEventResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedPlannedEventResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedPlannedEventResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedPlannedEventResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllPublic(): Observable<PlannedEventDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PlannedEvent/GetAllPublic";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPublic(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPublic(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PlannedEventDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PlannedEventDto[]>;
        }));
    }

    protected processGetAllPublic(response: HttpResponseBase): Observable<PlannedEventDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlannedEventDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param file (optional) 
     * @param plannedEventId (optional) 
     * @return Success
     */
    createGoogleMapsImage(file: FileParameter | undefined, plannedEventId: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/PlannedEvent/CreateGoogleMapsImage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (plannedEventId === null || plannedEventId === undefined)
            throw new Error("The parameter 'plannedEventId' cannot be null.");
        else
            content_.append("PlannedEventId", plannedEventId.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateGoogleMapsImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateGoogleMapsImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processCreateGoogleMapsImage(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PlannedEventUserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param plannedEventId (optional) 
     * @return Success
     */
    exportToExcel(plannedEventId: number | undefined): Observable<FileDownloadDto> {
        let url_ = this.baseUrl + "/api/services/app/PlannedEventUser/ExportToExcel?";
        if (plannedEventId === null)
            throw new Error("The parameter 'plannedEventId' cannot be null.");
        else if (plannedEventId !== undefined)
            url_ += "plannedEventId=" + encodeURIComponent("" + plannedEventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDownloadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDownloadDto>;
        }));
    }

    protected processExportToExcel(response: HttpResponseBase): Observable<FileDownloadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownloadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param plannedEventId (optional) 
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(plannedEventId: number | undefined, keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PlannedEventUserDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PlannedEventUser/GetAll?";
        if (plannedEventId === null)
            throw new Error("The parameter 'plannedEventId' cannot be null.");
        else if (plannedEventId !== undefined)
            url_ += "PlannedEventId=" + encodeURIComponent("" + plannedEventId) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PlannedEventUserDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PlannedEventUserDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PlannedEventUserDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlannedEventUserDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RoleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateRoleDto | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param permission (optional) 
     * @return Success
     */
    getRoles(permission: string | undefined): Observable<RoleListDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoles?";
        if (permission === null)
            throw new Error("The parameter 'permission' cannot be null.");
        else if (permission !== undefined)
            url_ += "Permission=" + encodeURIComponent("" + permission) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleListDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleListDtoListResultDto>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<RoleListDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleListDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: RoleDto | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllPermissions(): Observable<PermissionDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAllPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PermissionDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PermissionDtoListResultDto>;
        }));
    }

    protected processGetAllPermissions(response: HttpResponseBase): Observable<PermissionDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PermissionDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRoleForEdit(id: number | undefined): Observable<GetRoleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoleForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRoleForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRoleForEditOutput>;
        }));
    }

    protected processGetRoleForEdit(response: HttpResponseBase): Observable<GetRoleForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRoleForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<RoleDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<RoleDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SectorServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, maxResultCount: number | undefined): Observable<SectorDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Sector/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SectorDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SectorDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<SectorDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SectorDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<SectorDto> {
        let url_ = this.baseUrl + "/api/services/app/Sector/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SectorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SectorDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SectorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SectorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SessionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCurrentLoginInformations(): Observable<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentLoginInformations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentLoginInformations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCurrentLoginInformationsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCurrentLoginInformationsOutput>;
        }));
    }

    protected processGetCurrentLoginInformations(response: HttpResponseBase): Observable<GetCurrentLoginInformationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCurrentLoginInformationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SurveyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param staticCode (optional) 
     * @return Success
     */
    getSurveyByStaticCode(staticCode: string | undefined): Observable<SurveyDto> {
        let url_ = this.baseUrl + "/api/services/app/Survey/GetSurveyByStaticCode?";
        if (staticCode === null)
            throw new Error("The parameter 'staticCode' cannot be null.");
        else if (staticCode !== undefined)
            url_ += "staticCode=" + encodeURIComponent("" + staticCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSurveyByStaticCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyByStaticCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyDto>;
        }));
    }

    protected processGetSurveyByStaticCode(response: HttpResponseBase): Observable<SurveyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param staticCode (optional) 
     * @param trainingCourseId (optional) 
     * @return Success
     */
    getSurveyByStaticCodeAndTrainingCourseId(staticCode: string | undefined, trainingCourseId: number | undefined): Observable<SurveyDto> {
        let url_ = this.baseUrl + "/api/services/app/Survey/GetSurveyByStaticCodeAndTrainingCourseId?";
        if (staticCode === null)
            throw new Error("The parameter 'staticCode' cannot be null.");
        else if (staticCode !== undefined)
            url_ += "staticCode=" + encodeURIComponent("" + staticCode) + "&";
        if (trainingCourseId === null)
            throw new Error("The parameter 'trainingCourseId' cannot be null.");
        else if (trainingCourseId !== undefined)
            url_ += "trainingCourseId=" + encodeURIComponent("" + trainingCourseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSurveyByStaticCodeAndTrainingCourseId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyByStaticCodeAndTrainingCourseId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyDto>;
        }));
    }

    protected processGetSurveyByStaticCodeAndTrainingCourseId(response: HttpResponseBase): Observable<SurveyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<SurveyDto> {
        let url_ = this.baseUrl + "/api/services/app/Survey/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SurveyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param surveyId (optional) 
     * @return Success
     */
    getAllSections(surveyId: number | undefined): Observable<SurveySectionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Survey/GetAllSections?";
        if (surveyId === null)
            throw new Error("The parameter 'surveyId' cannot be null.");
        else if (surveyId !== undefined)
            url_ += "surveyId=" + encodeURIComponent("" + surveyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSections(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSections(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveySectionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveySectionDto[]>;
        }));
    }

    protected processGetAllSections(response: HttpResponseBase): Observable<SurveySectionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SurveySectionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sectionId (optional) 
     * @return Success
     */
    getAllQuestions(sectionId: number | undefined): Observable<SurveyQuestionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Survey/GetAllQuestions?";
        if (sectionId === null)
            throw new Error("The parameter 'sectionId' cannot be null.");
        else if (sectionId !== undefined)
            url_ += "sectionId=" + encodeURIComponent("" + sectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllQuestions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllQuestions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyQuestionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyQuestionDto[]>;
        }));
    }

    protected processGetAllQuestions(response: HttpResponseBase): Observable<SurveyQuestionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SurveyQuestionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SurveyCompilationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param compilationId (optional) 
     * @return Success
     */
    sendDigitalAssessmentResultEmail(compilationId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/SurveyCompilation/SendDigitalAssessmentResultEmail?";
        if (compilationId === null)
            throw new Error("The parameter 'compilationId' cannot be null.");
        else if (compilationId !== undefined)
            url_ += "compilationId=" + encodeURIComponent("" + compilationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendDigitalAssessmentResultEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendDigitalAssessmentResultEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSendDigitalAssessmentResultEmail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param compilationId (optional) 
     * @return Success
     */
    getSurveyCompilationFinalScore(compilationId: number | undefined): Observable<SurveyCompilationFinalScoreDto> {
        let url_ = this.baseUrl + "/api/services/app/SurveyCompilation/GetSurveyCompilationFinalScore?";
        if (compilationId === null)
            throw new Error("The parameter 'compilationId' cannot be null.");
        else if (compilationId !== undefined)
            url_ += "compilationId=" + encodeURIComponent("" + compilationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSurveyCompilationFinalScore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveyCompilationFinalScore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyCompilationFinalScoreDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyCompilationFinalScoreDto>;
        }));
    }

    protected processGetSurveyCompilationFinalScore(response: HttpResponseBase): Observable<SurveyCompilationFinalScoreDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyCompilationFinalScoreDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param surveyCompilationId (optional) 
     * @return Success
     */
    getAllSections(surveyCompilationId: number | undefined): Observable<SurveyCompilationSectionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SurveyCompilation/GetAllSections?";
        if (surveyCompilationId === null)
            throw new Error("The parameter 'surveyCompilationId' cannot be null.");
        else if (surveyCompilationId !== undefined)
            url_ += "surveyCompilationId=" + encodeURIComponent("" + surveyCompilationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSections(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSections(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyCompilationSectionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyCompilationSectionDto[]>;
        }));
    }

    protected processGetAllSections(response: HttpResponseBase): Observable<SurveyCompilationSectionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SurveyCompilationSectionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sectionId (optional) 
     * @return Success
     */
    getAllCompilationAnswers(compilationId: number, sectionId: number | undefined): Observable<SurveyAnswerDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SurveyCompilation/GetAllCompilationAnswers?";
        if (compilationId === undefined || compilationId === null)
            throw new Error("The parameter 'compilationId' must be defined and cannot be null.");
        else
            url_ += "CompilationId=" + encodeURIComponent("" + compilationId) + "&";
        if (sectionId === null)
            throw new Error("The parameter 'sectionId' cannot be null.");
        else if (sectionId !== undefined)
            url_ += "SectionId=" + encodeURIComponent("" + sectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCompilationAnswers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCompilationAnswers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyAnswerDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyAnswerDto[]>;
        }));
    }

    protected processGetAllCompilationAnswers(response: HttpResponseBase): Observable<SurveyAnswerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SurveyAnswerDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<CompanyBaseDtoBaseUserDtoSurveyCompilationDto> {
        let url_ = this.baseUrl + "/api/services/app/SurveyCompilation/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyBaseDtoBaseUserDtoSurveyCompilationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyBaseDtoBaseUserDtoSurveyCompilationDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CompanyBaseDtoBaseUserDtoSurveyCompilationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyBaseDtoBaseUserDtoSurveyCompilationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fiscalCode (optional) 
     * @return Success
     */
    getAllCompletedCompilations(fiscalCode: string | undefined): Observable<SurveyCompilationCompletedDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SurveyCompilation/GetAllCompletedCompilations?";
        if (fiscalCode === null)
            throw new Error("The parameter 'fiscalCode' cannot be null.");
        else if (fiscalCode !== undefined)
            url_ += "fiscalCode=" + encodeURIComponent("" + fiscalCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCompletedCompilations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCompletedCompilations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyCompilationCompletedDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyCompilationCompletedDto[]>;
        }));
    }

    protected processGetAllCompletedCompilations(response: HttpResponseBase): Observable<SurveyCompilationCompletedDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SurveyCompilationCompletedDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param compilationId (optional) 
     * @return Success
     */
    downloadDigitalAssessmentDocumentWord(compilationId: number | undefined): Observable<FileDownloadDto> {
        let url_ = this.baseUrl + "/api/services/app/SurveyCompilation/DownloadDigitalAssessmentDocumentWord?";
        if (compilationId === null)
            throw new Error("The parameter 'compilationId' cannot be null.");
        else if (compilationId !== undefined)
            url_ += "compilationId=" + encodeURIComponent("" + compilationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadDigitalAssessmentDocumentWord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadDigitalAssessmentDocumentWord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDownloadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDownloadDto>;
        }));
    }

    protected processDownloadDigitalAssessmentDocumentWord(response: HttpResponseBase): Observable<FileDownloadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownloadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    calculateLastCompilation(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/SurveyCompilation/CalculateLastCompilation";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateLastCompilation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateLastCompilation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCalculateLastCompilation(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param surveyId (optional) 
     * @return Success
     */
    canRepeatSurveyTrainingCourse(surveyId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/SurveyCompilation/CanRepeatSurveyTrainingCourse?";
        if (surveyId === null)
            throw new Error("The parameter 'surveyId' cannot be null.");
        else if (surveyId !== undefined)
            url_ += "surveyId=" + encodeURIComponent("" + surveyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCanRepeatSurveyTrainingCourse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCanRepeatSurveyTrainingCourse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCanRepeatSurveyTrainingCourse(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param compilationId (optional) 
     * @return Success
     */
    getCertificationCompletedCompilationTrainingCourse(compilationId: number | undefined): Observable<SurveyCompilationCertficationTrainingCourseDto> {
        let url_ = this.baseUrl + "/api/services/app/SurveyCompilation/GetCertificationCompletedCompilationTrainingCourse?";
        if (compilationId === null)
            throw new Error("The parameter 'compilationId' cannot be null.");
        else if (compilationId !== undefined)
            url_ += "compilationId=" + encodeURIComponent("" + compilationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCertificationCompletedCompilationTrainingCourse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCertificationCompletedCompilationTrainingCourse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyCompilationCertficationTrainingCourseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyCompilationCertficationTrainingCourseDto>;
        }));
    }

    protected processGetCertificationCompletedCompilationTrainingCourse(response: HttpResponseBase): Observable<SurveyCompilationCertficationTrainingCourseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SurveyCompilationCertficationTrainingCourseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param emailAddress (optional) 
     * @param businessName (optional) 
     * @param completionTime (optional) 
     * @param fiscalCode (optional) 
     * @param isCompleted (optional) 
     * @param staticCode (optional) 
     * @param surveyId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(emailAddress: string | undefined, businessName: string | undefined, completionTime: moment.Moment | undefined, fiscalCode: string | undefined, isCompleted: boolean | undefined, staticCode: string | undefined, surveyId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CompanyBaseDtoBaseUserDtoSurveyCompilationDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/SurveyCompilation/GetAll?";
        if (emailAddress === null)
            throw new Error("The parameter 'emailAddress' cannot be null.");
        else if (emailAddress !== undefined)
            url_ += "EmailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        if (businessName === null)
            throw new Error("The parameter 'businessName' cannot be null.");
        else if (businessName !== undefined)
            url_ += "BusinessName=" + encodeURIComponent("" + businessName) + "&";
        if (completionTime === null)
            throw new Error("The parameter 'completionTime' cannot be null.");
        else if (completionTime !== undefined)
            url_ += "CompletionTime=" + encodeURIComponent(completionTime ? "" + completionTime.toISOString() : "") + "&";
        if (fiscalCode === null)
            throw new Error("The parameter 'fiscalCode' cannot be null.");
        else if (fiscalCode !== undefined)
            url_ += "FiscalCode=" + encodeURIComponent("" + fiscalCode) + "&";
        if (isCompleted === null)
            throw new Error("The parameter 'isCompleted' cannot be null.");
        else if (isCompleted !== undefined)
            url_ += "IsCompleted=" + encodeURIComponent("" + isCompleted) + "&";
        if (staticCode === null)
            throw new Error("The parameter 'staticCode' cannot be null.");
        else if (staticCode !== undefined)
            url_ += "StaticCode=" + encodeURIComponent("" + staticCode) + "&";
        if (surveyId === null)
            throw new Error("The parameter 'surveyId' cannot be null.");
        else if (surveyId !== undefined)
            url_ += "SurveyId=" + encodeURIComponent("" + surveyId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyBaseDtoBaseUserDtoSurveyCompilationDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyBaseDtoBaseUserDtoSurveyCompilationDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CompanyBaseDtoBaseUserDtoSurveyCompilationDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyBaseDtoBaseUserDtoSurveyCompilationDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateCompilationInput | undefined): Observable<CompanyBaseDtoBaseUserDtoSurveyCompilationDto> {
        let url_ = this.baseUrl + "/api/services/app/SurveyCompilation/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyBaseDtoBaseUserDtoSurveyCompilationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyBaseDtoBaseUserDtoSurveyCompilationDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CompanyBaseDtoBaseUserDtoSurveyCompilationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyBaseDtoBaseUserDtoSurveyCompilationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveSelectedAnswers(body: SaveSelectedAnswersInput | undefined): Observable<SaveSelectedAnswersResultDto> {
        let url_ = this.baseUrl + "/api/services/app/SurveyCompilation/SaveSelectedAnswers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveSelectedAnswers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveSelectedAnswers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SaveSelectedAnswersResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SaveSelectedAnswersResultDto>;
        }));
    }

    protected processSaveSelectedAnswers(response: HttpResponseBase): Observable<SaveSelectedAnswersResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveSelectedAnswersResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param surveyCompilationId (optional) 
     * @return Success
     */
    finalizeSurvey(surveyCompilationId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SurveyCompilation/FinalizeSurvey?";
        if (surveyCompilationId === null)
            throw new Error("The parameter 'surveyCompilationId' cannot be null.");
        else if (surveyCompilationId !== undefined)
            url_ += "surveyCompilationId=" + encodeURIComponent("" + surveyCompilationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinalizeSurvey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinalizeSurvey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFinalizeSurvey(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TenantServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateTenantDto | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, isActive: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<TenantDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TenantDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: TenantDto | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TestEmailServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param emailAddress (optional) 
     * @return Success
     */
    sendMails(emailAddress: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TestEmail/sendMails?";
        if (emailAddress === null)
            throw new Error("The parameter 'emailAddress' cannot be null.");
        else if (emailAddress !== undefined)
            url_ += "emailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendMails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendMails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendMails(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TokenAuthServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    authenticate(body: AuthenticateModel | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthenticateResultModel>;
        }));
    }

    protected processAuthenticate(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getExternalAuthenticationProviders(): Observable<ExternalLoginProviderInfoModel[]> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetExternalAuthenticationProviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalAuthenticationProviders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalAuthenticationProviders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalLoginProviderInfoModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalLoginProviderInfoModel[]>;
        }));
    }

    protected processGetExternalAuthenticationProviders(response: HttpResponseBase): Observable<ExternalLoginProviderInfoModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExternalLoginProviderInfoModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    externalAuthenticate(body: ExternalAuthenticateModel | undefined): Observable<ExternalAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ExternalAuthenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExternalAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalAuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalAuthenticateResultModel>;
        }));
    }

    protected processExternalAuthenticate(response: HttpResponseBase): Observable<ExternalAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TrainingCourseServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTrainingCourse(id: number | undefined): Observable<TrainingCourseDto> {
        let url_ = this.baseUrl + "/api/services/app/TrainingCourse/GetTrainingCourse?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTrainingCourse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTrainingCourse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrainingCourseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrainingCourseDto>;
        }));
    }

    protected processGetTrainingCourse(response: HttpResponseBase): Observable<TrainingCourseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrainingCourseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateTrainingCourseDto | undefined): Observable<TrainingCourseBaseDto> {
        let url_ = this.baseUrl + "/api/services/app/TrainingCourse/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrainingCourseBaseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrainingCourseBaseDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TrainingCourseBaseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrainingCourseBaseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateTrainingCourseDto | undefined): Observable<TrainingCourseBaseDto> {
        let url_ = this.baseUrl + "/api/services/app/TrainingCourse/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrainingCourseBaseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrainingCourseBaseDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<TrainingCourseBaseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrainingCourseBaseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param file (optional) 
     * @param trainingCourseId (optional) 
     * @return Success
     */
    uploadTrainingCourseThumbnail(file: FileParameter | undefined, trainingCourseId: number | undefined): Observable<TrainingCourseDto> {
        let url_ = this.baseUrl + "/api/services/app/TrainingCourse/UploadTrainingCourseThumbnail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (trainingCourseId === null || trainingCourseId === undefined)
            throw new Error("The parameter 'trainingCourseId' cannot be null.");
        else
            content_.append("TrainingCourseId", trainingCourseId.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadTrainingCourseThumbnail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadTrainingCourseThumbnail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrainingCourseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrainingCourseDto>;
        }));
    }

    protected processUploadTrainingCourseThumbnail(response: HttpResponseBase): Observable<TrainingCourseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrainingCourseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param file (optional) 
     * @param trainingCourseId (optional) 
     * @return Success
     */
    uploadTrainingCourseImage(file: FileParameter | undefined, trainingCourseId: number | undefined): Observable<TrainingCourseDto> {
        let url_ = this.baseUrl + "/api/services/app/TrainingCourse/UploadTrainingCourseImage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (trainingCourseId === null || trainingCourseId === undefined)
            throw new Error("The parameter 'trainingCourseId' cannot be null.");
        else
            content_.append("TrainingCourseId", trainingCourseId.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadTrainingCourseImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadTrainingCourseImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrainingCourseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrainingCourseDto>;
        }));
    }

    protected processUploadTrainingCourseImage(response: HttpResponseBase): Observable<TrainingCourseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrainingCourseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param trainingCourseId (optional) 
     * @param thumbId (optional) 
     * @return Success
     */
    deleteTrainingCourseThumbnail(trainingCourseId: number | undefined, thumbId: number | undefined): Observable<TrainingCourseDto> {
        let url_ = this.baseUrl + "/api/services/app/TrainingCourse/DeleteTrainingCourseThumbnail?";
        if (trainingCourseId === null)
            throw new Error("The parameter 'trainingCourseId' cannot be null.");
        else if (trainingCourseId !== undefined)
            url_ += "trainingCourseId=" + encodeURIComponent("" + trainingCourseId) + "&";
        if (thumbId === null)
            throw new Error("The parameter 'thumbId' cannot be null.");
        else if (thumbId !== undefined)
            url_ += "thumbId=" + encodeURIComponent("" + thumbId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTrainingCourseThumbnail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTrainingCourseThumbnail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrainingCourseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrainingCourseDto>;
        }));
    }

    protected processDeleteTrainingCourseThumbnail(response: HttpResponseBase): Observable<TrainingCourseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrainingCourseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param trainingCourseId (optional) 
     * @param imageId (optional) 
     * @return Success
     */
    deleteTrainingCourseImage(trainingCourseId: number | undefined, imageId: number | undefined): Observable<TrainingCourseDto> {
        let url_ = this.baseUrl + "/api/services/app/TrainingCourse/DeleteTrainingCourseImage?";
        if (trainingCourseId === null)
            throw new Error("The parameter 'trainingCourseId' cannot be null.");
        else if (trainingCourseId !== undefined)
            url_ += "trainingCourseId=" + encodeURIComponent("" + trainingCourseId) + "&";
        if (imageId === null)
            throw new Error("The parameter 'imageId' cannot be null.");
        else if (imageId !== undefined)
            url_ += "imageId=" + encodeURIComponent("" + imageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTrainingCourseImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTrainingCourseImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrainingCourseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrainingCourseDto>;
        }));
    }

    protected processDeleteTrainingCourseImage(response: HttpResponseBase): Observable<TrainingCourseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrainingCourseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param trainingCourseId (optional) 
     * @return Success
     */
    canTrainingCourseBePublished(trainingCourseId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TrainingCourse/CanTrainingCourseBePublished?";
        if (trainingCourseId === null)
            throw new Error("The parameter 'trainingCourseId' cannot be null.");
        else if (trainingCourseId !== undefined)
            url_ += "trainingCourseId=" + encodeURIComponent("" + trainingCourseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCanTrainingCourseBePublished(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCanTrainingCourseBePublished(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCanTrainingCourseBePublished(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllTrainingCourseUser(): Observable<TrainingCourseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TrainingCourse/GetAllTrainingCourseUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTrainingCourseUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTrainingCourseUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrainingCourseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrainingCourseDto[]>;
        }));
    }

    protected processGetAllTrainingCourseUser(response: HttpResponseBase): Observable<TrainingCourseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TrainingCourseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<TrainingCourseBaseDto> {
        let url_ = this.baseUrl + "/api/services/app/TrainingCourse/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrainingCourseBaseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrainingCourseBaseDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TrainingCourseBaseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrainingCourseBaseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param topicIds (optional) 
     * @param contentTypeIds (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, topicIds: number[] | undefined, contentTypeIds: number[] | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<TrainingCourseBaseDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/TrainingCourse/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (topicIds === null)
            throw new Error("The parameter 'topicIds' cannot be null.");
        else if (topicIds !== undefined)
            topicIds && topicIds.forEach(item => { url_ += "TopicIds=" + encodeURIComponent("" + item) + "&"; });
        if (contentTypeIds === null)
            throw new Error("The parameter 'contentTypeIds' cannot be null.");
        else if (contentTypeIds !== undefined)
            contentTypeIds && contentTypeIds.forEach(item => { url_ += "ContentTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrainingCourseBaseDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrainingCourseBaseDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TrainingCourseBaseDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrainingCourseBaseDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TrainingCourse/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TrainingCourseContentTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, maxResultCount: number | undefined): Observable<TrainingCourseContentTypeDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/TrainingCourseContentType/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrainingCourseContentTypeDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrainingCourseContentTypeDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TrainingCourseContentTypeDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrainingCourseContentTypeDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<TrainingCourseContentTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/TrainingCourseContentType/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrainingCourseContentTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrainingCourseContentTypeDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TrainingCourseContentTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrainingCourseContentTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TrainingCourseLessonServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<TrainingCourseLessonDto> {
        let url_ = this.baseUrl + "/api/services/app/TrainingCourseLesson/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrainingCourseLessonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrainingCourseLessonDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TrainingCourseLessonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrainingCourseLessonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param userId (optional) 
     * @return Success
     */
    setCompleted(id: number | undefined, userId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TrainingCourseLesson/SetCompleted?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetCompleted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetCompleted(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetCompleted(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateTrainingCourseLessonDto | undefined): Observable<TrainingCourseLessonBaseDto> {
        let url_ = this.baseUrl + "/api/services/app/TrainingCourseLesson/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrainingCourseLessonBaseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrainingCourseLessonBaseDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TrainingCourseLessonBaseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrainingCourseLessonBaseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateTrainingCourseLessonDto | undefined): Observable<TrainingCourseLessonDto> {
        let url_ = this.baseUrl + "/api/services/app/TrainingCourseLesson/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrainingCourseLessonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrainingCourseLessonDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<TrainingCourseLessonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrainingCourseLessonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param videoDurationInSeconds (optional) 
     * @param file (optional) 
     * @param id (optional) 
     * @return Success
     */
    uploadVideo(videoDurationInSeconds: number | undefined, file: FileParameter | undefined, id: number | undefined): Observable<TrainingCourseLessonDto> {
        let url_ = this.baseUrl + "/api/services/app/TrainingCourseLesson/UploadVideo?";
        if (videoDurationInSeconds === null)
            throw new Error("The parameter 'videoDurationInSeconds' cannot be null.");
        else if (videoDurationInSeconds !== undefined)
            url_ += "VideoDurationInSeconds=" + encodeURIComponent("" + videoDurationInSeconds) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (id === null || id === undefined)
            throw new Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadVideo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadVideo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrainingCourseLessonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrainingCourseLessonDto>;
        }));
    }

    protected processUploadVideo(response: HttpResponseBase): Observable<TrainingCourseLessonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrainingCourseLessonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param file (optional) 
     * @param trainingCourseLessonId (optional) 
     * @return Success
     */
    uploadThumbnail(file: FileParameter | undefined, trainingCourseLessonId: number | undefined): Observable<TrainingCourseLessonDto> {
        let url_ = this.baseUrl + "/api/services/app/TrainingCourseLesson/UploadThumbnail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (trainingCourseLessonId === null || trainingCourseLessonId === undefined)
            throw new Error("The parameter 'trainingCourseLessonId' cannot be null.");
        else
            content_.append("TrainingCourseLessonId", trainingCourseLessonId.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadThumbnail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadThumbnail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrainingCourseLessonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrainingCourseLessonDto>;
        }));
    }

    protected processUploadThumbnail(response: HttpResponseBase): Observable<TrainingCourseLessonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrainingCourseLessonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param trainingCourseLessonId (optional) 
     * @param thumbId (optional) 
     * @return Success
     */
    deleteTrainingCourseLessonThumbnail(trainingCourseLessonId: number | undefined, thumbId: number | undefined): Observable<TrainingCourseLessonDto> {
        let url_ = this.baseUrl + "/api/services/app/TrainingCourseLesson/DeleteTrainingCourseLessonThumbnail?";
        if (trainingCourseLessonId === null)
            throw new Error("The parameter 'trainingCourseLessonId' cannot be null.");
        else if (trainingCourseLessonId !== undefined)
            url_ += "trainingCourseLessonId=" + encodeURIComponent("" + trainingCourseLessonId) + "&";
        if (thumbId === null)
            throw new Error("The parameter 'thumbId' cannot be null.");
        else if (thumbId !== undefined)
            url_ += "thumbId=" + encodeURIComponent("" + thumbId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTrainingCourseLessonThumbnail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTrainingCourseLessonThumbnail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrainingCourseLessonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrainingCourseLessonDto>;
        }));
    }

    protected processDeleteTrainingCourseLessonThumbnail(response: HttpResponseBase): Observable<TrainingCourseLessonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrainingCourseLessonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param trainingCourseLessonId (optional) 
     * @param videoId (optional) 
     * @return Success
     */
    deleteTrainingCourseLessonVideo(trainingCourseLessonId: number | undefined, videoId: number | undefined): Observable<TrainingCourseLessonDto> {
        let url_ = this.baseUrl + "/api/services/app/TrainingCourseLesson/DeleteTrainingCourseLessonVideo?";
        if (trainingCourseLessonId === null)
            throw new Error("The parameter 'trainingCourseLessonId' cannot be null.");
        else if (trainingCourseLessonId !== undefined)
            url_ += "trainingCourseLessonId=" + encodeURIComponent("" + trainingCourseLessonId) + "&";
        if (videoId === null)
            throw new Error("The parameter 'videoId' cannot be null.");
        else if (videoId !== undefined)
            url_ += "videoId=" + encodeURIComponent("" + videoId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTrainingCourseLessonVideo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTrainingCourseLessonVideo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrainingCourseLessonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrainingCourseLessonDto>;
        }));
    }

    protected processDeleteTrainingCourseLessonVideo(response: HttpResponseBase): Observable<TrainingCourseLessonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrainingCourseLessonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param file (optional) 
     * @param trainingCourseLessonId (optional) 
     * @return Success
     */
    uploadLessonFile(file: FileParameter | undefined, trainingCourseLessonId: number | undefined): Observable<TrainingCourseLessonFileDto> {
        let url_ = this.baseUrl + "/api/services/app/TrainingCourseLesson/UploadLessonFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (trainingCourseLessonId === null || trainingCourseLessonId === undefined)
            throw new Error("The parameter 'trainingCourseLessonId' cannot be null.");
        else
            content_.append("TrainingCourseLessonId", trainingCourseLessonId.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadLessonFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadLessonFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrainingCourseLessonFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrainingCourseLessonFileDto>;
        }));
    }

    protected processUploadLessonFile(response: HttpResponseBase): Observable<TrainingCourseLessonFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrainingCourseLessonFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param attachId (optional) 
     * @param fileId (optional) 
     * @return Success
     */
    deleteLessonFile(attachId: number | undefined, fileId: number | undefined): Observable<TrainingCourseLessonDto> {
        let url_ = this.baseUrl + "/api/services/app/TrainingCourseLesson/DeleteLessonFile?";
        if (attachId === null)
            throw new Error("The parameter 'attachId' cannot be null.");
        else if (attachId !== undefined)
            url_ += "attachId=" + encodeURIComponent("" + attachId) + "&";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLessonFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLessonFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrainingCourseLessonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrainingCourseLessonDto>;
        }));
    }

    protected processDeleteLessonFile(response: HttpResponseBase): Observable<TrainingCourseLessonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrainingCourseLessonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param courseId (optional) 
     * @return Success
     */
    trainingCourseLessonKeepWatching(courseId: number | undefined): Observable<TrainingCourseLessonDto> {
        let url_ = this.baseUrl + "/api/services/app/TrainingCourseLesson/TrainingCourseLessonKeepWatching?";
        if (courseId === null)
            throw new Error("The parameter 'courseId' cannot be null.");
        else if (courseId !== undefined)
            url_ += "courseId=" + encodeURIComponent("" + courseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTrainingCourseLessonKeepWatching(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTrainingCourseLessonKeepWatching(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrainingCourseLessonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrainingCourseLessonDto>;
        }));
    }

    protected processTrainingCourseLessonKeepWatching(response: HttpResponseBase): Observable<TrainingCourseLessonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrainingCourseLessonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<TrainingCourseLessonDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/TrainingCourseLesson/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrainingCourseLessonDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrainingCourseLessonDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TrainingCourseLessonDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrainingCourseLessonDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TrainingCourseLessonChapterServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param lessonId (optional) 
     * @return Success
     */
    getAllByLessonId(lessonId: number | undefined): Observable<TrainingCourseLessonChapterDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TrainingCourseLessonChapter/GetAllByLessonId?";
        if (lessonId === null)
            throw new Error("The parameter 'lessonId' cannot be null.");
        else if (lessonId !== undefined)
            url_ += "lessonId=" + encodeURIComponent("" + lessonId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByLessonId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByLessonId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrainingCourseLessonChapterDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrainingCourseLessonChapterDto[]>;
        }));
    }

    protected processGetAllByLessonId(response: HttpResponseBase): Observable<TrainingCourseLessonChapterDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TrainingCourseLessonChapterDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateTrainingCourseLessonChapterDto | undefined): Observable<TrainingCourseLessonChapterDto> {
        let url_ = this.baseUrl + "/api/services/app/TrainingCourseLessonChapter/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrainingCourseLessonChapterDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrainingCourseLessonChapterDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TrainingCourseLessonChapterDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrainingCourseLessonChapterDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TrainingCourseLessonChapter/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateTrainingCourseLessonChapterDto | undefined): Observable<TrainingCourseLessonChapterDto> {
        let url_ = this.baseUrl + "/api/services/app/TrainingCourseLessonChapter/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrainingCourseLessonChapterDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrainingCourseLessonChapterDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<TrainingCourseLessonChapterDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrainingCourseLessonChapterDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param trainingCourseLessonId (optional) 
     * @return Success
     */
    deleteAll(trainingCourseLessonId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TrainingCourseLessonChapter/DeleteAll?";
        if (trainingCourseLessonId === null)
            throw new Error("The parameter 'trainingCourseLessonId' cannot be null.");
        else if (trainingCourseLessonId !== undefined)
            url_ += "trainingCourseLessonId=" + encodeURIComponent("" + trainingCourseLessonId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAll(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<TrainingCourseLessonChapterDto> {
        let url_ = this.baseUrl + "/api/services/app/TrainingCourseLessonChapter/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrainingCourseLessonChapterDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrainingCourseLessonChapterDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TrainingCourseLessonChapterDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrainingCourseLessonChapterDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<TrainingCourseLessonChapterDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/TrainingCourseLessonChapter/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrainingCourseLessonChapterDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrainingCourseLessonChapterDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TrainingCourseLessonChapterDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrainingCourseLessonChapterDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TrainingCourseLessonUserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param lessonId (optional) 
     * @param secondsViewed (optional) 
     * @return Success
     */
    saveSecondsVideoViewed(lessonId: number | undefined, secondsViewed: number | undefined): Observable<TrainingCourseLessonUserDto> {
        let url_ = this.baseUrl + "/api/services/app/TrainingCourseLessonUser/SaveSecondsVideoViewed?";
        if (lessonId === null)
            throw new Error("The parameter 'lessonId' cannot be null.");
        else if (lessonId !== undefined)
            url_ += "lessonId=" + encodeURIComponent("" + lessonId) + "&";
        if (secondsViewed === null)
            throw new Error("The parameter 'secondsViewed' cannot be null.");
        else if (secondsViewed !== undefined)
            url_ += "secondsViewed=" + encodeURIComponent("" + secondsViewed) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveSecondsVideoViewed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveSecondsVideoViewed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrainingCourseLessonUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrainingCourseLessonUserDto>;
        }));
    }

    protected processSaveSecondsVideoViewed(response: HttpResponseBase): Observable<TrainingCourseLessonUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrainingCourseLessonUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param lessonId (optional) 
     * @param userId (optional) 
     * @return Success
     */
    get(lessonId: number | undefined, userId: number | undefined): Observable<TrainingCourseLessonUserDto> {
        let url_ = this.baseUrl + "/api/services/app/TrainingCourseLessonUser/Get?";
        if (lessonId === null)
            throw new Error("The parameter 'lessonId' cannot be null.");
        else if (lessonId !== undefined)
            url_ += "lessonId=" + encodeURIComponent("" + lessonId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrainingCourseLessonUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrainingCourseLessonUserDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TrainingCourseLessonUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrainingCourseLessonUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param lessonId (optional) 
     * @return Success
     */
    calculateSecondsViewesPercantage(lessonId: number | undefined): Observable<TrainingCourseLessonUserDto> {
        let url_ = this.baseUrl + "/api/services/app/TrainingCourseLessonUser/CalculateSecondsViewesPercantage?";
        if (lessonId === null)
            throw new Error("The parameter 'lessonId' cannot be null.");
        else if (lessonId !== undefined)
            url_ += "lessonId=" + encodeURIComponent("" + lessonId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateSecondsViewesPercantage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateSecondsViewesPercantage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrainingCourseLessonUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrainingCourseLessonUserDto>;
        }));
    }

    protected processCalculateSecondsViewesPercantage(response: HttpResponseBase): Observable<TrainingCourseLessonUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrainingCourseLessonUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param courseId (optional) 
     * @return Success
     */
    canUserCompileSurveyTrainingCourse(courseId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/TrainingCourseLessonUser/CanUserCompileSurveyTrainingCourse?";
        if (courseId === null)
            throw new Error("The parameter 'courseId' cannot be null.");
        else if (courseId !== undefined)
            url_ += "courseId=" + encodeURIComponent("" + courseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCanUserCompileSurveyTrainingCourse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCanUserCompileSurveyTrainingCourse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCanUserCompileSurveyTrainingCourse(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<TrainingCourseLessonUserDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/TrainingCourseLessonUser/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrainingCourseLessonUserDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrainingCourseLessonUserDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TrainingCourseLessonUserDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrainingCourseLessonUserDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TrainingCourseTopicServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllAvailableForLoggedUser(): Observable<TrainingCourseTopicDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TrainingCourseTopic/GetAllAvailableForLoggedUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAvailableForLoggedUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAvailableForLoggedUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrainingCourseTopicDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrainingCourseTopicDto[]>;
        }));
    }

    protected processGetAllAvailableForLoggedUser(response: HttpResponseBase): Observable<TrainingCourseTopicDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TrainingCourseTopicDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllByLastCourseCreated(): Observable<TrainingCourseTopicDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TrainingCourseTopic/GetAllByLastCourseCreated";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByLastCourseCreated(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByLastCourseCreated(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrainingCourseTopicDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrainingCourseTopicDto[]>;
        }));
    }

    protected processGetAllByLastCourseCreated(response: HttpResponseBase): Observable<TrainingCourseTopicDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TrainingCourseTopicDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, maxResultCount: number | undefined): Observable<TrainingCourseTopicDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/TrainingCourseTopic/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrainingCourseTopicDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrainingCourseTopicDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TrainingCourseTopicDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrainingCourseTopicDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<TrainingCourseTopicDto> {
        let url_ = this.baseUrl + "/api/services/app/TrainingCourseTopic/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrainingCourseTopicDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrainingCourseTopicDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TrainingCourseTopicDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrainingCourseTopicDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMyProfile(): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetMyProfile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processGetMyProfile(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateUserDto | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateUserDto | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    restore(userId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/Restore?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRestore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRestore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRestore(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    activate(userId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/Activate?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    deactivate(userId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/Deactivate?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeactivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    unlockLogin(userId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UnlockLogin?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlockLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlockLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnlockLogin(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeLanguage(body: ChangeUserLanguageDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangeLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    changeUserPreferenceSection(input: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangeUserPreferenceSection?";
        if (input === null)
            throw new Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeUserPreferenceSection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeUserPreferenceSection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeUserPreferenceSection(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePassword(body: ChangePasswordDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    forceResetPassword(body: ForceResetPasswordDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ForceResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForceResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForceResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processForceResetPassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param collaboratorId (optional) 
     * @return Success
     */
    giveMasterUserRole(userId: number | undefined, collaboratorId: number | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GiveMasterUserRole?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (collaboratorId === null)
            throw new Error("The parameter 'collaboratorId' cannot be null.");
        else if (collaboratorId !== undefined)
            url_ += "collaboratorId=" + encodeURIComponent("" + collaboratorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGiveMasterUserRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGiveMasterUserRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processGiveMasterUserRole(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param isNewsletterActivated (optional) 
     * @param isMasterUser (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, isActive: boolean | undefined, isNewsletterActivated: boolean | undefined, isMasterUser: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<UserDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (isNewsletterActivated === null)
            throw new Error("The parameter 'isNewsletterActivated' cannot be null.");
        else if (isNewsletterActivated !== undefined)
            url_ += "IsNewsletterActivated=" + encodeURIComponent("" + isNewsletterActivated) + "&";
        if (isMasterUser === null)
            throw new Error("The parameter 'isMasterUser' cannot be null.");
        else if (isMasterUser !== undefined)
            url_ += "IsMasterUser=" + encodeURIComponent("" + isMasterUser) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserInvitationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<UserInvitationDto> {
        let url_ = this.baseUrl + "/api/services/app/UserInvitation/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserInvitationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserInvitationDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserInvitationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInvitationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param publicMask (optional) 
     * @return Success
     */
    getByPublicMask(publicMask: string | undefined): Observable<UserInvitationDto> {
        let url_ = this.baseUrl + "/api/services/app/UserInvitation/GetByPublicMask?";
        if (publicMask === null)
            throw new Error("The parameter 'publicMask' cannot be null.");
        else if (publicMask !== undefined)
            url_ += "publicMask=" + encodeURIComponent("" + publicMask) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByPublicMask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByPublicMask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserInvitationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserInvitationDto>;
        }));
    }

    protected processGetByPublicMask(response: HttpResponseBase): Observable<UserInvitationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInvitationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createMultiple(body: CreateMultipleInvitationInput | undefined): Observable<UserInvitationsResultDto> {
        let url_ = this.baseUrl + "/api/services/app/UserInvitation/CreateMultiple";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMultiple(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMultiple(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserInvitationsResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserInvitationsResultDto>;
        }));
    }

    protected processCreateMultiple(response: HttpResponseBase): Observable<UserInvitationsResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInvitationsResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param batchId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(companyId: number | undefined, batchId: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<UserInvitationDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/UserInvitation/GetAll?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (batchId === null)
            throw new Error("The parameter 'batchId' cannot be null.");
        else if (batchId !== undefined)
            url_ += "BatchId=" + encodeURIComponent("" + batchId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserInvitationDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserInvitationDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserInvitationDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInvitationDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserPreferenceContractServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getAllPreferences(userId: number | undefined): Observable<UserPreferenceContractDto> {
        let url_ = this.baseUrl + "/api/services/app/UserPreferenceContract/GetAllPreferences?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPreferences(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPreferences(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserPreferenceContractDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserPreferenceContractDto>;
        }));
    }

    protected processGetAllPreferences(response: HttpResponseBase): Observable<UserPreferenceContractDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserPreferenceContractDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getAllInfocicaApplicationsByUser(userId: number | undefined): Observable<InfocicaApplicationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/UserPreferenceContract/GetAllInfocicaApplicationsByUser?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllInfocicaApplicationsByUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllInfocicaApplicationsByUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InfocicaApplicationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InfocicaApplicationDto[]>;
        }));
    }

    protected processGetAllInfocicaApplicationsByUser(response: HttpResponseBase): Observable<InfocicaApplicationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InfocicaApplicationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getAllInfocicaBeneficiariesByUser(userId: number | undefined): Observable<InfocicaBeneficiaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/UserPreferenceContract/GetAllInfocicaBeneficiariesByUser?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllInfocicaBeneficiariesByUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllInfocicaBeneficiariesByUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InfocicaBeneficiaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InfocicaBeneficiaryDto[]>;
        }));
    }

    protected processGetAllInfocicaBeneficiariesByUser(response: HttpResponseBase): Observable<InfocicaBeneficiaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InfocicaBeneficiaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getAllInfocicaFacilitationsByUser(userId: number | undefined): Observable<InfocicaFacilitationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/UserPreferenceContract/GetAllInfocicaFacilitationsByUser?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllInfocicaFacilitationsByUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllInfocicaFacilitationsByUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InfocicaFacilitationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InfocicaFacilitationDto[]>;
        }));
    }

    protected processGetAllInfocicaFacilitationsByUser(response: HttpResponseBase): Observable<InfocicaFacilitationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InfocicaFacilitationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getAllInfocicaRegionsByUser(userId: number | undefined): Observable<InfocicaRegionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/UserPreferenceContract/GetAllInfocicaRegionsByUser?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllInfocicaRegionsByUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllInfocicaRegionsByUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InfocicaRegionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InfocicaRegionDto[]>;
        }));
    }

    protected processGetAllInfocicaRegionsByUser(response: HttpResponseBase): Observable<InfocicaRegionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InfocicaRegionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getAllInfocicaEligibleExpenditureByUser(userId: number | undefined): Observable<InfocicaEligibleExpenditureDto[]> {
        let url_ = this.baseUrl + "/api/services/app/UserPreferenceContract/GetAllInfocicaEligibleExpenditureByUser?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllInfocicaEligibleExpenditureByUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllInfocicaEligibleExpenditureByUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InfocicaEligibleExpenditureDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InfocicaEligibleExpenditureDto[]>;
        }));
    }

    protected processGetAllInfocicaEligibleExpenditureByUser(response: HttpResponseBase): Observable<InfocicaEligibleExpenditureDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InfocicaEligibleExpenditureDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateFilters(body: UpdateUserPreferenceContractDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserPreferenceContract/UpdateFilters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFilters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFilters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateFilters(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserPreferenceTrainingCourseServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getAllPreferences(userId: number | undefined): Observable<UserPreferenceTrainigCourseDto> {
        let url_ = this.baseUrl + "/api/services/app/UserPreferenceTrainingCourse/GetAllPreferences?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPreferences(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPreferences(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserPreferenceTrainigCourseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserPreferenceTrainigCourseDto>;
        }));
    }

    protected processGetAllPreferences(response: HttpResponseBase): Observable<UserPreferenceTrainigCourseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserPreferenceTrainigCourseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getAllTrainingCourseTopicByUser(userId: number | undefined): Observable<TrainingCourseTopicDto[]> {
        let url_ = this.baseUrl + "/api/services/app/UserPreferenceTrainingCourse/GetAllTrainingCourseTopicByUser?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTrainingCourseTopicByUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTrainingCourseTopicByUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrainingCourseTopicDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrainingCourseTopicDto[]>;
        }));
    }

    protected processGetAllTrainingCourseTopicByUser(response: HttpResponseBase): Observable<TrainingCourseTopicDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TrainingCourseTopicDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getAllTrainingCourseContentTypeByUser(userId: number | undefined): Observable<TrainingCourseContentTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/UserPreferenceTrainingCourse/GetAllTrainingCourseContentTypeByUser?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTrainingCourseContentTypeByUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTrainingCourseContentTypeByUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TrainingCourseContentTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TrainingCourseContentTypeDto[]>;
        }));
    }

    protected processGetAllTrainingCourseContentTypeByUser(response: HttpResponseBase): Observable<TrainingCourseContentTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TrainingCourseContentTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateFilters(body: UpdateUserPreferenceTrainingCourseDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserPreferenceTrainingCourse/UpdateFilters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFilters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFilters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateFilters(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserSavedContractServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param contractId (optional) 
     * @return Success
     */
    addUserSavedContract(contractId: number | undefined): Observable<UserSavedContractDto> {
        let url_ = this.baseUrl + "/api/services/app/UserSavedContract/AddUserSavedContract?";
        if (contractId === null)
            throw new Error("The parameter 'contractId' cannot be null.");
        else if (contractId !== undefined)
            url_ += "contractId=" + encodeURIComponent("" + contractId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUserSavedContract(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUserSavedContract(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserSavedContractDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserSavedContractDto>;
        }));
    }

    protected processAddUserSavedContract(response: HttpResponseBase): Observable<UserSavedContractDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserSavedContractDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param contractId (optional) 
     * @return Success
     */
    removeUserSavedContract(contractId: number | undefined): Observable<UserSavedContractDto> {
        let url_ = this.baseUrl + "/api/services/app/UserSavedContract/RemoveUserSavedContract?";
        if (contractId === null)
            throw new Error("The parameter 'contractId' cannot be null.");
        else if (contractId !== undefined)
            url_ += "contractId=" + encodeURIComponent("" + contractId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveUserSavedContract(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveUserSavedContract(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserSavedContractDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserSavedContractDto>;
        }));
    }

    protected processRemoveUserSavedContract(response: HttpResponseBase): Observable<UserSavedContractDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserSavedContractDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param contractId (optional) 
     * @return Success
     */
    isContractSaved(contractId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/UserSavedContract/IsContractSaved?";
        if (contractId === null)
            throw new Error("The parameter 'contractId' cannot be null.");
        else if (contractId !== undefined)
            url_ += "contractId=" + encodeURIComponent("" + contractId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsContractSaved(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsContractSaved(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsContractSaved(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllUserSavedContract(): Observable<UserSavedContractDto[]> {
        let url_ = this.baseUrl + "/api/services/app/UserSavedContract/GetAllUserSavedContract";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUserSavedContract(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUserSavedContract(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserSavedContractDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserSavedContractDto[]>;
        }));
    }

    protected processGetAllUserSavedContract(response: HttpResponseBase): Observable<UserSavedContractDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserSavedContractDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class AdminDashboardReportDto implements IAdminDashboardReportDto {
    registeredUserCount!: number;
    activatedUserCount!: number;
    masterUserCount!: number;
    newsletterActivatedCount!: number;
    mostActiveUsers!: MostActiveUserDto[] | undefined;
    registeredCompanyCount!: number;
    sectorReport!: SectorReportDto[] | undefined;
    regionReport!: RegionReportDto[] | undefined;
    mostActiveCompanies!: MostActiveCompanyDto[] | undefined;
    mostPopularContractFilters!: MostPopularContractFiltersDto;
    mostPopularTrainingCourseTopicFilters!: MostPopularTrainingCourseTopicFiltersDto;
    mostPopularContracts!: MostPopularContractDto[] | undefined;
    mostPopularTrainingCourses!: MostPopularTrainingCourseDto[] | undefined;

    constructor(data?: IAdminDashboardReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.registeredUserCount = _data["registeredUserCount"];
            this.activatedUserCount = _data["activatedUserCount"];
            this.masterUserCount = _data["masterUserCount"];
            this.newsletterActivatedCount = _data["newsletterActivatedCount"];
            if (Array.isArray(_data["mostActiveUsers"])) {
                this.mostActiveUsers = [] as any;
                for (let item of _data["mostActiveUsers"])
                    this.mostActiveUsers!.push(MostActiveUserDto.fromJS(item));
            }
            this.registeredCompanyCount = _data["registeredCompanyCount"];
            if (Array.isArray(_data["sectorReport"])) {
                this.sectorReport = [] as any;
                for (let item of _data["sectorReport"])
                    this.sectorReport!.push(SectorReportDto.fromJS(item));
            }
            if (Array.isArray(_data["regionReport"])) {
                this.regionReport = [] as any;
                for (let item of _data["regionReport"])
                    this.regionReport!.push(RegionReportDto.fromJS(item));
            }
            if (Array.isArray(_data["mostActiveCompanies"])) {
                this.mostActiveCompanies = [] as any;
                for (let item of _data["mostActiveCompanies"])
                    this.mostActiveCompanies!.push(MostActiveCompanyDto.fromJS(item));
            }
            this.mostPopularContractFilters = _data["mostPopularContractFilters"] ? MostPopularContractFiltersDto.fromJS(_data["mostPopularContractFilters"]) : <any>undefined;
            this.mostPopularTrainingCourseTopicFilters = _data["mostPopularTrainingCourseTopicFilters"] ? MostPopularTrainingCourseTopicFiltersDto.fromJS(_data["mostPopularTrainingCourseTopicFilters"]) : <any>undefined;
            if (Array.isArray(_data["mostPopularContracts"])) {
                this.mostPopularContracts = [] as any;
                for (let item of _data["mostPopularContracts"])
                    this.mostPopularContracts!.push(MostPopularContractDto.fromJS(item));
            }
            if (Array.isArray(_data["mostPopularTrainingCourses"])) {
                this.mostPopularTrainingCourses = [] as any;
                for (let item of _data["mostPopularTrainingCourses"])
                    this.mostPopularTrainingCourses!.push(MostPopularTrainingCourseDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AdminDashboardReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminDashboardReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registeredUserCount"] = this.registeredUserCount;
        data["activatedUserCount"] = this.activatedUserCount;
        data["masterUserCount"] = this.masterUserCount;
        data["newsletterActivatedCount"] = this.newsletterActivatedCount;
        if (Array.isArray(this.mostActiveUsers)) {
            data["mostActiveUsers"] = [];
            for (let item of this.mostActiveUsers)
                data["mostActiveUsers"].push(item.toJSON());
        }
        data["registeredCompanyCount"] = this.registeredCompanyCount;
        if (Array.isArray(this.sectorReport)) {
            data["sectorReport"] = [];
            for (let item of this.sectorReport)
                data["sectorReport"].push(item.toJSON());
        }
        if (Array.isArray(this.regionReport)) {
            data["regionReport"] = [];
            for (let item of this.regionReport)
                data["regionReport"].push(item.toJSON());
        }
        if (Array.isArray(this.mostActiveCompanies)) {
            data["mostActiveCompanies"] = [];
            for (let item of this.mostActiveCompanies)
                data["mostActiveCompanies"].push(item.toJSON());
        }
        data["mostPopularContractFilters"] = this.mostPopularContractFilters ? this.mostPopularContractFilters.toJSON() : <any>undefined;
        data["mostPopularTrainingCourseTopicFilters"] = this.mostPopularTrainingCourseTopicFilters ? this.mostPopularTrainingCourseTopicFilters.toJSON() : <any>undefined;
        if (Array.isArray(this.mostPopularContracts)) {
            data["mostPopularContracts"] = [];
            for (let item of this.mostPopularContracts)
                data["mostPopularContracts"].push(item.toJSON());
        }
        if (Array.isArray(this.mostPopularTrainingCourses)) {
            data["mostPopularTrainingCourses"] = [];
            for (let item of this.mostPopularTrainingCourses)
                data["mostPopularTrainingCourses"].push(item.toJSON());
        }
        return data;
    }

    clone(): AdminDashboardReportDto {
        const json = this.toJSON();
        let result = new AdminDashboardReportDto();
        result.init(json);
        return result;
    }
}

export interface IAdminDashboardReportDto {
    registeredUserCount: number;
    activatedUserCount: number;
    masterUserCount: number;
    newsletterActivatedCount: number;
    mostActiveUsers: MostActiveUserDto[] | undefined;
    registeredCompanyCount: number;
    sectorReport: SectorReportDto[] | undefined;
    regionReport: RegionReportDto[] | undefined;
    mostActiveCompanies: MostActiveCompanyDto[] | undefined;
    mostPopularContractFilters: MostPopularContractFiltersDto;
    mostPopularTrainingCourseTopicFilters: MostPopularTrainingCourseTopicFiltersDto;
    mostPopularContracts: MostPopularContractDto[] | undefined;
    mostPopularTrainingCourses: MostPopularTrainingCourseDto[] | undefined;
}

export class AppCoreCompanyDto implements IAppCoreCompanyDto {
    businessName!: string | undefined;
    email!: string | undefined;
    sector!: SectorDto;
    region!: InfocicaRegionDto;

    constructor(data?: IAppCoreCompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.businessName = _data["businessName"];
            this.email = _data["email"];
            this.sector = _data["sector"] ? SectorDto.fromJS(_data["sector"]) : <any>undefined;
            this.region = _data["region"] ? InfocicaRegionDto.fromJS(_data["region"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AppCoreCompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppCoreCompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["businessName"] = this.businessName;
        data["email"] = this.email;
        data["sector"] = this.sector ? this.sector.toJSON() : <any>undefined;
        data["region"] = this.region ? this.region.toJSON() : <any>undefined;
        return data;
    }

    clone(): AppCoreCompanyDto {
        const json = this.toJSON();
        let result = new AppCoreCompanyDto();
        result.init(json);
        return result;
    }
}

export interface IAppCoreCompanyDto {
    businessName: string | undefined;
    email: string | undefined;
    sector: SectorDto;
    region: InfocicaRegionDto;
}

export class ApplicationInfoDto implements IApplicationInfoDto {
    version!: string | undefined;
    releaseDate!: moment.Moment;
    features!: { [key: string]: boolean; } | undefined;

    constructor(data?: IApplicationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.releaseDate = _data["releaseDate"] ? moment(_data["releaseDate"].toString()) : <any>undefined;
            if (_data["features"]) {
                this.features = {} as any;
                for (let key in _data["features"]) {
                    if (_data["features"].hasOwnProperty(key))
                        (<any>this.features)![key] = _data["features"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : <any>undefined;
        if (this.features) {
            data["features"] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key))
                    (<any>data["features"])[key] = (<any>this.features)[key];
            }
        }
        return data;
    }

    clone(): ApplicationInfoDto {
        const json = this.toJSON();
        let result = new ApplicationInfoDto();
        result.init(json);
        return result;
    }
}

export interface IApplicationInfoDto {
    version: string | undefined;
    releaseDate: moment.Moment;
    features: { [key: string]: boolean; } | undefined;
}

export class ApplicationPopularFilterDto implements IApplicationPopularFilterDto {
    application!: InfocicaApplicationDto;
    userCount!: number;

    constructor(data?: IApplicationPopularFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? InfocicaApplicationDto.fromJS(_data["application"]) : <any>undefined;
            this.userCount = _data["userCount"];
        }
    }

    static fromJS(data: any): ApplicationPopularFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationPopularFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["userCount"] = this.userCount;
        return data;
    }

    clone(): ApplicationPopularFilterDto {
        const json = this.toJSON();
        let result = new ApplicationPopularFilterDto();
        result.init(json);
        return result;
    }
}

export interface IApplicationPopularFilterDto {
    application: InfocicaApplicationDto;
    userCount: number;
}

export class AuthenticateModel implements IAuthenticateModel {
    userNameOrEmailAddress!: string;
    password!: string;
    rememberClient!: boolean;
    recaptchaToken!: string | undefined;

    constructor(data?: IAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userNameOrEmailAddress = _data["userNameOrEmailAddress"];
            this.password = _data["password"];
            this.rememberClient = _data["rememberClient"];
            this.recaptchaToken = _data["recaptchaToken"];
        }
    }

    static fromJS(data: any): AuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["password"] = this.password;
        data["rememberClient"] = this.rememberClient;
        data["recaptchaToken"] = this.recaptchaToken;
        return data;
    }

    clone(): AuthenticateModel {
        const json = this.toJSON();
        let result = new AuthenticateModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    rememberClient: boolean;
    recaptchaToken: string | undefined;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;
    userId!: number;

    constructor(data?: IAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): AuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["userId"] = this.userId;
        return data;
    }

    clone(): AuthenticateResultModel {
        const json = this.toJSON();
        let result = new AuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    userId: number;
}

export class BannerDto implements IBannerDto {
    id!: number;
    staticCode!: string | undefined;
    type!: string | undefined;
    icon!: string | undefined;
    description!: string | undefined;

    constructor(data?: IBannerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.staticCode = _data["staticCode"];
            this.type = _data["type"];
            this.icon = _data["icon"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): BannerDto {
        data = typeof data === 'object' ? data : {};
        let result = new BannerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["staticCode"] = this.staticCode;
        data["type"] = this.type;
        data["icon"] = this.icon;
        data["description"] = this.description;
        return data;
    }

    clone(): BannerDto {
        const json = this.toJSON();
        let result = new BannerDto();
        result.init(json);
        return result;
    }
}

export interface IBannerDto {
    id: number;
    staticCode: string | undefined;
    type: string | undefined;
    icon: string | undefined;
    description: string | undefined;
}

export class BaseUserDto implements IBaseUserDto {
    id!: number;
    name!: string | undefined;
    surname!: string | undefined;
    fullName!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    phoneNumber!: string | undefined;
    roleNames!: string[] | undefined;

    constructor(data?: IBaseUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.fullName = _data["fullName"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames!.push(item);
            }
        }
    }

    static fromJS(data: any): BaseUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new BaseUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["fullName"] = this.fullName;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        return data;
    }

    clone(): BaseUserDto {
        const json = this.toJSON();
        let result = new BaseUserDto();
        result.init(json);
        return result;
    }
}

export interface IBaseUserDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    fullName: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    phoneNumber: string | undefined;
    roleNames: string[] | undefined;
}

export class BaseUserDtoPagedResultDto implements IBaseUserDtoPagedResultDto {
    items!: BaseUserDto[] | undefined;
    totalCount!: number;

    constructor(data?: IBaseUserDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(BaseUserDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): BaseUserDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new BaseUserDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): BaseUserDtoPagedResultDto {
        const json = this.toJSON();
        let result = new BaseUserDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IBaseUserDtoPagedResultDto {
    items: BaseUserDto[] | undefined;
    totalCount: number;
}

export class BaseUserWithCompanyDto implements IBaseUserWithCompanyDto {
    id!: number;
    name!: string | undefined;
    surname!: string | undefined;
    fullName!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    phoneNumber!: string | undefined;
    company!: CompanyBaseDto;
    roleNames!: string[] | undefined;

    constructor(data?: IBaseUserWithCompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.fullName = _data["fullName"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.company = _data["company"] ? CompanyBaseDto.fromJS(_data["company"]) : <any>undefined;
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames!.push(item);
            }
        }
    }

    static fromJS(data: any): BaseUserWithCompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new BaseUserWithCompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["fullName"] = this.fullName;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        return data;
    }

    clone(): BaseUserWithCompanyDto {
        const json = this.toJSON();
        let result = new BaseUserWithCompanyDto();
        result.init(json);
        return result;
    }
}

export interface IBaseUserWithCompanyDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    fullName: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    phoneNumber: string | undefined;
    company: CompanyBaseDto;
    roleNames: string[] | undefined;
}

export class BeneficiaryPopularFilterDto implements IBeneficiaryPopularFilterDto {
    beneficiary!: InfocicaBeneficiaryDto;
    userCount!: number;

    constructor(data?: IBeneficiaryPopularFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.beneficiary = _data["beneficiary"] ? InfocicaBeneficiaryDto.fromJS(_data["beneficiary"]) : <any>undefined;
            this.userCount = _data["userCount"];
        }
    }

    static fromJS(data: any): BeneficiaryPopularFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new BeneficiaryPopularFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["beneficiary"] = this.beneficiary ? this.beneficiary.toJSON() : <any>undefined;
        data["userCount"] = this.userCount;
        return data;
    }

    clone(): BeneficiaryPopularFilterDto {
        const json = this.toJSON();
        let result = new BeneficiaryPopularFilterDto();
        result.init(json);
        return result;
    }
}

export interface IBeneficiaryPopularFilterDto {
    beneficiary: InfocicaBeneficiaryDto;
    userCount: number;
}

export class ChangePasswordDto implements IChangePasswordDto {
    currentPassword!: string;
    newPassword!: string;

    constructor(data?: IChangePasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }

    clone(): ChangePasswordDto {
        const json = this.toJSON();
        let result = new ChangePasswordDto();
        result.init(json);
        return result;
    }
}

export interface IChangePasswordDto {
    currentPassword: string;
    newPassword: string;
}

export class ChangeUiThemeInput implements IChangeUiThemeInput {
    theme!: string;

    constructor(data?: IChangeUiThemeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.theme = _data["theme"];
        }
    }

    static fromJS(data: any): ChangeUiThemeInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUiThemeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["theme"] = this.theme;
        return data;
    }

    clone(): ChangeUiThemeInput {
        const json = this.toJSON();
        let result = new ChangeUiThemeInput();
        result.init(json);
        return result;
    }
}

export interface IChangeUiThemeInput {
    theme: string;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
    languageName!: string;

    constructor(data?: IChangeUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageName = _data["languageName"];
        }
    }

    static fromJS(data: any): ChangeUserLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        return data;
    }

    clone(): ChangeUserLanguageDto {
        const json = this.toJSON();
        let result = new ChangeUserLanguageDto();
        result.init(json);
        return result;
    }
}

export interface IChangeUserLanguageDto {
    languageName: string;
}

export class Company implements ICompany {
    id!: number;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    sector!: Sector;
    region!: InfocicaRegion;
    businessName!: string | undefined;
    fiscalCode!: string | undefined;
    serialNumber!: string | undefined;
    annotation!: string | undefined;
    isActive!: boolean;
    companyUsers!: CompanyUser[] | undefined;
    tenantId!: number;

    constructor(data?: ICompany) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.sector = _data["sector"] ? Sector.fromJS(_data["sector"]) : <any>undefined;
            this.region = _data["region"] ? InfocicaRegion.fromJS(_data["region"]) : <any>undefined;
            this.businessName = _data["businessName"];
            this.fiscalCode = _data["fiscalCode"];
            this.serialNumber = _data["serialNumber"];
            this.annotation = _data["annotation"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["companyUsers"])) {
                this.companyUsers = [] as any;
                for (let item of _data["companyUsers"])
                    this.companyUsers!.push(CompanyUser.fromJS(item));
            }
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): Company {
        data = typeof data === 'object' ? data : {};
        let result = new Company();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["sector"] = this.sector ? this.sector.toJSON() : <any>undefined;
        data["region"] = this.region ? this.region.toJSON() : <any>undefined;
        data["businessName"] = this.businessName;
        data["fiscalCode"] = this.fiscalCode;
        data["serialNumber"] = this.serialNumber;
        data["annotation"] = this.annotation;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.companyUsers)) {
            data["companyUsers"] = [];
            for (let item of this.companyUsers)
                data["companyUsers"].push(item.toJSON());
        }
        data["tenantId"] = this.tenantId;
        return data;
    }

    clone(): Company {
        const json = this.toJSON();
        let result = new Company();
        result.init(json);
        return result;
    }
}

export interface ICompany {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    sector: Sector;
    region: InfocicaRegion;
    businessName: string | undefined;
    fiscalCode: string | undefined;
    serialNumber: string | undefined;
    annotation: string | undefined;
    isActive: boolean;
    companyUsers: CompanyUser[] | undefined;
    tenantId: number;
}

export class CompanyBaseDto implements ICompanyBaseDto {
    id!: number;
    businessName!: string | undefined;
    fiscalCode!: string | undefined;

    constructor(data?: ICompanyBaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.businessName = _data["businessName"];
            this.fiscalCode = _data["fiscalCode"];
        }
    }

    static fromJS(data: any): CompanyBaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyBaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["businessName"] = this.businessName;
        data["fiscalCode"] = this.fiscalCode;
        return data;
    }

    clone(): CompanyBaseDto {
        const json = this.toJSON();
        let result = new CompanyBaseDto();
        result.init(json);
        return result;
    }
}

export interface ICompanyBaseDto {
    id: number;
    businessName: string | undefined;
    fiscalCode: string | undefined;
}

export class CompanyBaseDtoBaseUserDtoSurveyCompilationDto implements ICompanyBaseDtoBaseUserDtoSurveyCompilationDto {
    id!: number;
    survey!: SurveyBaseDto;
    company!: CompanyBaseDto;
    completionTime!: moment.Moment | undefined;
    finalPoints!: number | undefined;
    creatorUser!: BaseUserDto;
    creationTime!: moment.Moment;
    completionPercentage!: number;
    compilationSendTime!: moment.Moment | undefined;

    constructor(data?: ICompanyBaseDtoBaseUserDtoSurveyCompilationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.survey = _data["survey"] ? SurveyBaseDto.fromJS(_data["survey"]) : <any>undefined;
            this.company = _data["company"] ? CompanyBaseDto.fromJS(_data["company"]) : <any>undefined;
            this.completionTime = _data["completionTime"] ? moment(_data["completionTime"].toString()) : <any>undefined;
            this.finalPoints = _data["finalPoints"];
            this.creatorUser = _data["creatorUser"] ? BaseUserDto.fromJS(_data["creatorUser"]) : <any>undefined;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.completionPercentage = _data["completionPercentage"];
            this.compilationSendTime = _data["compilationSendTime"] ? moment(_data["compilationSendTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CompanyBaseDtoBaseUserDtoSurveyCompilationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyBaseDtoBaseUserDtoSurveyCompilationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["survey"] = this.survey ? this.survey.toJSON() : <any>undefined;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["completionTime"] = this.completionTime ? this.completionTime.toISOString() : <any>undefined;
        data["finalPoints"] = this.finalPoints;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["completionPercentage"] = this.completionPercentage;
        data["compilationSendTime"] = this.compilationSendTime ? this.compilationSendTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): CompanyBaseDtoBaseUserDtoSurveyCompilationDto {
        const json = this.toJSON();
        let result = new CompanyBaseDtoBaseUserDtoSurveyCompilationDto();
        result.init(json);
        return result;
    }
}

export interface ICompanyBaseDtoBaseUserDtoSurveyCompilationDto {
    id: number;
    survey: SurveyBaseDto;
    company: CompanyBaseDto;
    completionTime: moment.Moment | undefined;
    finalPoints: number | undefined;
    creatorUser: BaseUserDto;
    creationTime: moment.Moment;
    completionPercentage: number;
    compilationSendTime: moment.Moment | undefined;
}

export class CompanyBaseDtoBaseUserDtoSurveyCompilationDtoPagedResultDto implements ICompanyBaseDtoBaseUserDtoSurveyCompilationDtoPagedResultDto {
    items!: CompanyBaseDtoBaseUserDtoSurveyCompilationDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICompanyBaseDtoBaseUserDtoSurveyCompilationDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CompanyBaseDtoBaseUserDtoSurveyCompilationDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CompanyBaseDtoBaseUserDtoSurveyCompilationDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyBaseDtoBaseUserDtoSurveyCompilationDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CompanyBaseDtoBaseUserDtoSurveyCompilationDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CompanyBaseDtoBaseUserDtoSurveyCompilationDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICompanyBaseDtoBaseUserDtoSurveyCompilationDtoPagedResultDto {
    items: CompanyBaseDtoBaseUserDtoSurveyCompilationDto[] | undefined;
    totalCount: number;
}

export class CompanyDto implements ICompanyDto {
    id!: number;
    sector!: SectorDto;
    region!: InfocicaRegionDto;
    businessName!: string | undefined;
    fiscalCode!: string | undefined;
    serialNumber!: string | undefined;
    annotation!: string | undefined;

    constructor(data?: ICompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sector = _data["sector"] ? SectorDto.fromJS(_data["sector"]) : <any>undefined;
            this.region = _data["region"] ? InfocicaRegionDto.fromJS(_data["region"]) : <any>undefined;
            this.businessName = _data["businessName"];
            this.fiscalCode = _data["fiscalCode"];
            this.serialNumber = _data["serialNumber"];
            this.annotation = _data["annotation"];
        }
    }

    static fromJS(data: any): CompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sector"] = this.sector ? this.sector.toJSON() : <any>undefined;
        data["region"] = this.region ? this.region.toJSON() : <any>undefined;
        data["businessName"] = this.businessName;
        data["fiscalCode"] = this.fiscalCode;
        data["serialNumber"] = this.serialNumber;
        data["annotation"] = this.annotation;
        return data;
    }

    clone(): CompanyDto {
        const json = this.toJSON();
        let result = new CompanyDto();
        result.init(json);
        return result;
    }
}

export interface ICompanyDto {
    id: number;
    sector: SectorDto;
    region: InfocicaRegionDto;
    businessName: string | undefined;
    fiscalCode: string | undefined;
    serialNumber: string | undefined;
    annotation: string | undefined;
}

export class CompanyDtoPagedResultDto implements ICompanyDtoPagedResultDto {
    items!: CompanyDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICompanyDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CompanyDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CompanyDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CompanyDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CompanyDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICompanyDtoPagedResultDto {
    items: CompanyDto[] | undefined;
    totalCount: number;
}

export class CompanyExtendedDto implements ICompanyExtendedDto {
    id!: number;
    sector!: SectorDto;
    region!: InfocicaRegionDto;
    businessName!: string | undefined;
    fiscalCode!: string | undefined;
    serialNumber!: string | undefined;
    annotation!: string | undefined;
    hasMasterUser!: boolean;

    constructor(data?: ICompanyExtendedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sector = _data["sector"] ? SectorDto.fromJS(_data["sector"]) : <any>undefined;
            this.region = _data["region"] ? InfocicaRegionDto.fromJS(_data["region"]) : <any>undefined;
            this.businessName = _data["businessName"];
            this.fiscalCode = _data["fiscalCode"];
            this.serialNumber = _data["serialNumber"];
            this.annotation = _data["annotation"];
            this.hasMasterUser = _data["hasMasterUser"];
        }
    }

    static fromJS(data: any): CompanyExtendedDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyExtendedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sector"] = this.sector ? this.sector.toJSON() : <any>undefined;
        data["region"] = this.region ? this.region.toJSON() : <any>undefined;
        data["businessName"] = this.businessName;
        data["fiscalCode"] = this.fiscalCode;
        data["serialNumber"] = this.serialNumber;
        data["annotation"] = this.annotation;
        data["hasMasterUser"] = this.hasMasterUser;
        return data;
    }

    clone(): CompanyExtendedDto {
        const json = this.toJSON();
        let result = new CompanyExtendedDto();
        result.init(json);
        return result;
    }
}

export interface ICompanyExtendedDto {
    id: number;
    sector: SectorDto;
    region: InfocicaRegionDto;
    businessName: string | undefined;
    fiscalCode: string | undefined;
    serialNumber: string | undefined;
    annotation: string | undefined;
    hasMasterUser: boolean;
}

export class CompanyUser implements ICompanyUser {
    id!: number;
    readonly domainEvents!: IEventData[] | undefined;
    creatorUserId!: number | undefined;
    creationTime!: moment.Moment;
    company!: Company;
    user!: User;
    isMaster!: boolean;

    constructor(data?: ICompanyUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["domainEvents"])) {
                (<any>this).domainEvents = [] as any;
                for (let item of _data["domainEvents"])
                    (<any>this).domainEvents!.push(IEventData.fromJS(item));
            }
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.company = _data["company"] ? Company.fromJS(_data["company"]) : <any>undefined;
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.isMaster = _data["isMaster"];
        }
    }

    static fromJS(data: any): CompanyUser {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            for (let item of this.domainEvents)
                data["domainEvents"].push(item.toJSON());
        }
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["isMaster"] = this.isMaster;
        return data;
    }

    clone(): CompanyUser {
        const json = this.toJSON();
        let result = new CompanyUser();
        result.init(json);
        return result;
    }
}

export interface ICompanyUser {
    id: number;
    domainEvents: IEventData[] | undefined;
    creatorUserId: number | undefined;
    creationTime: moment.Moment;
    company: Company;
    user: User;
    isMaster: boolean;
}

export class CompilationFinalScoreDto implements ICompilationFinalScoreDto {
    finalPoints!: number;
    percentage!: number;
    name!: string | undefined;
    description!: string | undefined;
    minimumPoints!: number;
    maximumPoints!: number;

    constructor(data?: ICompilationFinalScoreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.finalPoints = _data["finalPoints"];
            this.percentage = _data["percentage"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.minimumPoints = _data["minimumPoints"];
            this.maximumPoints = _data["maximumPoints"];
        }
    }

    static fromJS(data: any): CompilationFinalScoreDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompilationFinalScoreDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["finalPoints"] = this.finalPoints;
        data["percentage"] = this.percentage;
        data["name"] = this.name;
        data["description"] = this.description;
        data["minimumPoints"] = this.minimumPoints;
        data["maximumPoints"] = this.maximumPoints;
        return data;
    }

    clone(): CompilationFinalScoreDto {
        const json = this.toJSON();
        let result = new CompilationFinalScoreDto();
        result.init(json);
        return result;
    }
}

export interface ICompilationFinalScoreDto {
    finalPoints: number;
    percentage: number;
    name: string | undefined;
    description: string | undefined;
    minimumPoints: number;
    maximumPoints: number;
}

export class ContractBaseDto implements IContractBaseDto {
    id!: number;
    subject!: string | undefined;
    summary!: string | undefined;
    legislativeReference!: string | undefined;
    startDate!: moment.Moment | undefined;
    expirationDate!: moment.Moment | undefined;
    infocicaDateAdded!: moment.Moment;
    fileId!: number | undefined;

    constructor(data?: IContractBaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subject = _data["subject"];
            this.summary = _data["summary"];
            this.legislativeReference = _data["legislativeReference"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.expirationDate = _data["expirationDate"] ? moment(_data["expirationDate"].toString()) : <any>undefined;
            this.infocicaDateAdded = _data["infocicaDateAdded"] ? moment(_data["infocicaDateAdded"].toString()) : <any>undefined;
            this.fileId = _data["fileId"];
        }
    }

    static fromJS(data: any): ContractBaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractBaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subject"] = this.subject;
        data["summary"] = this.summary;
        data["legislativeReference"] = this.legislativeReference;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["infocicaDateAdded"] = this.infocicaDateAdded ? this.infocicaDateAdded.toISOString() : <any>undefined;
        data["fileId"] = this.fileId;
        return data;
    }

    clone(): ContractBaseDto {
        const json = this.toJSON();
        let result = new ContractBaseDto();
        result.init(json);
        return result;
    }
}

export interface IContractBaseDto {
    id: number;
    subject: string | undefined;
    summary: string | undefined;
    legislativeReference: string | undefined;
    startDate: moment.Moment | undefined;
    expirationDate: moment.Moment | undefined;
    infocicaDateAdded: moment.Moment;
    fileId: number | undefined;
}

export class ContractBaseDtoPagedResultDto implements IContractBaseDtoPagedResultDto {
    items!: ContractBaseDto[] | undefined;
    totalCount!: number;

    constructor(data?: IContractBaseDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ContractBaseDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ContractBaseDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractBaseDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ContractBaseDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ContractBaseDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IContractBaseDtoPagedResultDto {
    items: ContractBaseDto[] | undefined;
    totalCount: number;
}

export class ContractDto implements IContractDto {
    id!: number;
    subject!: string | undefined;
    summary!: string | undefined;
    legislativeReference!: string | undefined;
    startDate!: moment.Moment | undefined;
    expirationDate!: moment.Moment | undefined;
    eligibleExpenditures!: InfocicaEligibleExpenditureDto[] | undefined;
    beneficiaries!: InfocicaBeneficiaryDto[] | undefined;
    applicationScope!: InfocicaApplicationDto;
    region!: InfocicaRegionDto;
    province!: InfocicaProvinceDto;
    facilitations!: InfocicaFacilitationDto[] | undefined;
    infocicaDateAdded!: moment.Moment;
    creationTime!: moment.Moment;
    externalCode!: number;
    origin!: string | undefined;
    file!: File;

    constructor(data?: IContractDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subject = _data["subject"];
            this.summary = _data["summary"];
            this.legislativeReference = _data["legislativeReference"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.expirationDate = _data["expirationDate"] ? moment(_data["expirationDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["eligibleExpenditures"])) {
                this.eligibleExpenditures = [] as any;
                for (let item of _data["eligibleExpenditures"])
                    this.eligibleExpenditures!.push(InfocicaEligibleExpenditureDto.fromJS(item));
            }
            if (Array.isArray(_data["beneficiaries"])) {
                this.beneficiaries = [] as any;
                for (let item of _data["beneficiaries"])
                    this.beneficiaries!.push(InfocicaBeneficiaryDto.fromJS(item));
            }
            this.applicationScope = _data["applicationScope"] ? InfocicaApplicationDto.fromJS(_data["applicationScope"]) : <any>undefined;
            this.region = _data["region"] ? InfocicaRegionDto.fromJS(_data["region"]) : <any>undefined;
            this.province = _data["province"] ? InfocicaProvinceDto.fromJS(_data["province"]) : <any>undefined;
            if (Array.isArray(_data["facilitations"])) {
                this.facilitations = [] as any;
                for (let item of _data["facilitations"])
                    this.facilitations!.push(InfocicaFacilitationDto.fromJS(item));
            }
            this.infocicaDateAdded = _data["infocicaDateAdded"] ? moment(_data["infocicaDateAdded"].toString()) : <any>undefined;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.externalCode = _data["externalCode"];
            this.origin = _data["origin"];
            this.file = _data["file"] ? File.fromJS(_data["file"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ContractDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subject"] = this.subject;
        data["summary"] = this.summary;
        data["legislativeReference"] = this.legislativeReference;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        if (Array.isArray(this.eligibleExpenditures)) {
            data["eligibleExpenditures"] = [];
            for (let item of this.eligibleExpenditures)
                data["eligibleExpenditures"].push(item.toJSON());
        }
        if (Array.isArray(this.beneficiaries)) {
            data["beneficiaries"] = [];
            for (let item of this.beneficiaries)
                data["beneficiaries"].push(item.toJSON());
        }
        data["applicationScope"] = this.applicationScope ? this.applicationScope.toJSON() : <any>undefined;
        data["region"] = this.region ? this.region.toJSON() : <any>undefined;
        data["province"] = this.province ? this.province.toJSON() : <any>undefined;
        if (Array.isArray(this.facilitations)) {
            data["facilitations"] = [];
            for (let item of this.facilitations)
                data["facilitations"].push(item.toJSON());
        }
        data["infocicaDateAdded"] = this.infocicaDateAdded ? this.infocicaDateAdded.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["externalCode"] = this.externalCode;
        data["origin"] = this.origin;
        data["file"] = this.file ? this.file.toJSON() : <any>undefined;
        return data;
    }

    clone(): ContractDto {
        const json = this.toJSON();
        let result = new ContractDto();
        result.init(json);
        return result;
    }
}

export interface IContractDto {
    id: number;
    subject: string | undefined;
    summary: string | undefined;
    legislativeReference: string | undefined;
    startDate: moment.Moment | undefined;
    expirationDate: moment.Moment | undefined;
    eligibleExpenditures: InfocicaEligibleExpenditureDto[] | undefined;
    beneficiaries: InfocicaBeneficiaryDto[] | undefined;
    applicationScope: InfocicaApplicationDto;
    region: InfocicaRegionDto;
    province: InfocicaProvinceDto;
    facilitations: InfocicaFacilitationDto[] | undefined;
    infocicaDateAdded: moment.Moment;
    creationTime: moment.Moment;
    externalCode: number;
    origin: string | undefined;
    file: File;
}

export class CreateCompilationInput implements ICreateCompilationInput {
    surveyId!: number;
    userId!: number;

    constructor(data?: ICreateCompilationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyId = _data["surveyId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): CreateCompilationInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompilationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyId"] = this.surveyId;
        data["userId"] = this.userId;
        return data;
    }

    clone(): CreateCompilationInput {
        const json = this.toJSON();
        let result = new CreateCompilationInput();
        result.init(json);
        return result;
    }
}

export interface ICreateCompilationInput {
    surveyId: number;
    userId: number;
}

export class CreateContractDto implements ICreateContractDto {
    id!: number;
    subject!: string;
    summary!: string;
    legislativeReference!: string | undefined;
    startDate!: moment.Moment | undefined;
    expirationDate!: moment.Moment | undefined;
    eligibleExpendituresIds!: number[] | undefined;
    beneficiariesIds!: number[] | undefined;
    applicationScopeId!: number | undefined;
    regionId!: number | undefined;
    provinceId!: number | undefined;
    externalCode!: number;

    constructor(data?: ICreateContractDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subject = _data["subject"];
            this.summary = _data["summary"];
            this.legislativeReference = _data["legislativeReference"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.expirationDate = _data["expirationDate"] ? moment(_data["expirationDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["eligibleExpendituresIds"])) {
                this.eligibleExpendituresIds = [] as any;
                for (let item of _data["eligibleExpendituresIds"])
                    this.eligibleExpendituresIds!.push(item);
            }
            if (Array.isArray(_data["beneficiariesIds"])) {
                this.beneficiariesIds = [] as any;
                for (let item of _data["beneficiariesIds"])
                    this.beneficiariesIds!.push(item);
            }
            this.applicationScopeId = _data["applicationScopeId"];
            this.regionId = _data["regionId"];
            this.provinceId = _data["provinceId"];
            this.externalCode = _data["externalCode"];
        }
    }

    static fromJS(data: any): CreateContractDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateContractDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subject"] = this.subject;
        data["summary"] = this.summary;
        data["legislativeReference"] = this.legislativeReference;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        if (Array.isArray(this.eligibleExpendituresIds)) {
            data["eligibleExpendituresIds"] = [];
            for (let item of this.eligibleExpendituresIds)
                data["eligibleExpendituresIds"].push(item);
        }
        if (Array.isArray(this.beneficiariesIds)) {
            data["beneficiariesIds"] = [];
            for (let item of this.beneficiariesIds)
                data["beneficiariesIds"].push(item);
        }
        data["applicationScopeId"] = this.applicationScopeId;
        data["regionId"] = this.regionId;
        data["provinceId"] = this.provinceId;
        data["externalCode"] = this.externalCode;
        return data;
    }

    clone(): CreateContractDto {
        const json = this.toJSON();
        let result = new CreateContractDto();
        result.init(json);
        return result;
    }
}

export interface ICreateContractDto {
    id: number;
    subject: string;
    summary: string;
    legislativeReference: string | undefined;
    startDate: moment.Moment | undefined;
    expirationDate: moment.Moment | undefined;
    eligibleExpendituresIds: number[] | undefined;
    beneficiariesIds: number[] | undefined;
    applicationScopeId: number | undefined;
    regionId: number | undefined;
    provinceId: number | undefined;
    externalCode: number;
}

export class CreateGoToTokenDto implements ICreateGoToTokenDto {
    token!: string | undefined;
    expirationDate!: moment.Moment;

    constructor(data?: ICreateGoToTokenDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.expirationDate = _data["expirationDate"] ? moment(_data["expirationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateGoToTokenDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGoToTokenDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): CreateGoToTokenDto {
        const json = this.toJSON();
        let result = new CreateGoToTokenDto();
        result.init(json);
        return result;
    }
}

export interface ICreateGoToTokenDto {
    token: string | undefined;
    expirationDate: moment.Moment;
}

export class CreateMultipleInvitationInput implements ICreateMultipleInvitationInput {
    companyId!: number;
    userInvitations!: CreateUserInvitationBaseDto[] | undefined;

    constructor(data?: ICreateMultipleInvitationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            if (Array.isArray(_data["userInvitations"])) {
                this.userInvitations = [] as any;
                for (let item of _data["userInvitations"])
                    this.userInvitations!.push(CreateUserInvitationBaseDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateMultipleInvitationInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMultipleInvitationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        if (Array.isArray(this.userInvitations)) {
            data["userInvitations"] = [];
            for (let item of this.userInvitations)
                data["userInvitations"].push(item.toJSON());
        }
        return data;
    }

    clone(): CreateMultipleInvitationInput {
        const json = this.toJSON();
        let result = new CreateMultipleInvitationInput();
        result.init(json);
        return result;
    }
}

export interface ICreateMultipleInvitationInput {
    companyId: number;
    userInvitations: CreateUserInvitationBaseDto[] | undefined;
}

export class CreateRoleDto implements ICreateRoleDto {
    name!: string;
    displayName!: string;
    normalizedName!: string | undefined;
    description!: string | undefined;
    grantedPermissions!: string[] | undefined;

    constructor(data?: ICreateRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.description = _data["description"];
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        return data;
    }

    clone(): CreateRoleDto {
        const json = this.toJSON();
        let result = new CreateRoleDto();
        result.init(json);
        return result;
    }
}

export interface ICreateRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
}

export class CreateTenantDto implements ICreateTenantDto {
    tenancyName!: string;
    name!: string;
    adminEmailAddress!: string;
    connectionString!: string | undefined;
    isActive!: boolean;

    constructor(data?: ICreateTenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.adminEmailAddress = _data["adminEmailAddress"];
            this.connectionString = _data["connectionString"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateTenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["connectionString"] = this.connectionString;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): CreateTenantDto {
        const json = this.toJSON();
        let result = new CreateTenantDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTenantDto {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    connectionString: string | undefined;
    isActive: boolean;
}

export class CreateTrainingCourseDto implements ICreateTrainingCourseDto {
    id!: number;
    name!: string | undefined;
    description!: string | undefined;
    topicId!: number;
    contentTypeId!: number;
    isPublished!: boolean;

    constructor(data?: ICreateTrainingCourseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.topicId = _data["topicId"];
            this.contentTypeId = _data["contentTypeId"];
            this.isPublished = _data["isPublished"];
        }
    }

    static fromJS(data: any): CreateTrainingCourseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTrainingCourseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["topicId"] = this.topicId;
        data["contentTypeId"] = this.contentTypeId;
        data["isPublished"] = this.isPublished;
        return data;
    }

    clone(): CreateTrainingCourseDto {
        const json = this.toJSON();
        let result = new CreateTrainingCourseDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTrainingCourseDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
    topicId: number;
    contentTypeId: number;
    isPublished: boolean;
}

export class CreateTrainingCourseLessonChapterDto implements ICreateTrainingCourseLessonChapterDto {
    trainingCourseLessonId!: number;
    description!: string | undefined;
    minute!: string | undefined;

    constructor(data?: ICreateTrainingCourseLessonChapterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trainingCourseLessonId = _data["trainingCourseLessonId"];
            this.description = _data["description"];
            this.minute = _data["minute"];
        }
    }

    static fromJS(data: any): CreateTrainingCourseLessonChapterDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTrainingCourseLessonChapterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trainingCourseLessonId"] = this.trainingCourseLessonId;
        data["description"] = this.description;
        data["minute"] = this.minute;
        return data;
    }

    clone(): CreateTrainingCourseLessonChapterDto {
        const json = this.toJSON();
        let result = new CreateTrainingCourseLessonChapterDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTrainingCourseLessonChapterDto {
    trainingCourseLessonId: number;
    description: string | undefined;
    minute: string | undefined;
}

export class CreateTrainingCourseLessonDto implements ICreateTrainingCourseLessonDto {
    trainingCourseId!: number;
    name!: string;
    description!: string | undefined;
    teacherName!: string | undefined;
    externalLink!: string | undefined;

    constructor(data?: ICreateTrainingCourseLessonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trainingCourseId = _data["trainingCourseId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.teacherName = _data["teacherName"];
            this.externalLink = _data["externalLink"];
        }
    }

    static fromJS(data: any): CreateTrainingCourseLessonDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTrainingCourseLessonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trainingCourseId"] = this.trainingCourseId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["teacherName"] = this.teacherName;
        data["externalLink"] = this.externalLink;
        return data;
    }

    clone(): CreateTrainingCourseLessonDto {
        const json = this.toJSON();
        let result = new CreateTrainingCourseLessonDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTrainingCourseLessonDto {
    trainingCourseId: number;
    name: string;
    description: string | undefined;
    teacherName: string | undefined;
    externalLink: string | undefined;
}

export class CreateUserDto implements ICreateUserDto {
    emailAddress!: string | undefined;
    password!: string | undefined;
    isNewsletterActivated!: boolean;
    isActive!: boolean;
    roleNames!: string[] | undefined;
    genderId!: number;

    constructor(data?: ICreateUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
            this.isNewsletterActivated = _data["isNewsletterActivated"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames!.push(item);
            }
            this.genderId = _data["genderId"];
        }
    }

    static fromJS(data: any): CreateUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["isNewsletterActivated"] = this.isNewsletterActivated;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["genderId"] = this.genderId;
        return data;
    }

    clone(): CreateUserDto {
        const json = this.toJSON();
        let result = new CreateUserDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserDto {
    emailAddress: string | undefined;
    password: string | undefined;
    isNewsletterActivated: boolean;
    isActive: boolean;
    roleNames: string[] | undefined;
    genderId: number;
}

export class CreateUserInvitationBaseDto implements ICreateUserInvitationBaseDto {
    emailAddress!: string;
    name!: string | undefined;
    surname!: string | undefined;

    constructor(data?: ICreateUserInvitationBaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.name = _data["name"];
            this.surname = _data["surname"];
        }
    }

    static fromJS(data: any): CreateUserInvitationBaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserInvitationBaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["name"] = this.name;
        data["surname"] = this.surname;
        return data;
    }

    clone(): CreateUserInvitationBaseDto {
        const json = this.toJSON();
        let result = new CreateUserInvitationBaseDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserInvitationBaseDto {
    emailAddress: string;
    name: string | undefined;
    surname: string | undefined;
}

export class EligibleExpenditurePopularDto implements IEligibleExpenditurePopularDto {
    eligibleExpenditure!: InfocicaEligibleExpenditureDto;
    userCount!: number;

    constructor(data?: IEligibleExpenditurePopularDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eligibleExpenditure = _data["eligibleExpenditure"] ? InfocicaEligibleExpenditureDto.fromJS(_data["eligibleExpenditure"]) : <any>undefined;
            this.userCount = _data["userCount"];
        }
    }

    static fromJS(data: any): EligibleExpenditurePopularDto {
        data = typeof data === 'object' ? data : {};
        let result = new EligibleExpenditurePopularDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eligibleExpenditure"] = this.eligibleExpenditure ? this.eligibleExpenditure.toJSON() : <any>undefined;
        data["userCount"] = this.userCount;
        return data;
    }

    clone(): EligibleExpenditurePopularDto {
        const json = this.toJSON();
        let result = new EligibleExpenditurePopularDto();
        result.init(json);
        return result;
    }
}

export interface IEligibleExpenditurePopularDto {
    eligibleExpenditure: InfocicaEligibleExpenditureDto;
    userCount: number;
}

export class ExternalAuthenticateModel implements IExternalAuthenticateModel {
    authProvider!: string;
    providerKey!: string;
    providerAccessCode!: string;

    constructor(data?: IExternalAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authProvider = _data["authProvider"];
            this.providerKey = _data["providerKey"];
            this.providerAccessCode = _data["providerAccessCode"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authProvider"] = this.authProvider;
        data["providerKey"] = this.providerKey;
        data["providerAccessCode"] = this.providerAccessCode;
        return data;
    }

    clone(): ExternalAuthenticateModel {
        const json = this.toJSON();
        let result = new ExternalAuthenticateModel();
        result.init(json);
        return result;
    }
}

export interface IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;
}

export class ExternalAuthenticateResultModel implements IExternalAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;
    waitingForActivation!: boolean;

    constructor(data?: IExternalAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.waitingForActivation = _data["waitingForActivation"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["waitingForActivation"] = this.waitingForActivation;
        return data;
    }

    clone(): ExternalAuthenticateResultModel {
        const json = this.toJSON();
        let result = new ExternalAuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    waitingForActivation: boolean;
}

export class ExternalLoginProviderInfoModel implements IExternalLoginProviderInfoModel {
    name!: string | undefined;
    clientId!: string | undefined;

    constructor(data?: IExternalLoginProviderInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): ExternalLoginProviderInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginProviderInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["clientId"] = this.clientId;
        return data;
    }

    clone(): ExternalLoginProviderInfoModel {
        const json = this.toJSON();
        let result = new ExternalLoginProviderInfoModel();
        result.init(json);
        return result;
    }
}

export interface IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;
}

export class FacilitationPopularFilterDto implements IFacilitationPopularFilterDto {
    facilitation!: InfocicaFacilitationDto;
    userCount!: number;

    constructor(data?: IFacilitationPopularFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.facilitation = _data["facilitation"] ? InfocicaFacilitationDto.fromJS(_data["facilitation"]) : <any>undefined;
            this.userCount = _data["userCount"];
        }
    }

    static fromJS(data: any): FacilitationPopularFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new FacilitationPopularFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["facilitation"] = this.facilitation ? this.facilitation.toJSON() : <any>undefined;
        data["userCount"] = this.userCount;
        return data;
    }

    clone(): FacilitationPopularFilterDto {
        const json = this.toJSON();
        let result = new FacilitationPopularFilterDto();
        result.init(json);
        return result;
    }
}

export interface IFacilitationPopularFilterDto {
    facilitation: InfocicaFacilitationDto;
    userCount: number;
}

export class FeedRSSNewsDto implements IFeedRSSNewsDto {
    id!: string | undefined;
    title!: string | undefined;
    image!: string | undefined;
    content!: string | undefined;
    description!: string | undefined;
    publicationDate!: moment.Moment;
    url!: string | undefined;
    externalCode!: string | undefined;
    creator!: string | undefined;

    constructor(data?: IFeedRSSNewsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.image = _data["image"];
            this.content = _data["content"];
            this.description = _data["description"];
            this.publicationDate = _data["publicationDate"] ? moment(_data["publicationDate"].toString()) : <any>undefined;
            this.url = _data["url"];
            this.externalCode = _data["externalCode"];
            this.creator = _data["creator"];
        }
    }

    static fromJS(data: any): FeedRSSNewsDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeedRSSNewsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["image"] = this.image;
        data["content"] = this.content;
        data["description"] = this.description;
        data["publicationDate"] = this.publicationDate ? this.publicationDate.toISOString() : <any>undefined;
        data["url"] = this.url;
        data["externalCode"] = this.externalCode;
        data["creator"] = this.creator;
        return data;
    }

    clone(): FeedRSSNewsDto {
        const json = this.toJSON();
        let result = new FeedRSSNewsDto();
        result.init(json);
        return result;
    }
}

export interface IFeedRSSNewsDto {
    id: string | undefined;
    title: string | undefined;
    image: string | undefined;
    content: string | undefined;
    description: string | undefined;
    publicationDate: moment.Moment;
    url: string | undefined;
    externalCode: string | undefined;
    creator: string | undefined;
}

export class File implements IFile {
    id!: number;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    mask!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    extension!: string | undefined;
    mimeType!: string | undefined;
    size!: number;

    constructor(data?: IFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.mask = _data["mask"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.extension = _data["extension"];
            this.mimeType = _data["mimeType"];
            this.size = _data["size"];
        }
    }

    static fromJS(data: any): File {
        data = typeof data === 'object' ? data : {};
        let result = new File();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["mask"] = this.mask;
        data["name"] = this.name;
        data["description"] = this.description;
        data["extension"] = this.extension;
        data["mimeType"] = this.mimeType;
        data["size"] = this.size;
        return data;
    }

    clone(): File {
        const json = this.toJSON();
        let result = new File();
        result.init(json);
        return result;
    }
}

export interface IFile {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    mask: string | undefined;
    name: string | undefined;
    description: string | undefined;
    extension: string | undefined;
    mimeType: string | undefined;
    size: number;
}

export class FileDownloadDto implements IFileDownloadDto {
    fileName!: string | undefined;
    mimeType!: string | undefined;
    size!: number;
    byteArray!: string | undefined;

    constructor(data?: IFileDownloadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.mimeType = _data["mimeType"];
            this.size = _data["size"];
            this.byteArray = _data["byteArray"];
        }
    }

    static fromJS(data: any): FileDownloadDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDownloadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["mimeType"] = this.mimeType;
        data["size"] = this.size;
        data["byteArray"] = this.byteArray;
        return data;
    }

    clone(): FileDownloadDto {
        const json = this.toJSON();
        let result = new FileDownloadDto();
        result.init(json);
        return result;
    }
}

export interface IFileDownloadDto {
    fileName: string | undefined;
    mimeType: string | undefined;
    size: number;
    byteArray: string | undefined;
}

export class FileDto implements IFileDto {
    id!: number;
    mask!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    extension!: string | undefined;
    mimeType!: string | undefined;
    size!: number;

    constructor(data?: IFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mask = _data["mask"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.extension = _data["extension"];
            this.mimeType = _data["mimeType"];
            this.size = _data["size"];
        }
    }

    static fromJS(data: any): FileDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mask"] = this.mask;
        data["name"] = this.name;
        data["description"] = this.description;
        data["extension"] = this.extension;
        data["mimeType"] = this.mimeType;
        data["size"] = this.size;
        return data;
    }

    clone(): FileDto {
        const json = this.toJSON();
        let result = new FileDto();
        result.init(json);
        return result;
    }
}

export interface IFileDto {
    id: number;
    mask: string | undefined;
    name: string | undefined;
    description: string | undefined;
    extension: string | undefined;
    mimeType: string | undefined;
    size: number;
}

export class FileExtendedDto implements IFileExtendedDto {
    id!: number;
    mask!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    extension!: string | undefined;
    mimeType!: string | undefined;
    size!: number;
    byteArray!: string | undefined;
    signedUrl!: string | undefined;

    constructor(data?: IFileExtendedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mask = _data["mask"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.extension = _data["extension"];
            this.mimeType = _data["mimeType"];
            this.size = _data["size"];
            this.byteArray = _data["byteArray"];
            this.signedUrl = _data["signedUrl"];
        }
    }

    static fromJS(data: any): FileExtendedDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileExtendedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mask"] = this.mask;
        data["name"] = this.name;
        data["description"] = this.description;
        data["extension"] = this.extension;
        data["mimeType"] = this.mimeType;
        data["size"] = this.size;
        data["byteArray"] = this.byteArray;
        data["signedUrl"] = this.signedUrl;
        return data;
    }

    clone(): FileExtendedDto {
        const json = this.toJSON();
        let result = new FileExtendedDto();
        result.init(json);
        return result;
    }
}

export interface IFileExtendedDto {
    id: number;
    mask: string | undefined;
    name: string | undefined;
    description: string | undefined;
    extension: string | undefined;
    mimeType: string | undefined;
    size: number;
    byteArray: string | undefined;
    signedUrl: string | undefined;
}

export class FlatPermissionDto implements IFlatPermissionDto {
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;

    constructor(data?: IFlatPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): FlatPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        return data;
    }

    clone(): FlatPermissionDto {
        const json = this.toJSON();
        let result = new FlatPermissionDto();
        result.init(json);
        return result;
    }
}

export interface IFlatPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
}

export class ForceResetPasswordDto implements IForceResetPasswordDto {
    adminPassword!: string;
    userId!: number;
    newPassword!: string;

    constructor(data?: IForceResetPasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adminPassword = _data["adminPassword"];
            this.userId = _data["userId"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ForceResetPasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ForceResetPasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adminPassword"] = this.adminPassword;
        data["userId"] = this.userId;
        data["newPassword"] = this.newPassword;
        return data;
    }

    clone(): ForceResetPasswordDto {
        const json = this.toJSON();
        let result = new ForceResetPasswordDto();
        result.init(json);
        return result;
    }
}

export interface IForceResetPasswordDto {
    adminPassword: string;
    userId: number;
    newPassword: string;
}

export class ForgotPasswordDto implements IForgotPasswordDto {
    emailAddress!: string;

    constructor(data?: IForgotPasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): ForgotPasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotPasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    }

    clone(): ForgotPasswordDto {
        const json = this.toJSON();
        let result = new ForgotPasswordDto();
        result.init(json);
        return result;
    }
}

export interface IForgotPasswordDto {
    emailAddress: string;
}

export class Gender implements IGender {
    id!: number;
    value!: string;

    constructor(data?: IGender) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Gender {
        data = typeof data === 'object' ? data : {};
        let result = new Gender();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        return data;
    }

    clone(): Gender {
        const json = this.toJSON();
        let result = new Gender();
        result.init(json);
        return result;
    }
}

export interface IGender {
    id: number;
    value: string;
}

export class GenderDto implements IGenderDto {
    id!: number;
    value!: string | undefined;

    constructor(data?: IGenderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): GenderDto {
        data = typeof data === 'object' ? data : {};
        let result = new GenderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        return data;
    }

    clone(): GenderDto {
        const json = this.toJSON();
        let result = new GenderDto();
        result.init(json);
        return result;
    }
}

export interface IGenderDto {
    id: number;
    value: string | undefined;
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
    application!: ApplicationInfoDto;
    user!: BaseUserDto;
    tenant!: TenantLoginInfoDto;
    company!: CompanyBaseDto;

    constructor(data?: IGetCurrentLoginInformationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationInfoDto.fromJS(_data["application"]) : <any>undefined;
            this.user = _data["user"] ? BaseUserDto.fromJS(_data["user"]) : <any>undefined;
            this.tenant = _data["tenant"] ? TenantLoginInfoDto.fromJS(_data["tenant"]) : <any>undefined;
            this.company = _data["company"] ? CompanyBaseDto.fromJS(_data["company"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCurrentLoginInformationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetCurrentLoginInformationsOutput {
        const json = this.toJSON();
        let result = new GetCurrentLoginInformationsOutput();
        result.init(json);
        return result;
    }
}

export interface IGetCurrentLoginInformationsOutput {
    application: ApplicationInfoDto;
    user: BaseUserDto;
    tenant: TenantLoginInfoDto;
    company: CompanyBaseDto;
}

export class GetRoleForEditOutput implements IGetRoleForEditOutput {
    role!: RoleEditDto;
    permissions!: FlatPermissionDto[] | undefined;
    grantedPermissionNames!: string[] | undefined;

    constructor(data?: IGetRoleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleEditDto.fromJS(_data["role"]) : <any>undefined;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(FlatPermissionDto.fromJS(item));
            }
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any): GetRoleForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }

    clone(): GetRoleForEditOutput {
        const json = this.toJSON();
        let result = new GetRoleForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class GoToTokenDto implements IGoToTokenDto {
    id!: string;
    token!: string | undefined;
    expirationDate!: moment.Moment;

    constructor(data?: IGoToTokenDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.token = _data["token"];
            this.expirationDate = _data["expirationDate"] ? moment(_data["expirationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GoToTokenDto {
        data = typeof data === 'object' ? data : {};
        let result = new GoToTokenDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["token"] = this.token;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): GoToTokenDto {
        const json = this.toJSON();
        let result = new GoToTokenDto();
        result.init(json);
        return result;
    }
}

export interface IGoToTokenDto {
    id: string;
    token: string | undefined;
    expirationDate: moment.Moment;
}

export class GoToWebhookNotificationDto implements IGoToWebhookNotificationDto {
    id!: number;
    eventName!: string | undefined;
    status!: string | undefined;
    creationTime!: moment.Moment;
    isRead!: boolean;

    constructor(data?: IGoToWebhookNotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.eventName = _data["eventName"];
            this.status = _data["status"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.isRead = _data["isRead"];
        }
    }

    static fromJS(data: any): GoToWebhookNotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new GoToWebhookNotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["eventName"] = this.eventName;
        data["status"] = this.status;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["isRead"] = this.isRead;
        return data;
    }

    clone(): GoToWebhookNotificationDto {
        const json = this.toJSON();
        let result = new GoToWebhookNotificationDto();
        result.init(json);
        return result;
    }
}

export interface IGoToWebhookNotificationDto {
    id: number;
    eventName: string | undefined;
    status: string | undefined;
    creationTime: moment.Moment;
    isRead: boolean;
}

export class GoToWebinarSetting implements IGoToWebinarSetting {
    clientId!: string | undefined;
    secret!: string | undefined;

    constructor(data?: IGoToWebinarSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.secret = _data["secret"];
        }
    }

    static fromJS(data: any): GoToWebinarSetting {
        data = typeof data === 'object' ? data : {};
        let result = new GoToWebinarSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["secret"] = this.secret;
        return data;
    }

    clone(): GoToWebinarSetting {
        const json = this.toJSON();
        let result = new GoToWebinarSetting();
        result.init(json);
        return result;
    }
}

export interface IGoToWebinarSetting {
    clientId: string | undefined;
    secret: string | undefined;
}

export class IdentityError implements IIdentityError {
    code!: string | undefined;
    description!: string | undefined;

    constructor(data?: IIdentityError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): IdentityError {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["description"] = this.description;
        return data;
    }

    clone(): IdentityError {
        const json = this.toJSON();
        let result = new IdentityError();
        result.init(json);
        return result;
    }
}

export interface IIdentityError {
    code: string | undefined;
    description: string | undefined;
}

export class IdentityResult implements IIdentityResult {
    readonly succeeded!: boolean;
    readonly errors!: IdentityError[] | undefined;

    constructor(data?: IIdentityResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(IdentityError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IdentityResult {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }

    clone(): IdentityResult {
        const json = this.toJSON();
        let result = new IdentityResult();
        result.init(json);
        return result;
    }
}

export interface IIdentityResult {
    succeeded: boolean;
    errors: IdentityError[] | undefined;
}

export class IEventData implements IIEventData {
    eventTime!: moment.Moment;
    eventSource!: any | undefined;

    constructor(data?: IIEventData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventTime = _data["eventTime"] ? moment(_data["eventTime"].toString()) : <any>undefined;
            this.eventSource = _data["eventSource"];
        }
    }

    static fromJS(data: any): IEventData {
        data = typeof data === 'object' ? data : {};
        let result = new IEventData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventTime"] = this.eventTime ? this.eventTime.toISOString() : <any>undefined;
        data["eventSource"] = this.eventSource;
        return data;
    }

    clone(): IEventData {
        const json = this.toJSON();
        let result = new IEventData();
        result.init(json);
        return result;
    }
}

export interface IIEventData {
    eventTime: moment.Moment;
    eventSource: any | undefined;
}

export class InfocicaApplicationDto implements IInfocicaApplicationDto {
    id!: number;
    description!: string | undefined;

    constructor(data?: IInfocicaApplicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): InfocicaApplicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new InfocicaApplicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        return data;
    }

    clone(): InfocicaApplicationDto {
        const json = this.toJSON();
        let result = new InfocicaApplicationDto();
        result.init(json);
        return result;
    }
}

export interface IInfocicaApplicationDto {
    id: number;
    description: string | undefined;
}

export class InfocicaApplicationDtoPagedResultDto implements IInfocicaApplicationDtoPagedResultDto {
    items!: InfocicaApplicationDto[] | undefined;
    totalCount!: number;

    constructor(data?: IInfocicaApplicationDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(InfocicaApplicationDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): InfocicaApplicationDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new InfocicaApplicationDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): InfocicaApplicationDtoPagedResultDto {
        const json = this.toJSON();
        let result = new InfocicaApplicationDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IInfocicaApplicationDtoPagedResultDto {
    items: InfocicaApplicationDto[] | undefined;
    totalCount: number;
}

export class InfocicaBeneficiaryDto implements IInfocicaBeneficiaryDto {
    id!: number;
    description!: string | undefined;

    constructor(data?: IInfocicaBeneficiaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): InfocicaBeneficiaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new InfocicaBeneficiaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        return data;
    }

    clone(): InfocicaBeneficiaryDto {
        const json = this.toJSON();
        let result = new InfocicaBeneficiaryDto();
        result.init(json);
        return result;
    }
}

export interface IInfocicaBeneficiaryDto {
    id: number;
    description: string | undefined;
}

export class InfocicaBeneficiaryDtoPagedResultDto implements IInfocicaBeneficiaryDtoPagedResultDto {
    items!: InfocicaBeneficiaryDto[] | undefined;
    totalCount!: number;

    constructor(data?: IInfocicaBeneficiaryDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(InfocicaBeneficiaryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): InfocicaBeneficiaryDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new InfocicaBeneficiaryDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): InfocicaBeneficiaryDtoPagedResultDto {
        const json = this.toJSON();
        let result = new InfocicaBeneficiaryDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IInfocicaBeneficiaryDtoPagedResultDto {
    items: InfocicaBeneficiaryDto[] | undefined;
    totalCount: number;
}

export class InfocicaEligibleExpenditureDto implements IInfocicaEligibleExpenditureDto {
    id!: number;
    description!: string | undefined;

    constructor(data?: IInfocicaEligibleExpenditureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): InfocicaEligibleExpenditureDto {
        data = typeof data === 'object' ? data : {};
        let result = new InfocicaEligibleExpenditureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        return data;
    }

    clone(): InfocicaEligibleExpenditureDto {
        const json = this.toJSON();
        let result = new InfocicaEligibleExpenditureDto();
        result.init(json);
        return result;
    }
}

export interface IInfocicaEligibleExpenditureDto {
    id: number;
    description: string | undefined;
}

export class InfocicaEligibleExpenditureDtoPagedResultDto implements IInfocicaEligibleExpenditureDtoPagedResultDto {
    items!: InfocicaEligibleExpenditureDto[] | undefined;
    totalCount!: number;

    constructor(data?: IInfocicaEligibleExpenditureDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(InfocicaEligibleExpenditureDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): InfocicaEligibleExpenditureDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new InfocicaEligibleExpenditureDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): InfocicaEligibleExpenditureDtoPagedResultDto {
        const json = this.toJSON();
        let result = new InfocicaEligibleExpenditureDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IInfocicaEligibleExpenditureDtoPagedResultDto {
    items: InfocicaEligibleExpenditureDto[] | undefined;
    totalCount: number;
}

export class InfocicaFacilitationDto implements IInfocicaFacilitationDto {
    id!: number;
    description!: string | undefined;

    constructor(data?: IInfocicaFacilitationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): InfocicaFacilitationDto {
        data = typeof data === 'object' ? data : {};
        let result = new InfocicaFacilitationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        return data;
    }

    clone(): InfocicaFacilitationDto {
        const json = this.toJSON();
        let result = new InfocicaFacilitationDto();
        result.init(json);
        return result;
    }
}

export interface IInfocicaFacilitationDto {
    id: number;
    description: string | undefined;
}

export class InfocicaFacilitationDtoPagedResultDto implements IInfocicaFacilitationDtoPagedResultDto {
    items!: InfocicaFacilitationDto[] | undefined;
    totalCount!: number;

    constructor(data?: IInfocicaFacilitationDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(InfocicaFacilitationDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): InfocicaFacilitationDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new InfocicaFacilitationDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): InfocicaFacilitationDtoPagedResultDto {
        const json = this.toJSON();
        let result = new InfocicaFacilitationDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IInfocicaFacilitationDtoPagedResultDto {
    items: InfocicaFacilitationDto[] | undefined;
    totalCount: number;
}

export class InfocicaProvinceDto implements IInfocicaProvinceDto {
    id!: number;
    description!: string | undefined;

    constructor(data?: IInfocicaProvinceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): InfocicaProvinceDto {
        data = typeof data === 'object' ? data : {};
        let result = new InfocicaProvinceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        return data;
    }

    clone(): InfocicaProvinceDto {
        const json = this.toJSON();
        let result = new InfocicaProvinceDto();
        result.init(json);
        return result;
    }
}

export interface IInfocicaProvinceDto {
    id: number;
    description: string | undefined;
}

export class InfocicaProvinceDtoPagedResultDto implements IInfocicaProvinceDtoPagedResultDto {
    items!: InfocicaProvinceDto[] | undefined;
    totalCount!: number;

    constructor(data?: IInfocicaProvinceDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(InfocicaProvinceDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): InfocicaProvinceDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new InfocicaProvinceDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): InfocicaProvinceDtoPagedResultDto {
        const json = this.toJSON();
        let result = new InfocicaProvinceDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IInfocicaProvinceDtoPagedResultDto {
    items: InfocicaProvinceDto[] | undefined;
    totalCount: number;
}

export class InfocicaRegion implements IInfocicaRegion {
    id!: number;
    description!: string;
    externalCode!: number;

    constructor(data?: IInfocicaRegion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.externalCode = _data["externalCode"];
        }
    }

    static fromJS(data: any): InfocicaRegion {
        data = typeof data === 'object' ? data : {};
        let result = new InfocicaRegion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["externalCode"] = this.externalCode;
        return data;
    }

    clone(): InfocicaRegion {
        const json = this.toJSON();
        let result = new InfocicaRegion();
        result.init(json);
        return result;
    }
}

export interface IInfocicaRegion {
    id: number;
    description: string;
    externalCode: number;
}

export class InfocicaRegionDto implements IInfocicaRegionDto {
    id!: number;
    description!: string | undefined;

    constructor(data?: IInfocicaRegionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): InfocicaRegionDto {
        data = typeof data === 'object' ? data : {};
        let result = new InfocicaRegionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        return data;
    }

    clone(): InfocicaRegionDto {
        const json = this.toJSON();
        let result = new InfocicaRegionDto();
        result.init(json);
        return result;
    }
}

export interface IInfocicaRegionDto {
    id: number;
    description: string | undefined;
}

export class InfocicaRegionDtoPagedResultDto implements IInfocicaRegionDtoPagedResultDto {
    items!: InfocicaRegionDto[] | undefined;
    totalCount!: number;

    constructor(data?: IInfocicaRegionDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(InfocicaRegionDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): InfocicaRegionDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new InfocicaRegionDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): InfocicaRegionDtoPagedResultDto {
        const json = this.toJSON();
        let result = new InfocicaRegionDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IInfocicaRegionDtoPagedResultDto {
    items: InfocicaRegionDto[] | undefined;
    totalCount: number;
}

export class Int64EntityDto implements IInt64EntityDto {
    id!: number;

    constructor(data?: IInt64EntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Int64EntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new Int64EntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): Int64EntityDto {
        const json = this.toJSON();
        let result = new Int64EntityDto();
        result.init(json);
        return result;
    }
}

export interface IInt64EntityDto {
    id: number;
}

export class IsTenantAvailableInput implements IIsTenantAvailableInput {
    tenancyName!: string;

    constructor(data?: IIsTenantAvailableInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): IsTenantAvailableInput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        return data;
    }

    clone(): IsTenantAvailableInput {
        const json = this.toJSON();
        let result = new IsTenantAvailableInput();
        result.init(json);
        return result;
    }
}

export interface IIsTenantAvailableInput {
    tenancyName: string;
}

export class IsTenantAvailableOutput implements IIsTenantAvailableOutput {
    state!: TenantAvailabilityState;
    tenantId!: number | undefined;

    constructor(data?: IIsTenantAvailableOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): IsTenantAvailableOutput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["tenantId"] = this.tenantId;
        return data;
    }

    clone(): IsTenantAvailableOutput {
        const json = this.toJSON();
        let result = new IsTenantAvailableOutput();
        result.init(json);
        return result;
    }
}

export interface IIsTenantAvailableOutput {
    state: TenantAvailabilityState;
    tenantId: number | undefined;
}

export class MostActiveCompanyDto implements IMostActiveCompanyDto {
    company!: CompanyDto;
    score!: number;

    constructor(data?: IMostActiveCompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"] ? CompanyDto.fromJS(_data["company"]) : <any>undefined;
            this.score = _data["score"];
        }
    }

    static fromJS(data: any): MostActiveCompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new MostActiveCompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["score"] = this.score;
        return data;
    }

    clone(): MostActiveCompanyDto {
        const json = this.toJSON();
        let result = new MostActiveCompanyDto();
        result.init(json);
        return result;
    }
}

export interface IMostActiveCompanyDto {
    company: CompanyDto;
    score: number;
}

export class MostActiveUserDto implements IMostActiveUserDto {
    user!: BaseUserWithCompanyDto;
    score!: number;

    constructor(data?: IMostActiveUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? BaseUserWithCompanyDto.fromJS(_data["user"]) : <any>undefined;
            this.score = _data["score"];
        }
    }

    static fromJS(data: any): MostActiveUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new MostActiveUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["score"] = this.score;
        return data;
    }

    clone(): MostActiveUserDto {
        const json = this.toJSON();
        let result = new MostActiveUserDto();
        result.init(json);
        return result;
    }
}

export interface IMostActiveUserDto {
    user: BaseUserWithCompanyDto;
    score: number;
}

export class MostPopularContractDto implements IMostPopularContractDto {
    contract!: ContractBaseDto;
    viewCount!: number;

    constructor(data?: IMostPopularContractDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contract = _data["contract"] ? ContractBaseDto.fromJS(_data["contract"]) : <any>undefined;
            this.viewCount = _data["viewCount"];
        }
    }

    static fromJS(data: any): MostPopularContractDto {
        data = typeof data === 'object' ? data : {};
        let result = new MostPopularContractDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contract"] = this.contract ? this.contract.toJSON() : <any>undefined;
        data["viewCount"] = this.viewCount;
        return data;
    }

    clone(): MostPopularContractDto {
        const json = this.toJSON();
        let result = new MostPopularContractDto();
        result.init(json);
        return result;
    }
}

export interface IMostPopularContractDto {
    contract: ContractBaseDto;
    viewCount: number;
}

export class MostPopularContractFiltersDto implements IMostPopularContractFiltersDto {
    applications!: ApplicationPopularFilterDto[] | undefined;
    beneficiaries!: BeneficiaryPopularFilterDto[] | undefined;
    eligibleExpenditures!: EligibleExpenditurePopularDto[] | undefined;
    facilitations!: FacilitationPopularFilterDto[] | undefined;
    regions!: RegionPopularFilterDto[] | undefined;
    applicationPopularFilterCount!: number;
    beneficiaryPopularFilterCount!: number;
    eligibleExpenditureFilterCount!: number;
    facilitationPopularFilterCount!: number;
    regionPopularFilterCount!: number;

    constructor(data?: IMostPopularContractFiltersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["applications"])) {
                this.applications = [] as any;
                for (let item of _data["applications"])
                    this.applications!.push(ApplicationPopularFilterDto.fromJS(item));
            }
            if (Array.isArray(_data["beneficiaries"])) {
                this.beneficiaries = [] as any;
                for (let item of _data["beneficiaries"])
                    this.beneficiaries!.push(BeneficiaryPopularFilterDto.fromJS(item));
            }
            if (Array.isArray(_data["eligibleExpenditures"])) {
                this.eligibleExpenditures = [] as any;
                for (let item of _data["eligibleExpenditures"])
                    this.eligibleExpenditures!.push(EligibleExpenditurePopularDto.fromJS(item));
            }
            if (Array.isArray(_data["facilitations"])) {
                this.facilitations = [] as any;
                for (let item of _data["facilitations"])
                    this.facilitations!.push(FacilitationPopularFilterDto.fromJS(item));
            }
            if (Array.isArray(_data["regions"])) {
                this.regions = [] as any;
                for (let item of _data["regions"])
                    this.regions!.push(RegionPopularFilterDto.fromJS(item));
            }
            this.applicationPopularFilterCount = _data["applicationPopularFilterCount"];
            this.beneficiaryPopularFilterCount = _data["beneficiaryPopularFilterCount"];
            this.eligibleExpenditureFilterCount = _data["eligibleExpenditureFilterCount"];
            this.facilitationPopularFilterCount = _data["facilitationPopularFilterCount"];
            this.regionPopularFilterCount = _data["regionPopularFilterCount"];
        }
    }

    static fromJS(data: any): MostPopularContractFiltersDto {
        data = typeof data === 'object' ? data : {};
        let result = new MostPopularContractFiltersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.applications)) {
            data["applications"] = [];
            for (let item of this.applications)
                data["applications"].push(item.toJSON());
        }
        if (Array.isArray(this.beneficiaries)) {
            data["beneficiaries"] = [];
            for (let item of this.beneficiaries)
                data["beneficiaries"].push(item.toJSON());
        }
        if (Array.isArray(this.eligibleExpenditures)) {
            data["eligibleExpenditures"] = [];
            for (let item of this.eligibleExpenditures)
                data["eligibleExpenditures"].push(item.toJSON());
        }
        if (Array.isArray(this.facilitations)) {
            data["facilitations"] = [];
            for (let item of this.facilitations)
                data["facilitations"].push(item.toJSON());
        }
        if (Array.isArray(this.regions)) {
            data["regions"] = [];
            for (let item of this.regions)
                data["regions"].push(item.toJSON());
        }
        data["applicationPopularFilterCount"] = this.applicationPopularFilterCount;
        data["beneficiaryPopularFilterCount"] = this.beneficiaryPopularFilterCount;
        data["eligibleExpenditureFilterCount"] = this.eligibleExpenditureFilterCount;
        data["facilitationPopularFilterCount"] = this.facilitationPopularFilterCount;
        data["regionPopularFilterCount"] = this.regionPopularFilterCount;
        return data;
    }

    clone(): MostPopularContractFiltersDto {
        const json = this.toJSON();
        let result = new MostPopularContractFiltersDto();
        result.init(json);
        return result;
    }
}

export interface IMostPopularContractFiltersDto {
    applications: ApplicationPopularFilterDto[] | undefined;
    beneficiaries: BeneficiaryPopularFilterDto[] | undefined;
    eligibleExpenditures: EligibleExpenditurePopularDto[] | undefined;
    facilitations: FacilitationPopularFilterDto[] | undefined;
    regions: RegionPopularFilterDto[] | undefined;
    applicationPopularFilterCount: number;
    beneficiaryPopularFilterCount: number;
    eligibleExpenditureFilterCount: number;
    facilitationPopularFilterCount: number;
    regionPopularFilterCount: number;
}

export class MostPopularTrainingCourseDto implements IMostPopularTrainingCourseDto {
    trainingCourse!: TrainingCourseBaseDto;
    viewCount!: number;

    constructor(data?: IMostPopularTrainingCourseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trainingCourse = _data["trainingCourse"] ? TrainingCourseBaseDto.fromJS(_data["trainingCourse"]) : <any>undefined;
            this.viewCount = _data["viewCount"];
        }
    }

    static fromJS(data: any): MostPopularTrainingCourseDto {
        data = typeof data === 'object' ? data : {};
        let result = new MostPopularTrainingCourseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trainingCourse"] = this.trainingCourse ? this.trainingCourse.toJSON() : <any>undefined;
        data["viewCount"] = this.viewCount;
        return data;
    }

    clone(): MostPopularTrainingCourseDto {
        const json = this.toJSON();
        let result = new MostPopularTrainingCourseDto();
        result.init(json);
        return result;
    }
}

export interface IMostPopularTrainingCourseDto {
    trainingCourse: TrainingCourseBaseDto;
    viewCount: number;
}

export class MostPopularTrainingCourseTopicFiltersDto implements IMostPopularTrainingCourseTopicFiltersDto {
    trainingCourseTopics!: TrainingCourseTopicFilterDto[] | undefined;
    trainingCourseTopicsFilterCount!: number;

    constructor(data?: IMostPopularTrainingCourseTopicFiltersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["trainingCourseTopics"])) {
                this.trainingCourseTopics = [] as any;
                for (let item of _data["trainingCourseTopics"])
                    this.trainingCourseTopics!.push(TrainingCourseTopicFilterDto.fromJS(item));
            }
            this.trainingCourseTopicsFilterCount = _data["trainingCourseTopicsFilterCount"];
        }
    }

    static fromJS(data: any): MostPopularTrainingCourseTopicFiltersDto {
        data = typeof data === 'object' ? data : {};
        let result = new MostPopularTrainingCourseTopicFiltersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.trainingCourseTopics)) {
            data["trainingCourseTopics"] = [];
            for (let item of this.trainingCourseTopics)
                data["trainingCourseTopics"].push(item.toJSON());
        }
        data["trainingCourseTopicsFilterCount"] = this.trainingCourseTopicsFilterCount;
        return data;
    }

    clone(): MostPopularTrainingCourseTopicFiltersDto {
        const json = this.toJSON();
        let result = new MostPopularTrainingCourseTopicFiltersDto();
        result.init(json);
        return result;
    }
}

export interface IMostPopularTrainingCourseTopicFiltersDto {
    trainingCourseTopics: TrainingCourseTopicFilterDto[] | undefined;
    trainingCourseTopicsFilterCount: number;
}

export class NewsDto implements INewsDto {
    id!: number;
    title!: string | undefined;
    imagePath!: string | undefined;
    content!: string | undefined;
    description!: string | undefined;
    publicationDate!: moment.Moment;
    externalCode!: string | undefined;
    creator!: string | undefined;
    url!: string | undefined;

    constructor(data?: INewsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.imagePath = _data["imagePath"];
            this.content = _data["content"];
            this.description = _data["description"];
            this.publicationDate = _data["publicationDate"] ? moment(_data["publicationDate"].toString()) : <any>undefined;
            this.externalCode = _data["externalCode"];
            this.creator = _data["creator"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): NewsDto {
        data = typeof data === 'object' ? data : {};
        let result = new NewsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["imagePath"] = this.imagePath;
        data["content"] = this.content;
        data["description"] = this.description;
        data["publicationDate"] = this.publicationDate ? this.publicationDate.toISOString() : <any>undefined;
        data["externalCode"] = this.externalCode;
        data["creator"] = this.creator;
        data["url"] = this.url;
        return data;
    }

    clone(): NewsDto {
        const json = this.toJSON();
        let result = new NewsDto();
        result.init(json);
        return result;
    }
}

export interface INewsDto {
    id: number;
    title: string | undefined;
    imagePath: string | undefined;
    content: string | undefined;
    description: string | undefined;
    publicationDate: moment.Moment;
    externalCode: string | undefined;
    creator: string | undefined;
    url: string | undefined;
}

export class NewsDtoPagedResultDto implements INewsDtoPagedResultDto {
    items!: NewsDto[] | undefined;
    totalCount!: number;

    constructor(data?: INewsDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(NewsDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): NewsDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new NewsDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): NewsDtoPagedResultDto {
        const json = this.toJSON();
        let result = new NewsDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface INewsDtoPagedResultDto {
    items: NewsDto[] | undefined;
    totalCount: number;
}

export class PagedPlannedEventResultDto implements IPagedPlannedEventResultDto {
    items!: PlannedEventDto[] | undefined;
    totalCount!: number;
    pageNumber!: number | undefined;

    constructor(data?: IPagedPlannedEventResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PlannedEventDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.pageNumber = _data["pageNumber"];
        }
    }

    static fromJS(data: any): PagedPlannedEventResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedPlannedEventResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["pageNumber"] = this.pageNumber;
        return data;
    }

    clone(): PagedPlannedEventResultDto {
        const json = this.toJSON();
        let result = new PagedPlannedEventResultDto();
        result.init(json);
        return result;
    }
}

export interface IPagedPlannedEventResultDto {
    items: PlannedEventDto[] | undefined;
    totalCount: number;
    pageNumber: number | undefined;
}

export class ParticipationModeDto implements IParticipationModeDto {
    id!: number;
    description!: string | undefined;
    staticCode!: number;

    constructor(data?: IParticipationModeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.staticCode = _data["staticCode"];
        }
    }

    static fromJS(data: any): ParticipationModeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipationModeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["staticCode"] = this.staticCode;
        return data;
    }

    clone(): ParticipationModeDto {
        const json = this.toJSON();
        let result = new ParticipationModeDto();
        result.init(json);
        return result;
    }
}

export interface IParticipationModeDto {
    id: number;
    description: string | undefined;
    staticCode: number;
}

export class ParticipationModeDtoPagedResultDto implements IParticipationModeDtoPagedResultDto {
    items!: ParticipationModeDto[] | undefined;
    totalCount!: number;

    constructor(data?: IParticipationModeDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ParticipationModeDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ParticipationModeDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipationModeDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ParticipationModeDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ParticipationModeDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IParticipationModeDtoPagedResultDto {
    items: ParticipationModeDto[] | undefined;
    totalCount: number;
}

export class PermissionDto implements IPermissionDto {
    id!: number;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;

    constructor(data?: IPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): PermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        return data;
    }

    clone(): PermissionDto {
        const json = this.toJSON();
        let result = new PermissionDto();
        result.init(json);
        return result;
    }
}

export interface IPermissionDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
}

export class PermissionDtoListResultDto implements IPermissionDtoListResultDto {
    items!: PermissionDto[] | undefined;

    constructor(data?: IPermissionDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PermissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PermissionDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PermissionDtoListResultDto {
        const json = this.toJSON();
        let result = new PermissionDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IPermissionDtoListResultDto {
    items: PermissionDto[] | undefined;
}

export class PlannedEventDto implements IPlannedEventDto {
    id!: number;
    participationMode!: ParticipationModeDto;
    isPublished!: boolean;
    isDiscarded!: boolean;
    googleMapsImage!: FileDto;
    googleMapsUrl!: string | undefined;
    address!: string | undefined;
    notifications!: GoToWebhookNotificationDto[] | undefined;
    currentUserSubscription!: PlannedEventUserDto;
    numberOfRegisteredUsers!: number;
    startDate!: moment.Moment;
    endDate!: moment.Moment;
    subject!: string | undefined;
    description!: string | undefined;
    registrationUrl!: string | undefined;

    constructor(data?: IPlannedEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.participationMode = _data["participationMode"] ? ParticipationModeDto.fromJS(_data["participationMode"]) : <any>undefined;
            this.isPublished = _data["isPublished"];
            this.isDiscarded = _data["isDiscarded"];
            this.googleMapsImage = _data["googleMapsImage"] ? FileDto.fromJS(_data["googleMapsImage"]) : <any>undefined;
            this.googleMapsUrl = _data["googleMapsUrl"];
            this.address = _data["address"];
            if (Array.isArray(_data["notifications"])) {
                this.notifications = [] as any;
                for (let item of _data["notifications"])
                    this.notifications!.push(GoToWebhookNotificationDto.fromJS(item));
            }
            this.currentUserSubscription = _data["currentUserSubscription"] ? PlannedEventUserDto.fromJS(_data["currentUserSubscription"]) : <any>undefined;
            this.numberOfRegisteredUsers = _data["numberOfRegisteredUsers"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.subject = _data["subject"];
            this.description = _data["description"];
            this.registrationUrl = _data["registrationUrl"];
        }
    }

    static fromJS(data: any): PlannedEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlannedEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["participationMode"] = this.participationMode ? this.participationMode.toJSON() : <any>undefined;
        data["isPublished"] = this.isPublished;
        data["isDiscarded"] = this.isDiscarded;
        data["googleMapsImage"] = this.googleMapsImage ? this.googleMapsImage.toJSON() : <any>undefined;
        data["googleMapsUrl"] = this.googleMapsUrl;
        data["address"] = this.address;
        if (Array.isArray(this.notifications)) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item.toJSON());
        }
        data["currentUserSubscription"] = this.currentUserSubscription ? this.currentUserSubscription.toJSON() : <any>undefined;
        data["numberOfRegisteredUsers"] = this.numberOfRegisteredUsers;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["subject"] = this.subject;
        data["description"] = this.description;
        data["registrationUrl"] = this.registrationUrl;
        return data;
    }

    clone(): PlannedEventDto {
        const json = this.toJSON();
        let result = new PlannedEventDto();
        result.init(json);
        return result;
    }
}

export interface IPlannedEventDto {
    id: number;
    participationMode: ParticipationModeDto;
    isPublished: boolean;
    isDiscarded: boolean;
    googleMapsImage: FileDto;
    googleMapsUrl: string | undefined;
    address: string | undefined;
    notifications: GoToWebhookNotificationDto[] | undefined;
    currentUserSubscription: PlannedEventUserDto;
    numberOfRegisteredUsers: number;
    startDate: moment.Moment;
    endDate: moment.Moment;
    subject: string | undefined;
    description: string | undefined;
    registrationUrl: string | undefined;
}

export class PlannedEventUserDto implements IPlannedEventUserDto {
    id!: number;
    user!: BaseUserDto;
    participationMode!: ParticipationModeDto;
    synchronizationDate!: moment.Moment | undefined;
    registrationDate!: moment.Moment | undefined;
    joinUrl!: string | undefined;
    creationTime!: moment.Moment;

    constructor(data?: IPlannedEventUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.user = _data["user"] ? BaseUserDto.fromJS(_data["user"]) : <any>undefined;
            this.participationMode = _data["participationMode"] ? ParticipationModeDto.fromJS(_data["participationMode"]) : <any>undefined;
            this.synchronizationDate = _data["synchronizationDate"] ? moment(_data["synchronizationDate"].toString()) : <any>undefined;
            this.registrationDate = _data["registrationDate"] ? moment(_data["registrationDate"].toString()) : <any>undefined;
            this.joinUrl = _data["joinUrl"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PlannedEventUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlannedEventUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["participationMode"] = this.participationMode ? this.participationMode.toJSON() : <any>undefined;
        data["synchronizationDate"] = this.synchronizationDate ? this.synchronizationDate.toISOString() : <any>undefined;
        data["registrationDate"] = this.registrationDate ? this.registrationDate.toISOString() : <any>undefined;
        data["joinUrl"] = this.joinUrl;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): PlannedEventUserDto {
        const json = this.toJSON();
        let result = new PlannedEventUserDto();
        result.init(json);
        return result;
    }
}

export interface IPlannedEventUserDto {
    id: number;
    user: BaseUserDto;
    participationMode: ParticipationModeDto;
    synchronizationDate: moment.Moment | undefined;
    registrationDate: moment.Moment | undefined;
    joinUrl: string | undefined;
    creationTime: moment.Moment;
}

export class PlannedEventUserDtoPagedResultDto implements IPlannedEventUserDtoPagedResultDto {
    items!: PlannedEventUserDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPlannedEventUserDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PlannedEventUserDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PlannedEventUserDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlannedEventUserDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PlannedEventUserDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PlannedEventUserDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPlannedEventUserDtoPagedResultDto {
    items: PlannedEventUserDto[] | undefined;
    totalCount: number;
}

export class RegionPopularFilterDto implements IRegionPopularFilterDto {
    region!: InfocicaRegionDto;
    userCount!: number;

    constructor(data?: IRegionPopularFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.region = _data["region"] ? InfocicaRegionDto.fromJS(_data["region"]) : <any>undefined;
            this.userCount = _data["userCount"];
        }
    }

    static fromJS(data: any): RegionPopularFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegionPopularFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["region"] = this.region ? this.region.toJSON() : <any>undefined;
        data["userCount"] = this.userCount;
        return data;
    }

    clone(): RegionPopularFilterDto {
        const json = this.toJSON();
        let result = new RegionPopularFilterDto();
        result.init(json);
        return result;
    }
}

export interface IRegionPopularFilterDto {
    region: InfocicaRegionDto;
    userCount: number;
}

export class RegionReportDto implements IRegionReportDto {
    region!: InfocicaRegionDto;
    selectedByCompanyCount!: number;

    constructor(data?: IRegionReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.region = _data["region"] ? InfocicaRegionDto.fromJS(_data["region"]) : <any>undefined;
            this.selectedByCompanyCount = _data["selectedByCompanyCount"];
        }
    }

    static fromJS(data: any): RegionReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegionReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["region"] = this.region ? this.region.toJSON() : <any>undefined;
        data["selectedByCompanyCount"] = this.selectedByCompanyCount;
        return data;
    }

    clone(): RegionReportDto {
        const json = this.toJSON();
        let result = new RegionReportDto();
        result.init(json);
        return result;
    }
}

export interface IRegionReportDto {
    region: InfocicaRegionDto;
    selectedByCompanyCount: number;
}

export class RegisterInput implements IRegisterInput {
    name!: string;
    surname!: string;
    userName!: string | undefined;
    sectorId!: number;
    regionId!: number | undefined;
    companyFiscalCode!: string;
    businessName!: string;
    emailAddress!: string;
    password!: string;
    isNewsletterActivated!: boolean;
    isPersonalConsentDataActivated!: boolean;
    recaptchaToken!: string | undefined;
    subscribePlannedEvents!: SubscribePlannedEventDto[] | undefined;

    constructor(data?: IRegisterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.sectorId = _data["sectorId"];
            this.regionId = _data["regionId"];
            this.companyFiscalCode = _data["companyFiscalCode"];
            this.businessName = _data["businessName"];
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
            this.isNewsletterActivated = _data["isNewsletterActivated"];
            this.isPersonalConsentDataActivated = _data["isPersonalConsentDataActivated"];
            this.recaptchaToken = _data["recaptchaToken"];
            if (Array.isArray(_data["subscribePlannedEvents"])) {
                this.subscribePlannedEvents = [] as any;
                for (let item of _data["subscribePlannedEvents"])
                    this.subscribePlannedEvents!.push(SubscribePlannedEventDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RegisterInput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["sectorId"] = this.sectorId;
        data["regionId"] = this.regionId;
        data["companyFiscalCode"] = this.companyFiscalCode;
        data["businessName"] = this.businessName;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["isNewsletterActivated"] = this.isNewsletterActivated;
        data["isPersonalConsentDataActivated"] = this.isPersonalConsentDataActivated;
        data["recaptchaToken"] = this.recaptchaToken;
        if (Array.isArray(this.subscribePlannedEvents)) {
            data["subscribePlannedEvents"] = [];
            for (let item of this.subscribePlannedEvents)
                data["subscribePlannedEvents"].push(item.toJSON());
        }
        return data;
    }

    clone(): RegisterInput {
        const json = this.toJSON();
        let result = new RegisterInput();
        result.init(json);
        return result;
    }
}

export interface IRegisterInput {
    name: string;
    surname: string;
    userName: string | undefined;
    sectorId: number;
    regionId: number | undefined;
    companyFiscalCode: string;
    businessName: string;
    emailAddress: string;
    password: string;
    isNewsletterActivated: boolean;
    isPersonalConsentDataActivated: boolean;
    recaptchaToken: string | undefined;
    subscribePlannedEvents: SubscribePlannedEventDto[] | undefined;
}

export class RegisterOutput implements IRegisterOutput {
    companyFiscalCode!: string | undefined;
    businessName!: string | undefined;
    emailAddress!: string | undefined;

    constructor(data?: IRegisterOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyFiscalCode = _data["companyFiscalCode"];
            this.businessName = _data["businessName"];
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): RegisterOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyFiscalCode"] = this.companyFiscalCode;
        data["businessName"] = this.businessName;
        data["emailAddress"] = this.emailAddress;
        return data;
    }

    clone(): RegisterOutput {
        const json = this.toJSON();
        let result = new RegisterOutput();
        result.init(json);
        return result;
    }
}

export interface IRegisterOutput {
    companyFiscalCode: string | undefined;
    businessName: string | undefined;
    emailAddress: string | undefined;
}

export class ResetPasswordResultDto implements IResetPasswordResultDto {
    result!: IdentityResult;
    userId!: number;
    isUserActive!: boolean;

    constructor(data?: IResetPasswordResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? IdentityResult.fromJS(_data["result"]) : <any>undefined;
            this.userId = _data["userId"];
            this.isUserActive = _data["isUserActive"];
        }
    }

    static fromJS(data: any): ResetPasswordResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["isUserActive"] = this.isUserActive;
        return data;
    }

    clone(): ResetPasswordResultDto {
        const json = this.toJSON();
        let result = new ResetPasswordResultDto();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordResultDto {
    result: IdentityResult;
    userId: number;
    isUserActive: boolean;
}

export class RoleDto implements IRoleDto {
    id!: number;
    name!: string;
    displayName!: string;
    normalizedName!: string | undefined;
    description!: string | undefined;
    grantedPermissions!: string[] | undefined;

    constructor(data?: IRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.description = _data["description"];
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions!.push(item);
            }
        }
    }

    static fromJS(data: any): RoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        return data;
    }

    clone(): RoleDto {
        const json = this.toJSON();
        let result = new RoleDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDto {
    id: number;
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
}

export class RoleDtoPagedResultDto implements IRoleDtoPagedResultDto {
    items!: RoleDto[] | undefined;
    totalCount!: number;

    constructor(data?: IRoleDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RoleDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): RoleDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): RoleDtoPagedResultDto {
        const json = this.toJSON();
        let result = new RoleDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDtoPagedResultDto {
    items: RoleDto[] | undefined;
    totalCount: number;
}

export class RoleEditDto implements IRoleEditDto {
    id!: number;
    name!: string;
    displayName!: string;
    description!: string | undefined;
    isStatic!: boolean;

    constructor(data?: IRoleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.isStatic = _data["isStatic"];
        }
    }

    static fromJS(data: any): RoleEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isStatic"] = this.isStatic;
        return data;
    }

    clone(): RoleEditDto {
        const json = this.toJSON();
        let result = new RoleEditDto();
        result.init(json);
        return result;
    }
}

export interface IRoleEditDto {
    id: number;
    name: string;
    displayName: string;
    description: string | undefined;
    isStatic: boolean;
}

export class RoleListDto implements IRoleListDto {
    id!: number;
    name!: string | undefined;
    displayName!: string | undefined;
    isStatic!: boolean;
    isDefault!: boolean;
    creationTime!: moment.Moment;

    constructor(data?: IRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isStatic = _data["isStatic"];
            this.isDefault = _data["isDefault"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isStatic"] = this.isStatic;
        data["isDefault"] = this.isDefault;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): RoleListDto {
        const json = this.toJSON();
        let result = new RoleListDto();
        result.init(json);
        return result;
    }
}

export interface IRoleListDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean;
    isDefault: boolean;
    creationTime: moment.Moment;
}

export class RoleListDtoListResultDto implements IRoleListDtoListResultDto {
    items!: RoleListDto[] | undefined;

    constructor(data?: IRoleListDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleListDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): RoleListDtoListResultDto {
        const json = this.toJSON();
        let result = new RoleListDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleListDtoListResultDto {
    items: RoleListDto[] | undefined;
}

export class SaveSelectedAnswersInput implements ISaveSelectedAnswersInput {
    compilationId!: number;
    questionId!: number;
    selectedAnswerIds!: number[];

    constructor(data?: ISaveSelectedAnswersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.selectedAnswerIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.compilationId = _data["compilationId"];
            this.questionId = _data["questionId"];
            if (Array.isArray(_data["selectedAnswerIds"])) {
                this.selectedAnswerIds = [] as any;
                for (let item of _data["selectedAnswerIds"])
                    this.selectedAnswerIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SaveSelectedAnswersInput {
        data = typeof data === 'object' ? data : {};
        let result = new SaveSelectedAnswersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["compilationId"] = this.compilationId;
        data["questionId"] = this.questionId;
        if (Array.isArray(this.selectedAnswerIds)) {
            data["selectedAnswerIds"] = [];
            for (let item of this.selectedAnswerIds)
                data["selectedAnswerIds"].push(item);
        }
        return data;
    }

    clone(): SaveSelectedAnswersInput {
        const json = this.toJSON();
        let result = new SaveSelectedAnswersInput();
        result.init(json);
        return result;
    }
}

export interface ISaveSelectedAnswersInput {
    compilationId: number;
    questionId: number;
    selectedAnswerIds: number[];
}

export class SaveSelectedAnswersResultDto implements ISaveSelectedAnswersResultDto {
    sectionsCompletedIds!: number[] | undefined;
    surveyCompletionPercentage!: number;

    constructor(data?: ISaveSelectedAnswersResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sectionsCompletedIds"])) {
                this.sectionsCompletedIds = [] as any;
                for (let item of _data["sectionsCompletedIds"])
                    this.sectionsCompletedIds!.push(item);
            }
            this.surveyCompletionPercentage = _data["surveyCompletionPercentage"];
        }
    }

    static fromJS(data: any): SaveSelectedAnswersResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveSelectedAnswersResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sectionsCompletedIds)) {
            data["sectionsCompletedIds"] = [];
            for (let item of this.sectionsCompletedIds)
                data["sectionsCompletedIds"].push(item);
        }
        data["surveyCompletionPercentage"] = this.surveyCompletionPercentage;
        return data;
    }

    clone(): SaveSelectedAnswersResultDto {
        const json = this.toJSON();
        let result = new SaveSelectedAnswersResultDto();
        result.init(json);
        return result;
    }
}

export interface ISaveSelectedAnswersResultDto {
    sectionsCompletedIds: number[] | undefined;
    surveyCompletionPercentage: number;
}

export class SectionFinalScoreDto implements ISectionFinalScoreDto {
    finalPoints!: number;
    percentage!: number;
    name!: string | undefined;
    sectionId!: number;
    index!: number;

    constructor(data?: ISectionFinalScoreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.finalPoints = _data["finalPoints"];
            this.percentage = _data["percentage"];
            this.name = _data["name"];
            this.sectionId = _data["sectionId"];
            this.index = _data["index"];
        }
    }

    static fromJS(data: any): SectionFinalScoreDto {
        data = typeof data === 'object' ? data : {};
        let result = new SectionFinalScoreDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["finalPoints"] = this.finalPoints;
        data["percentage"] = this.percentage;
        data["name"] = this.name;
        data["sectionId"] = this.sectionId;
        data["index"] = this.index;
        return data;
    }

    clone(): SectionFinalScoreDto {
        const json = this.toJSON();
        let result = new SectionFinalScoreDto();
        result.init(json);
        return result;
    }
}

export interface ISectionFinalScoreDto {
    finalPoints: number;
    percentage: number;
    name: string | undefined;
    sectionId: number;
    index: number;
}

export class Sector implements ISector {
    id!: number;
    description!: string;

    constructor(data?: ISector) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): Sector {
        data = typeof data === 'object' ? data : {};
        let result = new Sector();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        return data;
    }

    clone(): Sector {
        const json = this.toJSON();
        let result = new Sector();
        result.init(json);
        return result;
    }
}

export interface ISector {
    id: number;
    description: string;
}

export class SectorDto implements ISectorDto {
    id!: number;
    description!: string | undefined;

    constructor(data?: ISectorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): SectorDto {
        data = typeof data === 'object' ? data : {};
        let result = new SectorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        return data;
    }

    clone(): SectorDto {
        const json = this.toJSON();
        let result = new SectorDto();
        result.init(json);
        return result;
    }
}

export interface ISectorDto {
    id: number;
    description: string | undefined;
}

export class SectorDtoPagedResultDto implements ISectorDtoPagedResultDto {
    items!: SectorDto[] | undefined;
    totalCount!: number;

    constructor(data?: ISectorDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SectorDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): SectorDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SectorDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): SectorDtoPagedResultDto {
        const json = this.toJSON();
        let result = new SectorDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ISectorDtoPagedResultDto {
    items: SectorDto[] | undefined;
    totalCount: number;
}

export class SectorReportDto implements ISectorReportDto {
    sector!: SectorDto;
    selectedByCompanyCount!: number;

    constructor(data?: ISectorReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sector = _data["sector"] ? SectorDto.fromJS(_data["sector"]) : <any>undefined;
            this.selectedByCompanyCount = _data["selectedByCompanyCount"];
        }
    }

    static fromJS(data: any): SectorReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new SectorReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sector"] = this.sector ? this.sector.toJSON() : <any>undefined;
        data["selectedByCompanyCount"] = this.selectedByCompanyCount;
        return data;
    }

    clone(): SectorReportDto {
        const json = this.toJSON();
        let result = new SectorReportDto();
        result.init(json);
        return result;
    }
}

export interface ISectorReportDto {
    sector: SectorDto;
    selectedByCompanyCount: number;
}

export class Setting implements ISetting {
    id!: number;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    tenantId!: number | undefined;
    userId!: number | undefined;
    name!: string;
    value!: string | undefined;

    constructor(data?: ISetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Setting {
        data = typeof data === 'object' ? data : {};
        let result = new Setting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }

    clone(): Setting {
        const json = this.toJSON();
        let result = new Setting();
        result.init(json);
        return result;
    }
}

export interface ISetting {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    tenantId: number | undefined;
    userId: number | undefined;
    name: string;
    value: string | undefined;
}

export class SubscribePlannedEventDto implements ISubscribePlannedEventDto {
    plannedEvent!: Int64EntityDto;
    participationMode!: Int64EntityDto;
    firstName!: string;
    lastName!: string;
    organization!: string;
    sectorAnswer!: string;

    constructor(data?: ISubscribePlannedEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plannedEvent = _data["plannedEvent"] ? Int64EntityDto.fromJS(_data["plannedEvent"]) : <any>undefined;
            this.participationMode = _data["participationMode"] ? Int64EntityDto.fromJS(_data["participationMode"]) : <any>undefined;
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.organization = _data["organization"];
            this.sectorAnswer = _data["sectorAnswer"];
        }
    }

    static fromJS(data: any): SubscribePlannedEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscribePlannedEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plannedEvent"] = this.plannedEvent ? this.plannedEvent.toJSON() : <any>undefined;
        data["participationMode"] = this.participationMode ? this.participationMode.toJSON() : <any>undefined;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["organization"] = this.organization;
        data["sectorAnswer"] = this.sectorAnswer;
        return data;
    }

    clone(): SubscribePlannedEventDto {
        const json = this.toJSON();
        let result = new SubscribePlannedEventDto();
        result.init(json);
        return result;
    }
}

export interface ISubscribePlannedEventDto {
    plannedEvent: Int64EntityDto;
    participationMode: Int64EntityDto;
    firstName: string;
    lastName: string;
    organization: string;
    sectorAnswer: string;
}

export class SurveyAnswerDto implements ISurveyAnswerDto {
    id!: number;
    answerType!: SurveyAnswerTypeDto;
    questionId!: number;
    text!: string | undefined;
    index!: number;
    weight!: number;

    constructor(data?: ISurveyAnswerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.answerType = _data["answerType"] ? SurveyAnswerTypeDto.fromJS(_data["answerType"]) : <any>undefined;
            this.questionId = _data["questionId"];
            this.text = _data["text"];
            this.index = _data["index"];
            this.weight = _data["weight"];
        }
    }

    static fromJS(data: any): SurveyAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyAnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["answerType"] = this.answerType ? this.answerType.toJSON() : <any>undefined;
        data["questionId"] = this.questionId;
        data["text"] = this.text;
        data["index"] = this.index;
        data["weight"] = this.weight;
        return data;
    }

    clone(): SurveyAnswerDto {
        const json = this.toJSON();
        let result = new SurveyAnswerDto();
        result.init(json);
        return result;
    }
}

export interface ISurveyAnswerDto {
    id: number;
    answerType: SurveyAnswerTypeDto;
    questionId: number;
    text: string | undefined;
    index: number;
    weight: number;
}

export class SurveyAnswerTypeDto implements ISurveyAnswerTypeDto {
    id!: number;
    description!: string | undefined;
    staticCode!: string | undefined;

    constructor(data?: ISurveyAnswerTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.staticCode = _data["staticCode"];
        }
    }

    static fromJS(data: any): SurveyAnswerTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyAnswerTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["staticCode"] = this.staticCode;
        return data;
    }

    clone(): SurveyAnswerTypeDto {
        const json = this.toJSON();
        let result = new SurveyAnswerTypeDto();
        result.init(json);
        return result;
    }
}

export interface ISurveyAnswerTypeDto {
    id: number;
    description: string | undefined;
    staticCode: string | undefined;
}

export class SurveyBaseDto implements ISurveyBaseDto {
    id!: number;
    name!: string | undefined;
    titlePageLocalizationKey!: string | undefined;
    compilationMessageLocalizationKey!: string | undefined;
    endCompilationMessageLocalizationKey!: string | undefined;
    canSendEmailToCoopera!: boolean;
    staticCode!: string | undefined;

    constructor(data?: ISurveyBaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.titlePageLocalizationKey = _data["titlePageLocalizationKey"];
            this.compilationMessageLocalizationKey = _data["compilationMessageLocalizationKey"];
            this.endCompilationMessageLocalizationKey = _data["endCompilationMessageLocalizationKey"];
            this.canSendEmailToCoopera = _data["canSendEmailToCoopera"];
            this.staticCode = _data["staticCode"];
        }
    }

    static fromJS(data: any): SurveyBaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyBaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["titlePageLocalizationKey"] = this.titlePageLocalizationKey;
        data["compilationMessageLocalizationKey"] = this.compilationMessageLocalizationKey;
        data["endCompilationMessageLocalizationKey"] = this.endCompilationMessageLocalizationKey;
        data["canSendEmailToCoopera"] = this.canSendEmailToCoopera;
        data["staticCode"] = this.staticCode;
        return data;
    }

    clone(): SurveyBaseDto {
        const json = this.toJSON();
        let result = new SurveyBaseDto();
        result.init(json);
        return result;
    }
}

export interface ISurveyBaseDto {
    id: number;
    name: string | undefined;
    titlePageLocalizationKey: string | undefined;
    compilationMessageLocalizationKey: string | undefined;
    endCompilationMessageLocalizationKey: string | undefined;
    canSendEmailToCoopera: boolean;
    staticCode: string | undefined;
}

export class SurveyCompilationCertficationTrainingCourseDto implements ISurveyCompilationCertficationTrainingCourseDto {
    user!: User;
    trainingCourseName!: string | undefined;
    compilationTime!: moment.Moment;

    constructor(data?: ISurveyCompilationCertficationTrainingCourseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.trainingCourseName = _data["trainingCourseName"];
            this.compilationTime = _data["compilationTime"] ? moment(_data["compilationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SurveyCompilationCertficationTrainingCourseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyCompilationCertficationTrainingCourseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["trainingCourseName"] = this.trainingCourseName;
        data["compilationTime"] = this.compilationTime ? this.compilationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): SurveyCompilationCertficationTrainingCourseDto {
        const json = this.toJSON();
        let result = new SurveyCompilationCertficationTrainingCourseDto();
        result.init(json);
        return result;
    }
}

export interface ISurveyCompilationCertficationTrainingCourseDto {
    user: User;
    trainingCourseName: string | undefined;
    compilationTime: moment.Moment;
}

export class SurveyCompilationCompletedDto implements ISurveyCompilationCompletedDto {
    id!: number;
    completionTime!: moment.Moment;

    constructor(data?: ISurveyCompilationCompletedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.completionTime = _data["completionTime"] ? moment(_data["completionTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SurveyCompilationCompletedDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyCompilationCompletedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["completionTime"] = this.completionTime ? this.completionTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): SurveyCompilationCompletedDto {
        const json = this.toJSON();
        let result = new SurveyCompilationCompletedDto();
        result.init(json);
        return result;
    }
}

export interface ISurveyCompilationCompletedDto {
    id: number;
    completionTime: moment.Moment;
}

export class SurveyCompilationFinalScoreDto implements ISurveyCompilationFinalScoreDto {
    sectionsFinalScore!: SectionFinalScoreDto[] | undefined;
    compilationFinalScore!: CompilationFinalScoreDto;

    constructor(data?: ISurveyCompilationFinalScoreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sectionsFinalScore"])) {
                this.sectionsFinalScore = [] as any;
                for (let item of _data["sectionsFinalScore"])
                    this.sectionsFinalScore!.push(SectionFinalScoreDto.fromJS(item));
            }
            this.compilationFinalScore = _data["compilationFinalScore"] ? CompilationFinalScoreDto.fromJS(_data["compilationFinalScore"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SurveyCompilationFinalScoreDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyCompilationFinalScoreDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sectionsFinalScore)) {
            data["sectionsFinalScore"] = [];
            for (let item of this.sectionsFinalScore)
                data["sectionsFinalScore"].push(item.toJSON());
        }
        data["compilationFinalScore"] = this.compilationFinalScore ? this.compilationFinalScore.toJSON() : <any>undefined;
        return data;
    }

    clone(): SurveyCompilationFinalScoreDto {
        const json = this.toJSON();
        let result = new SurveyCompilationFinalScoreDto();
        result.init(json);
        return result;
    }
}

export interface ISurveyCompilationFinalScoreDto {
    sectionsFinalScore: SectionFinalScoreDto[] | undefined;
    compilationFinalScore: CompilationFinalScoreDto;
}

export class SurveyCompilationSectionDto implements ISurveyCompilationSectionDto {
    id!: number;
    name!: string | undefined;
    index!: number;
    isCompleted!: boolean;

    constructor(data?: ISurveyCompilationSectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.index = _data["index"];
            this.isCompleted = _data["isCompleted"];
        }
    }

    static fromJS(data: any): SurveyCompilationSectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyCompilationSectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["index"] = this.index;
        data["isCompleted"] = this.isCompleted;
        return data;
    }

    clone(): SurveyCompilationSectionDto {
        const json = this.toJSON();
        let result = new SurveyCompilationSectionDto();
        result.init(json);
        return result;
    }
}

export interface ISurveyCompilationSectionDto {
    id: number;
    name: string | undefined;
    index: number;
    isCompleted: boolean;
}

export class SurveyDto implements ISurveyDto {
    id!: number;
    name!: string | undefined;
    titlePageLocalizationKey!: string | undefined;
    compilationMessageLocalizationKey!: string | undefined;
    endCompilationMessageLocalizationKey!: string | undefined;
    canSendEmailToCoopera!: boolean;
    staticCode!: string | undefined;

    constructor(data?: ISurveyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.titlePageLocalizationKey = _data["titlePageLocalizationKey"];
            this.compilationMessageLocalizationKey = _data["compilationMessageLocalizationKey"];
            this.endCompilationMessageLocalizationKey = _data["endCompilationMessageLocalizationKey"];
            this.canSendEmailToCoopera = _data["canSendEmailToCoopera"];
            this.staticCode = _data["staticCode"];
        }
    }

    static fromJS(data: any): SurveyDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["titlePageLocalizationKey"] = this.titlePageLocalizationKey;
        data["compilationMessageLocalizationKey"] = this.compilationMessageLocalizationKey;
        data["endCompilationMessageLocalizationKey"] = this.endCompilationMessageLocalizationKey;
        data["canSendEmailToCoopera"] = this.canSendEmailToCoopera;
        data["staticCode"] = this.staticCode;
        return data;
    }

    clone(): SurveyDto {
        const json = this.toJSON();
        let result = new SurveyDto();
        result.init(json);
        return result;
    }
}

export interface ISurveyDto {
    id: number;
    name: string | undefined;
    titlePageLocalizationKey: string | undefined;
    compilationMessageLocalizationKey: string | undefined;
    endCompilationMessageLocalizationKey: string | undefined;
    canSendEmailToCoopera: boolean;
    staticCode: string | undefined;
}

export class SurveyQuestionDto implements ISurveyQuestionDto {
    id!: number;
    questionType!: SurveyQuestionTypeDto;
    text!: string | undefined;
    totalWeight!: number;
    index!: number;
    answers!: SurveyAnswerDto[] | undefined;

    constructor(data?: ISurveyQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.questionType = _data["questionType"] ? SurveyQuestionTypeDto.fromJS(_data["questionType"]) : <any>undefined;
            this.text = _data["text"];
            this.totalWeight = _data["totalWeight"];
            this.index = _data["index"];
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(SurveyAnswerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SurveyQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyQuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["questionType"] = this.questionType ? this.questionType.toJSON() : <any>undefined;
        data["text"] = this.text;
        data["totalWeight"] = this.totalWeight;
        data["index"] = this.index;
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        return data;
    }

    clone(): SurveyQuestionDto {
        const json = this.toJSON();
        let result = new SurveyQuestionDto();
        result.init(json);
        return result;
    }
}

export interface ISurveyQuestionDto {
    id: number;
    questionType: SurveyQuestionTypeDto;
    text: string | undefined;
    totalWeight: number;
    index: number;
    answers: SurveyAnswerDto[] | undefined;
}

export class SurveyQuestionTypeDto implements ISurveyQuestionTypeDto {
    id!: number;
    description!: string | undefined;
    staticCode!: string | undefined;

    constructor(data?: ISurveyQuestionTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.staticCode = _data["staticCode"];
        }
    }

    static fromJS(data: any): SurveyQuestionTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyQuestionTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["staticCode"] = this.staticCode;
        return data;
    }

    clone(): SurveyQuestionTypeDto {
        const json = this.toJSON();
        let result = new SurveyQuestionTypeDto();
        result.init(json);
        return result;
    }
}

export interface ISurveyQuestionTypeDto {
    id: number;
    description: string | undefined;
    staticCode: string | undefined;
}

export class SurveySectionDto implements ISurveySectionDto {
    id!: number;
    name!: string | undefined;
    index!: number;

    constructor(data?: ISurveySectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.index = _data["index"];
        }
    }

    static fromJS(data: any): SurveySectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveySectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["index"] = this.index;
        return data;
    }

    clone(): SurveySectionDto {
        const json = this.toJSON();
        let result = new SurveySectionDto();
        result.init(json);
        return result;
    }
}

export interface ISurveySectionDto {
    id: number;
    name: string | undefined;
    index: number;
}

export enum TenantAvailabilityState {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class TenantDto implements ITenantDto {
    id!: number;
    tenancyName!: string;
    name!: string;
    isActive!: boolean;

    constructor(data?: ITenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): TenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): TenantDto {
        const json = this.toJSON();
        let result = new TenantDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDto {
    id: number;
    tenancyName: string;
    name: string;
    isActive: boolean;
}

export class TenantDtoPagedResultDto implements ITenantDtoPagedResultDto {
    items!: TenantDto[] | undefined;
    totalCount!: number;

    constructor(data?: ITenantDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TenantDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): TenantDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): TenantDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TenantDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDtoPagedResultDto {
    items: TenantDto[] | undefined;
    totalCount: number;
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
    id!: number;
    tenancyName!: string | undefined;
    name!: string | undefined;

    constructor(data?: ITenantLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TenantLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        return data;
    }

    clone(): TenantLoginInfoDto {
        const json = this.toJSON();
        let result = new TenantLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface ITenantLoginInfoDto {
    id: number;
    tenancyName: string | undefined;
    name: string | undefined;
}

export class TimeSpan implements ITimeSpan {
    ticks!: number;
    days!: number;
    hours!: number;
    milliseconds!: number;
    minutes!: number;
    seconds!: number;
    readonly totalDays!: number;
    readonly totalHours!: number;
    readonly totalMilliseconds!: number;
    readonly totalMinutes!: number;
    readonly totalSeconds!: number;

    constructor(data?: ITimeSpan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticks = _data["ticks"];
            this.days = _data["days"];
            this.hours = _data["hours"];
            this.milliseconds = _data["milliseconds"];
            this.minutes = _data["minutes"];
            this.seconds = _data["seconds"];
            (<any>this).totalDays = _data["totalDays"];
            (<any>this).totalHours = _data["totalHours"];
            (<any>this).totalMilliseconds = _data["totalMilliseconds"];
            (<any>this).totalMinutes = _data["totalMinutes"];
            (<any>this).totalSeconds = _data["totalSeconds"];
        }
    }

    static fromJS(data: any): TimeSpan {
        data = typeof data === 'object' ? data : {};
        let result = new TimeSpan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticks"] = this.ticks;
        data["days"] = this.days;
        data["hours"] = this.hours;
        data["milliseconds"] = this.milliseconds;
        data["minutes"] = this.minutes;
        data["seconds"] = this.seconds;
        data["totalDays"] = this.totalDays;
        data["totalHours"] = this.totalHours;
        data["totalMilliseconds"] = this.totalMilliseconds;
        data["totalMinutes"] = this.totalMinutes;
        data["totalSeconds"] = this.totalSeconds;
        return data;
    }

    clone(): TimeSpan {
        const json = this.toJSON();
        let result = new TimeSpan();
        result.init(json);
        return result;
    }
}

export interface ITimeSpan {
    ticks: number;
    days: number;
    hours: number;
    milliseconds: number;
    minutes: number;
    seconds: number;
    totalDays: number;
    totalHours: number;
    totalMilliseconds: number;
    totalMinutes: number;
    totalSeconds: number;
}

export class TrainingCourseBaseDto implements ITrainingCourseBaseDto {
    id!: number;
    name!: string | undefined;
    description!: string | undefined;
    imageThumbnail!: string | undefined;
    image!: string | undefined;
    contentType!: string | undefined;
    completionPercentage!: number;
    isPublished!: boolean;
    creationTime!: moment.Moment;

    constructor(data?: ITrainingCourseBaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.imageThumbnail = _data["imageThumbnail"];
            this.image = _data["image"];
            this.contentType = _data["contentType"];
            this.completionPercentage = _data["completionPercentage"];
            this.isPublished = _data["isPublished"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TrainingCourseBaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingCourseBaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["imageThumbnail"] = this.imageThumbnail;
        data["image"] = this.image;
        data["contentType"] = this.contentType;
        data["completionPercentage"] = this.completionPercentage;
        data["isPublished"] = this.isPublished;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): TrainingCourseBaseDto {
        const json = this.toJSON();
        let result = new TrainingCourseBaseDto();
        result.init(json);
        return result;
    }
}

export interface ITrainingCourseBaseDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
    imageThumbnail: string | undefined;
    image: string | undefined;
    contentType: string | undefined;
    completionPercentage: number;
    isPublished: boolean;
    creationTime: moment.Moment;
}

export class TrainingCourseBaseDtoPagedResultDto implements ITrainingCourseBaseDtoPagedResultDto {
    items!: TrainingCourseBaseDto[] | undefined;
    totalCount!: number;

    constructor(data?: ITrainingCourseBaseDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TrainingCourseBaseDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): TrainingCourseBaseDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingCourseBaseDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): TrainingCourseBaseDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TrainingCourseBaseDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITrainingCourseBaseDtoPagedResultDto {
    items: TrainingCourseBaseDto[] | undefined;
    totalCount: number;
}

export class TrainingCourseContentTypeDto implements ITrainingCourseContentTypeDto {
    id!: number;
    description!: string | undefined;

    constructor(data?: ITrainingCourseContentTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): TrainingCourseContentTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingCourseContentTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        return data;
    }

    clone(): TrainingCourseContentTypeDto {
        const json = this.toJSON();
        let result = new TrainingCourseContentTypeDto();
        result.init(json);
        return result;
    }
}

export interface ITrainingCourseContentTypeDto {
    id: number;
    description: string | undefined;
}

export class TrainingCourseContentTypeDtoPagedResultDto implements ITrainingCourseContentTypeDtoPagedResultDto {
    items!: TrainingCourseContentTypeDto[] | undefined;
    totalCount!: number;

    constructor(data?: ITrainingCourseContentTypeDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TrainingCourseContentTypeDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): TrainingCourseContentTypeDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingCourseContentTypeDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): TrainingCourseContentTypeDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TrainingCourseContentTypeDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITrainingCourseContentTypeDtoPagedResultDto {
    items: TrainingCourseContentTypeDto[] | undefined;
    totalCount: number;
}

export class TrainingCourseDto implements ITrainingCourseDto {
    id!: number;
    name!: string | undefined;
    description!: string | undefined;
    imageBase64!: string | undefined;
    imageThumbnailBase64!: string | undefined;
    image!: FileDto;
    imageThumbnail!: FileDto;
    topic!: TrainingCourseTopicDto;
    contentType!: TrainingCourseContentTypeDto;
    lessons!: TrainingCourseLessonBaseDto[] | undefined;
    completionPercentage!: number;
    isPublished!: boolean;
    creationTime!: moment.Moment;

    constructor(data?: ITrainingCourseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.imageBase64 = _data["imageBase64"];
            this.imageThumbnailBase64 = _data["imageThumbnailBase64"];
            this.image = _data["image"] ? FileDto.fromJS(_data["image"]) : <any>undefined;
            this.imageThumbnail = _data["imageThumbnail"] ? FileDto.fromJS(_data["imageThumbnail"]) : <any>undefined;
            this.topic = _data["topic"] ? TrainingCourseTopicDto.fromJS(_data["topic"]) : <any>undefined;
            this.contentType = _data["contentType"] ? TrainingCourseContentTypeDto.fromJS(_data["contentType"]) : <any>undefined;
            if (Array.isArray(_data["lessons"])) {
                this.lessons = [] as any;
                for (let item of _data["lessons"])
                    this.lessons!.push(TrainingCourseLessonBaseDto.fromJS(item));
            }
            this.completionPercentage = _data["completionPercentage"];
            this.isPublished = _data["isPublished"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TrainingCourseDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingCourseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["imageBase64"] = this.imageBase64;
        data["imageThumbnailBase64"] = this.imageThumbnailBase64;
        data["image"] = this.image ? this.image.toJSON() : <any>undefined;
        data["imageThumbnail"] = this.imageThumbnail ? this.imageThumbnail.toJSON() : <any>undefined;
        data["topic"] = this.topic ? this.topic.toJSON() : <any>undefined;
        data["contentType"] = this.contentType ? this.contentType.toJSON() : <any>undefined;
        if (Array.isArray(this.lessons)) {
            data["lessons"] = [];
            for (let item of this.lessons)
                data["lessons"].push(item.toJSON());
        }
        data["completionPercentage"] = this.completionPercentage;
        data["isPublished"] = this.isPublished;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): TrainingCourseDto {
        const json = this.toJSON();
        let result = new TrainingCourseDto();
        result.init(json);
        return result;
    }
}

export interface ITrainingCourseDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
    imageBase64: string | undefined;
    imageThumbnailBase64: string | undefined;
    image: FileDto;
    imageThumbnail: FileDto;
    topic: TrainingCourseTopicDto;
    contentType: TrainingCourseContentTypeDto;
    lessons: TrainingCourseLessonBaseDto[] | undefined;
    completionPercentage: number;
    isPublished: boolean;
    creationTime: moment.Moment;
}

export class TrainingCourseLessonBaseDto implements ITrainingCourseLessonBaseDto {
    id!: number;
    name!: string | undefined;
    description!: string | undefined;
    teacherName!: string | undefined;
    externalLink!: string | undefined;
    imageBase64Thumbnail!: string | undefined;
    completionTime!: moment.Moment | undefined;
    index!: number;

    constructor(data?: ITrainingCourseLessonBaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.teacherName = _data["teacherName"];
            this.externalLink = _data["externalLink"];
            this.imageBase64Thumbnail = _data["imageBase64Thumbnail"];
            this.completionTime = _data["completionTime"] ? moment(_data["completionTime"].toString()) : <any>undefined;
            this.index = _data["index"];
        }
    }

    static fromJS(data: any): TrainingCourseLessonBaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingCourseLessonBaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["teacherName"] = this.teacherName;
        data["externalLink"] = this.externalLink;
        data["imageBase64Thumbnail"] = this.imageBase64Thumbnail;
        data["completionTime"] = this.completionTime ? this.completionTime.toISOString() : <any>undefined;
        data["index"] = this.index;
        return data;
    }

    clone(): TrainingCourseLessonBaseDto {
        const json = this.toJSON();
        let result = new TrainingCourseLessonBaseDto();
        result.init(json);
        return result;
    }
}

export interface ITrainingCourseLessonBaseDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
    teacherName: string | undefined;
    externalLink: string | undefined;
    imageBase64Thumbnail: string | undefined;
    completionTime: moment.Moment | undefined;
    index: number;
}

export class TrainingCourseLessonChapterDto implements ITrainingCourseLessonChapterDto {
    id!: number;
    description!: string | undefined;
    minute!: string | undefined;
    totalSeconds!: number;

    constructor(data?: ITrainingCourseLessonChapterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.minute = _data["minute"];
            this.totalSeconds = _data["totalSeconds"];
        }
    }

    static fromJS(data: any): TrainingCourseLessonChapterDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingCourseLessonChapterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["minute"] = this.minute;
        data["totalSeconds"] = this.totalSeconds;
        return data;
    }

    clone(): TrainingCourseLessonChapterDto {
        const json = this.toJSON();
        let result = new TrainingCourseLessonChapterDto();
        result.init(json);
        return result;
    }
}

export interface ITrainingCourseLessonChapterDto {
    id: number;
    description: string | undefined;
    minute: string | undefined;
    totalSeconds: number;
}

export class TrainingCourseLessonChapterDtoPagedResultDto implements ITrainingCourseLessonChapterDtoPagedResultDto {
    items!: TrainingCourseLessonChapterDto[] | undefined;
    totalCount!: number;

    constructor(data?: ITrainingCourseLessonChapterDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TrainingCourseLessonChapterDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): TrainingCourseLessonChapterDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingCourseLessonChapterDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): TrainingCourseLessonChapterDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TrainingCourseLessonChapterDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITrainingCourseLessonChapterDtoPagedResultDto {
    items: TrainingCourseLessonChapterDto[] | undefined;
    totalCount: number;
}

export class TrainingCourseLessonDto implements ITrainingCourseLessonDto {
    id!: number;
    trainingCourse!: TrainingCourseBaseDto;
    name!: string | undefined;
    description!: string | undefined;
    videoEmbedded!: string | undefined;
    imageBase64Thumbnail!: string | undefined;
    videoUrl!: string | undefined;
    teacherName!: string | undefined;
    chapters!: TrainingCourseLessonChapterDto[] | undefined;
    externalLink!: string | undefined;
    attachments!: TrainingCourseLessonFileDto[] | undefined;
    completionTime!: moment.Moment | undefined;
    index!: number;
    videoFile!: FileDto;
    imageThumbnail!: FileDto;

    constructor(data?: ITrainingCourseLessonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.trainingCourse = _data["trainingCourse"] ? TrainingCourseBaseDto.fromJS(_data["trainingCourse"]) : <any>undefined;
            this.name = _data["name"];
            this.description = _data["description"];
            this.videoEmbedded = _data["videoEmbedded"];
            this.imageBase64Thumbnail = _data["imageBase64Thumbnail"];
            this.videoUrl = _data["videoUrl"];
            this.teacherName = _data["teacherName"];
            if (Array.isArray(_data["chapters"])) {
                this.chapters = [] as any;
                for (let item of _data["chapters"])
                    this.chapters!.push(TrainingCourseLessonChapterDto.fromJS(item));
            }
            this.externalLink = _data["externalLink"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(TrainingCourseLessonFileDto.fromJS(item));
            }
            this.completionTime = _data["completionTime"] ? moment(_data["completionTime"].toString()) : <any>undefined;
            this.index = _data["index"];
            this.videoFile = _data["videoFile"] ? FileDto.fromJS(_data["videoFile"]) : <any>undefined;
            this.imageThumbnail = _data["imageThumbnail"] ? FileDto.fromJS(_data["imageThumbnail"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TrainingCourseLessonDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingCourseLessonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["trainingCourse"] = this.trainingCourse ? this.trainingCourse.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["description"] = this.description;
        data["videoEmbedded"] = this.videoEmbedded;
        data["imageBase64Thumbnail"] = this.imageBase64Thumbnail;
        data["videoUrl"] = this.videoUrl;
        data["teacherName"] = this.teacherName;
        if (Array.isArray(this.chapters)) {
            data["chapters"] = [];
            for (let item of this.chapters)
                data["chapters"].push(item.toJSON());
        }
        data["externalLink"] = this.externalLink;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        data["completionTime"] = this.completionTime ? this.completionTime.toISOString() : <any>undefined;
        data["index"] = this.index;
        data["videoFile"] = this.videoFile ? this.videoFile.toJSON() : <any>undefined;
        data["imageThumbnail"] = this.imageThumbnail ? this.imageThumbnail.toJSON() : <any>undefined;
        return data;
    }

    clone(): TrainingCourseLessonDto {
        const json = this.toJSON();
        let result = new TrainingCourseLessonDto();
        result.init(json);
        return result;
    }
}

export interface ITrainingCourseLessonDto {
    id: number;
    trainingCourse: TrainingCourseBaseDto;
    name: string | undefined;
    description: string | undefined;
    videoEmbedded: string | undefined;
    imageBase64Thumbnail: string | undefined;
    videoUrl: string | undefined;
    teacherName: string | undefined;
    chapters: TrainingCourseLessonChapterDto[] | undefined;
    externalLink: string | undefined;
    attachments: TrainingCourseLessonFileDto[] | undefined;
    completionTime: moment.Moment | undefined;
    index: number;
    videoFile: FileDto;
    imageThumbnail: FileDto;
}

export class TrainingCourseLessonDtoPagedResultDto implements ITrainingCourseLessonDtoPagedResultDto {
    items!: TrainingCourseLessonDto[] | undefined;
    totalCount!: number;

    constructor(data?: ITrainingCourseLessonDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TrainingCourseLessonDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): TrainingCourseLessonDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingCourseLessonDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): TrainingCourseLessonDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TrainingCourseLessonDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITrainingCourseLessonDtoPagedResultDto {
    items: TrainingCourseLessonDto[] | undefined;
    totalCount: number;
}

export class TrainingCourseLessonFileDto implements ITrainingCourseLessonFileDto {
    id!: number;
    file!: FileDto;

    constructor(data?: ITrainingCourseLessonFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.file = _data["file"] ? FileDto.fromJS(_data["file"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TrainingCourseLessonFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingCourseLessonFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["file"] = this.file ? this.file.toJSON() : <any>undefined;
        return data;
    }

    clone(): TrainingCourseLessonFileDto {
        const json = this.toJSON();
        let result = new TrainingCourseLessonFileDto();
        result.init(json);
        return result;
    }
}

export interface ITrainingCourseLessonFileDto {
    id: number;
    file: FileDto;
}

export class TrainingCourseLessonUserDto implements ITrainingCourseLessonUserDto {
    id!: number;
    trainingCourseLesson!: TrainingCourseLessonDto;
    userId!: number;
    user!: UserDto;
    completionTime!: moment.Moment | undefined;
    secondsViewed!: TimeSpan;
    totalSeconds!: number | undefined;
    secondsViewedPercentage!: number;

    constructor(data?: ITrainingCourseLessonUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.trainingCourseLesson = _data["trainingCourseLesson"] ? TrainingCourseLessonDto.fromJS(_data["trainingCourseLesson"]) : <any>undefined;
            this.userId = _data["userId"];
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : <any>undefined;
            this.completionTime = _data["completionTime"] ? moment(_data["completionTime"].toString()) : <any>undefined;
            this.secondsViewed = _data["secondsViewed"] ? TimeSpan.fromJS(_data["secondsViewed"]) : <any>undefined;
            this.totalSeconds = _data["totalSeconds"];
            this.secondsViewedPercentage = _data["secondsViewedPercentage"];
        }
    }

    static fromJS(data: any): TrainingCourseLessonUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingCourseLessonUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["trainingCourseLesson"] = this.trainingCourseLesson ? this.trainingCourseLesson.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["completionTime"] = this.completionTime ? this.completionTime.toISOString() : <any>undefined;
        data["secondsViewed"] = this.secondsViewed ? this.secondsViewed.toJSON() : <any>undefined;
        data["totalSeconds"] = this.totalSeconds;
        data["secondsViewedPercentage"] = this.secondsViewedPercentage;
        return data;
    }

    clone(): TrainingCourseLessonUserDto {
        const json = this.toJSON();
        let result = new TrainingCourseLessonUserDto();
        result.init(json);
        return result;
    }
}

export interface ITrainingCourseLessonUserDto {
    id: number;
    trainingCourseLesson: TrainingCourseLessonDto;
    userId: number;
    user: UserDto;
    completionTime: moment.Moment | undefined;
    secondsViewed: TimeSpan;
    totalSeconds: number | undefined;
    secondsViewedPercentage: number;
}

export class TrainingCourseLessonUserDtoPagedResultDto implements ITrainingCourseLessonUserDtoPagedResultDto {
    items!: TrainingCourseLessonUserDto[] | undefined;
    totalCount!: number;

    constructor(data?: ITrainingCourseLessonUserDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TrainingCourseLessonUserDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): TrainingCourseLessonUserDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingCourseLessonUserDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): TrainingCourseLessonUserDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TrainingCourseLessonUserDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITrainingCourseLessonUserDtoPagedResultDto {
    items: TrainingCourseLessonUserDto[] | undefined;
    totalCount: number;
}

export class TrainingCourseTopicDto implements ITrainingCourseTopicDto {
    id!: number;
    description!: string | undefined;

    constructor(data?: ITrainingCourseTopicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): TrainingCourseTopicDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingCourseTopicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        return data;
    }

    clone(): TrainingCourseTopicDto {
        const json = this.toJSON();
        let result = new TrainingCourseTopicDto();
        result.init(json);
        return result;
    }
}

export interface ITrainingCourseTopicDto {
    id: number;
    description: string | undefined;
}

export class TrainingCourseTopicDtoPagedResultDto implements ITrainingCourseTopicDtoPagedResultDto {
    items!: TrainingCourseTopicDto[] | undefined;
    totalCount!: number;

    constructor(data?: ITrainingCourseTopicDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TrainingCourseTopicDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): TrainingCourseTopicDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingCourseTopicDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): TrainingCourseTopicDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TrainingCourseTopicDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITrainingCourseTopicDtoPagedResultDto {
    items: TrainingCourseTopicDto[] | undefined;
    totalCount: number;
}

export class TrainingCourseTopicFilterDto implements ITrainingCourseTopicFilterDto {
    trainingCourseTopic!: TrainingCourseTopicDto;
    userCount!: number;

    constructor(data?: ITrainingCourseTopicFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trainingCourseTopic = _data["trainingCourseTopic"] ? TrainingCourseTopicDto.fromJS(_data["trainingCourseTopic"]) : <any>undefined;
            this.userCount = _data["userCount"];
        }
    }

    static fromJS(data: any): TrainingCourseTopicFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingCourseTopicFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trainingCourseTopic"] = this.trainingCourseTopic ? this.trainingCourseTopic.toJSON() : <any>undefined;
        data["userCount"] = this.userCount;
        return data;
    }

    clone(): TrainingCourseTopicFilterDto {
        const json = this.toJSON();
        let result = new TrainingCourseTopicFilterDto();
        result.init(json);
        return result;
    }
}

export interface ITrainingCourseTopicFilterDto {
    trainingCourseTopic: TrainingCourseTopicDto;
    userCount: number;
}

export class UpdateCompanyDto implements IUpdateCompanyDto {
    id!: number;
    sectorId!: number;
    regionId!: number;
    businessName!: string | undefined;
    fiscalCode!: string | undefined;

    constructor(data?: IUpdateCompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sectorId = _data["sectorId"];
            this.regionId = _data["regionId"];
            this.businessName = _data["businessName"];
            this.fiscalCode = _data["fiscalCode"];
        }
    }

    static fromJS(data: any): UpdateCompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sectorId"] = this.sectorId;
        data["regionId"] = this.regionId;
        data["businessName"] = this.businessName;
        data["fiscalCode"] = this.fiscalCode;
        return data;
    }

    clone(): UpdateCompanyDto {
        const json = this.toJSON();
        let result = new UpdateCompanyDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateCompanyDto {
    id: number;
    sectorId: number;
    regionId: number;
    businessName: string | undefined;
    fiscalCode: string | undefined;
}

export class UpdatePlannedEventDto implements IUpdatePlannedEventDto {
    id!: number;
    participationMode!: Int64EntityDto;
    isPublished!: boolean;
    googleMapsUrl!: string | undefined;
    address!: string | undefined;

    constructor(data?: IUpdatePlannedEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.participationMode = _data["participationMode"] ? Int64EntityDto.fromJS(_data["participationMode"]) : <any>undefined;
            this.isPublished = _data["isPublished"];
            this.googleMapsUrl = _data["googleMapsUrl"];
            this.address = _data["address"];
        }
    }

    static fromJS(data: any): UpdatePlannedEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePlannedEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["participationMode"] = this.participationMode ? this.participationMode.toJSON() : <any>undefined;
        data["isPublished"] = this.isPublished;
        data["googleMapsUrl"] = this.googleMapsUrl;
        data["address"] = this.address;
        return data;
    }

    clone(): UpdatePlannedEventDto {
        const json = this.toJSON();
        let result = new UpdatePlannedEventDto();
        result.init(json);
        return result;
    }
}

export interface IUpdatePlannedEventDto {
    id: number;
    participationMode: Int64EntityDto;
    isPublished: boolean;
    googleMapsUrl: string | undefined;
    address: string | undefined;
}

export class UpdateTrainingCourseDto implements IUpdateTrainingCourseDto {
    id!: number;
    name!: string | undefined;
    description!: string | undefined;
    topicId!: number;
    contentTypeId!: number;
    isPublished!: boolean;

    constructor(data?: IUpdateTrainingCourseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.topicId = _data["topicId"];
            this.contentTypeId = _data["contentTypeId"];
            this.isPublished = _data["isPublished"];
        }
    }

    static fromJS(data: any): UpdateTrainingCourseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTrainingCourseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["topicId"] = this.topicId;
        data["contentTypeId"] = this.contentTypeId;
        data["isPublished"] = this.isPublished;
        return data;
    }

    clone(): UpdateTrainingCourseDto {
        const json = this.toJSON();
        let result = new UpdateTrainingCourseDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateTrainingCourseDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
    topicId: number;
    contentTypeId: number;
    isPublished: boolean;
}

export class UpdateTrainingCourseLessonChapterDto implements IUpdateTrainingCourseLessonChapterDto {
    id!: number;
    description!: string | undefined;
    minute!: string | undefined;

    constructor(data?: IUpdateTrainingCourseLessonChapterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.minute = _data["minute"];
        }
    }

    static fromJS(data: any): UpdateTrainingCourseLessonChapterDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTrainingCourseLessonChapterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["minute"] = this.minute;
        return data;
    }

    clone(): UpdateTrainingCourseLessonChapterDto {
        const json = this.toJSON();
        let result = new UpdateTrainingCourseLessonChapterDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateTrainingCourseLessonChapterDto {
    id: number;
    description: string | undefined;
    minute: string | undefined;
}

export class UpdateTrainingCourseLessonDto implements IUpdateTrainingCourseLessonDto {
    id!: number;
    name!: string | undefined;
    description!: string | undefined;
    teacherName!: string | undefined;
    externalLink!: string | undefined;

    constructor(data?: IUpdateTrainingCourseLessonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.teacherName = _data["teacherName"];
            this.externalLink = _data["externalLink"];
        }
    }

    static fromJS(data: any): UpdateTrainingCourseLessonDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTrainingCourseLessonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["teacherName"] = this.teacherName;
        data["externalLink"] = this.externalLink;
        return data;
    }

    clone(): UpdateTrainingCourseLessonDto {
        const json = this.toJSON();
        let result = new UpdateTrainingCourseLessonDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateTrainingCourseLessonDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
    teacherName: string | undefined;
    externalLink: string | undefined;
}

export class UpdateUserDto implements IUpdateUserDto {
    id!: number;
    name!: string | undefined;
    surname!: string | undefined;
    phoneNumber!: string | undefined;

    constructor(data?: IUpdateUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): UpdateUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }

    clone(): UpdateUserDto {
        const json = this.toJSON();
        let result = new UpdateUserDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    phoneNumber: string | undefined;
}

export class UpdateUserPreferenceContractDto implements IUpdateUserPreferenceContractDto {
    applicationIds!: number[] | undefined;
    beneficiaryIds!: number[] | undefined;
    facilitationIds!: number[] | undefined;
    regionIds!: number[] | undefined;
    eligibleExpenditureIds!: number[] | undefined;

    constructor(data?: IUpdateUserPreferenceContractDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["applicationIds"])) {
                this.applicationIds = [] as any;
                for (let item of _data["applicationIds"])
                    this.applicationIds!.push(item);
            }
            if (Array.isArray(_data["beneficiaryIds"])) {
                this.beneficiaryIds = [] as any;
                for (let item of _data["beneficiaryIds"])
                    this.beneficiaryIds!.push(item);
            }
            if (Array.isArray(_data["facilitationIds"])) {
                this.facilitationIds = [] as any;
                for (let item of _data["facilitationIds"])
                    this.facilitationIds!.push(item);
            }
            if (Array.isArray(_data["regionIds"])) {
                this.regionIds = [] as any;
                for (let item of _data["regionIds"])
                    this.regionIds!.push(item);
            }
            if (Array.isArray(_data["eligibleExpenditureIds"])) {
                this.eligibleExpenditureIds = [] as any;
                for (let item of _data["eligibleExpenditureIds"])
                    this.eligibleExpenditureIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateUserPreferenceContractDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserPreferenceContractDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.applicationIds)) {
            data["applicationIds"] = [];
            for (let item of this.applicationIds)
                data["applicationIds"].push(item);
        }
        if (Array.isArray(this.beneficiaryIds)) {
            data["beneficiaryIds"] = [];
            for (let item of this.beneficiaryIds)
                data["beneficiaryIds"].push(item);
        }
        if (Array.isArray(this.facilitationIds)) {
            data["facilitationIds"] = [];
            for (let item of this.facilitationIds)
                data["facilitationIds"].push(item);
        }
        if (Array.isArray(this.regionIds)) {
            data["regionIds"] = [];
            for (let item of this.regionIds)
                data["regionIds"].push(item);
        }
        if (Array.isArray(this.eligibleExpenditureIds)) {
            data["eligibleExpenditureIds"] = [];
            for (let item of this.eligibleExpenditureIds)
                data["eligibleExpenditureIds"].push(item);
        }
        return data;
    }

    clone(): UpdateUserPreferenceContractDto {
        const json = this.toJSON();
        let result = new UpdateUserPreferenceContractDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserPreferenceContractDto {
    applicationIds: number[] | undefined;
    beneficiaryIds: number[] | undefined;
    facilitationIds: number[] | undefined;
    regionIds: number[] | undefined;
    eligibleExpenditureIds: number[] | undefined;
}

export class UpdateUserPreferenceTrainingCourseDto implements IUpdateUserPreferenceTrainingCourseDto {
    trainingCourseTopicIds!: number[] | undefined;
    trainingCourseContentTypeIds!: number[] | undefined;

    constructor(data?: IUpdateUserPreferenceTrainingCourseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["trainingCourseTopicIds"])) {
                this.trainingCourseTopicIds = [] as any;
                for (let item of _data["trainingCourseTopicIds"])
                    this.trainingCourseTopicIds!.push(item);
            }
            if (Array.isArray(_data["trainingCourseContentTypeIds"])) {
                this.trainingCourseContentTypeIds = [] as any;
                for (let item of _data["trainingCourseContentTypeIds"])
                    this.trainingCourseContentTypeIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateUserPreferenceTrainingCourseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserPreferenceTrainingCourseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.trainingCourseTopicIds)) {
            data["trainingCourseTopicIds"] = [];
            for (let item of this.trainingCourseTopicIds)
                data["trainingCourseTopicIds"].push(item);
        }
        if (Array.isArray(this.trainingCourseContentTypeIds)) {
            data["trainingCourseContentTypeIds"] = [];
            for (let item of this.trainingCourseContentTypeIds)
                data["trainingCourseContentTypeIds"].push(item);
        }
        return data;
    }

    clone(): UpdateUserPreferenceTrainingCourseDto {
        const json = this.toJSON();
        let result = new UpdateUserPreferenceTrainingCourseDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserPreferenceTrainingCourseDto {
    trainingCourseTopicIds: number[] | undefined;
    trainingCourseContentTypeIds: number[] | undefined;
}

export class User implements IUser {
    id!: number;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    lastModificationTime!: moment.Moment | undefined;
    lastModifierUserId!: number | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: moment.Moment | undefined;
    authenticationSource!: string | undefined;
    userName!: string;
    tenantId!: number | undefined;
    emailAddress!: string;
    name!: string;
    surname!: string;
    readonly fullName!: string | undefined;
    password!: string;
    emailConfirmationCode!: string | undefined;
    passwordResetCode!: string | undefined;
    lockoutEndDateUtc!: moment.Moment | undefined;
    accessFailedCount!: number;
    isLockoutEnabled!: boolean;
    phoneNumber!: string | undefined;
    isPhoneNumberConfirmed!: boolean;
    securityStamp!: string | undefined;
    isTwoFactorEnabled!: boolean;
    logins!: UserLogin[] | undefined;
    roles!: UserRole[] | undefined;
    claims!: UserClaim[] | undefined;
    permissions!: UserPermissionSetting[] | undefined;
    settings!: Setting[] | undefined;
    isEmailConfirmed!: boolean;
    isActive!: boolean;
    normalizedUserName!: string;
    normalizedEmailAddress!: string;
    concurrencyStamp!: string | undefined;
    tokens!: UserToken[] | undefined;
    deleterUser!: User;
    creatorUser!: User;
    lastModifierUser!: User;
    birthDate!: moment.Moment | undefined;
    gender!: Gender;
    fiscalCode!: string | undefined;
    vatCode!: string | undefined;
    annotation!: string | undefined;
    isNewsletterActivated!: boolean;
    isPersonalConsentDataActivated!: boolean;
    companyUser!: CompanyUser[] | undefined;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.authenticationSource = _data["authenticationSource"];
            this.userName = _data["userName"];
            this.tenantId = _data["tenantId"];
            this.emailAddress = _data["emailAddress"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            (<any>this).fullName = _data["fullName"];
            this.password = _data["password"];
            this.emailConfirmationCode = _data["emailConfirmationCode"];
            this.passwordResetCode = _data["passwordResetCode"];
            this.lockoutEndDateUtc = _data["lockoutEndDateUtc"] ? moment(_data["lockoutEndDateUtc"].toString()) : <any>undefined;
            this.accessFailedCount = _data["accessFailedCount"];
            this.isLockoutEnabled = _data["isLockoutEnabled"];
            this.phoneNumber = _data["phoneNumber"];
            this.isPhoneNumberConfirmed = _data["isPhoneNumberConfirmed"];
            this.securityStamp = _data["securityStamp"];
            this.isTwoFactorEnabled = _data["isTwoFactorEnabled"];
            if (Array.isArray(_data["logins"])) {
                this.logins = [] as any;
                for (let item of _data["logins"])
                    this.logins!.push(UserLogin.fromJS(item));
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(UserRole.fromJS(item));
            }
            if (Array.isArray(_data["claims"])) {
                this.claims = [] as any;
                for (let item of _data["claims"])
                    this.claims!.push(UserClaim.fromJS(item));
            }
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(UserPermissionSetting.fromJS(item));
            }
            if (Array.isArray(_data["settings"])) {
                this.settings = [] as any;
                for (let item of _data["settings"])
                    this.settings!.push(Setting.fromJS(item));
            }
            this.isEmailConfirmed = _data["isEmailConfirmed"];
            this.isActive = _data["isActive"];
            this.normalizedUserName = _data["normalizedUserName"];
            this.normalizedEmailAddress = _data["normalizedEmailAddress"];
            this.concurrencyStamp = _data["concurrencyStamp"];
            if (Array.isArray(_data["tokens"])) {
                this.tokens = [] as any;
                for (let item of _data["tokens"])
                    this.tokens!.push(UserToken.fromJS(item));
            }
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : <any>undefined;
            this.gender = _data["gender"] ? Gender.fromJS(_data["gender"]) : <any>undefined;
            this.fiscalCode = _data["fiscalCode"];
            this.vatCode = _data["vatCode"];
            this.annotation = _data["annotation"];
            this.isNewsletterActivated = _data["isNewsletterActivated"];
            this.isPersonalConsentDataActivated = _data["isPersonalConsentDataActivated"];
            if (Array.isArray(_data["companyUser"])) {
                this.companyUser = [] as any;
                for (let item of _data["companyUser"])
                    this.companyUser!.push(CompanyUser.fromJS(item));
            }
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["authenticationSource"] = this.authenticationSource;
        data["userName"] = this.userName;
        data["tenantId"] = this.tenantId;
        data["emailAddress"] = this.emailAddress;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["fullName"] = this.fullName;
        data["password"] = this.password;
        data["emailConfirmationCode"] = this.emailConfirmationCode;
        data["passwordResetCode"] = this.passwordResetCode;
        data["lockoutEndDateUtc"] = this.lockoutEndDateUtc ? this.lockoutEndDateUtc.toISOString() : <any>undefined;
        data["accessFailedCount"] = this.accessFailedCount;
        data["isLockoutEnabled"] = this.isLockoutEnabled;
        data["phoneNumber"] = this.phoneNumber;
        data["isPhoneNumberConfirmed"] = this.isPhoneNumberConfirmed;
        data["securityStamp"] = this.securityStamp;
        data["isTwoFactorEnabled"] = this.isTwoFactorEnabled;
        if (Array.isArray(this.logins)) {
            data["logins"] = [];
            for (let item of this.logins)
                data["logins"].push(item.toJSON());
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item.toJSON());
        }
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.settings)) {
            data["settings"] = [];
            for (let item of this.settings)
                data["settings"].push(item.toJSON());
        }
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        data["isActive"] = this.isActive;
        data["normalizedUserName"] = this.normalizedUserName;
        data["normalizedEmailAddress"] = this.normalizedEmailAddress;
        data["concurrencyStamp"] = this.concurrencyStamp;
        if (Array.isArray(this.tokens)) {
            data["tokens"] = [];
            for (let item of this.tokens)
                data["tokens"].push(item.toJSON());
        }
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["birthDate"] = this.birthDate ? this.birthDate.format('YYYY-MM-DD') : <any>undefined;
        data["gender"] = this.gender ? this.gender.toJSON() : <any>undefined;
        data["fiscalCode"] = this.fiscalCode;
        data["vatCode"] = this.vatCode;
        data["annotation"] = this.annotation;
        data["isNewsletterActivated"] = this.isNewsletterActivated;
        data["isPersonalConsentDataActivated"] = this.isPersonalConsentDataActivated;
        if (Array.isArray(this.companyUser)) {
            data["companyUser"] = [];
            for (let item of this.companyUser)
                data["companyUser"].push(item.toJSON());
        }
        return data;
    }

    clone(): User {
        const json = this.toJSON();
        let result = new User();
        result.init(json);
        return result;
    }
}

export interface IUser {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    authenticationSource: string | undefined;
    userName: string;
    tenantId: number | undefined;
    emailAddress: string;
    name: string;
    surname: string;
    fullName: string | undefined;
    password: string;
    emailConfirmationCode: string | undefined;
    passwordResetCode: string | undefined;
    lockoutEndDateUtc: moment.Moment | undefined;
    accessFailedCount: number;
    isLockoutEnabled: boolean;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean;
    securityStamp: string | undefined;
    isTwoFactorEnabled: boolean;
    logins: UserLogin[] | undefined;
    roles: UserRole[] | undefined;
    claims: UserClaim[] | undefined;
    permissions: UserPermissionSetting[] | undefined;
    settings: Setting[] | undefined;
    isEmailConfirmed: boolean;
    isActive: boolean;
    normalizedUserName: string;
    normalizedEmailAddress: string;
    concurrencyStamp: string | undefined;
    tokens: UserToken[] | undefined;
    deleterUser: User;
    creatorUser: User;
    lastModifierUser: User;
    birthDate: moment.Moment | undefined;
    gender: Gender;
    fiscalCode: string | undefined;
    vatCode: string | undefined;
    annotation: string | undefined;
    isNewsletterActivated: boolean;
    isPersonalConsentDataActivated: boolean;
    companyUser: CompanyUser[] | undefined;
}

export class UserClaim implements IUserClaim {
    id!: number;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    tenantId!: number | undefined;
    userId!: number;
    claimType!: string | undefined;
    claimValue!: string | undefined;

    constructor(data?: IUserClaim) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.claimType = _data["claimType"];
            this.claimValue = _data["claimValue"];
        }
    }

    static fromJS(data: any): UserClaim {
        data = typeof data === 'object' ? data : {};
        let result = new UserClaim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["claimType"] = this.claimType;
        data["claimValue"] = this.claimValue;
        return data;
    }

    clone(): UserClaim {
        const json = this.toJSON();
        let result = new UserClaim();
        result.init(json);
        return result;
    }
}

export interface IUserClaim {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    userId: number;
    claimType: string | undefined;
    claimValue: string | undefined;
}

export class UserDto implements IUserDto {
    id!: number;
    name!: string | undefined;
    surname!: string | undefined;
    gender!: GenderDto;
    birthDate!: moment.Moment | undefined;
    phoneNumber!: string | undefined;
    vatCode!: string | undefined;
    fiscalCode!: string | undefined;
    annotation!: string | undefined;
    emailAddress!: string | undefined;
    roleNames!: string[] | undefined;
    roleDisplayNames!: string[] | undefined;
    isActive!: boolean;
    isDeleted!: boolean;
    isEmailConfirmed!: boolean;
    fullName!: string | undefined;
    accessFailedCount!: number;
    lockoutEndDateUtc!: moment.Moment | undefined;
    grantedPermissions!: string[] | undefined;
    lastLoginTime!: moment.Moment | undefined;
    isNewsletterActivated!: boolean;
    creationTime!: moment.Moment;
    company!: CompanyBaseDto;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.gender = _data["gender"] ? GenderDto.fromJS(_data["gender"]) : <any>undefined;
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : <any>undefined;
            this.phoneNumber = _data["phoneNumber"];
            this.vatCode = _data["vatCode"];
            this.fiscalCode = _data["fiscalCode"];
            this.annotation = _data["annotation"];
            this.emailAddress = _data["emailAddress"];
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames!.push(item);
            }
            if (Array.isArray(_data["roleDisplayNames"])) {
                this.roleDisplayNames = [] as any;
                for (let item of _data["roleDisplayNames"])
                    this.roleDisplayNames!.push(item);
            }
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.isEmailConfirmed = _data["isEmailConfirmed"];
            this.fullName = _data["fullName"];
            this.accessFailedCount = _data["accessFailedCount"];
            this.lockoutEndDateUtc = _data["lockoutEndDateUtc"] ? moment(_data["lockoutEndDateUtc"].toString()) : <any>undefined;
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions!.push(item);
            }
            this.lastLoginTime = _data["lastLoginTime"] ? moment(_data["lastLoginTime"].toString()) : <any>undefined;
            this.isNewsletterActivated = _data["isNewsletterActivated"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.company = _data["company"] ? CompanyBaseDto.fromJS(_data["company"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["gender"] = this.gender ? this.gender.toJSON() : <any>undefined;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["phoneNumber"] = this.phoneNumber;
        data["vatCode"] = this.vatCode;
        data["fiscalCode"] = this.fiscalCode;
        data["annotation"] = this.annotation;
        data["emailAddress"] = this.emailAddress;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        if (Array.isArray(this.roleDisplayNames)) {
            data["roleDisplayNames"] = [];
            for (let item of this.roleDisplayNames)
                data["roleDisplayNames"].push(item);
        }
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        data["fullName"] = this.fullName;
        data["accessFailedCount"] = this.accessFailedCount;
        data["lockoutEndDateUtc"] = this.lockoutEndDateUtc ? this.lockoutEndDateUtc.toISOString() : <any>undefined;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
        data["isNewsletterActivated"] = this.isNewsletterActivated;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        return data;
    }

    clone(): UserDto {
        const json = this.toJSON();
        let result = new UserDto();
        result.init(json);
        return result;
    }
}

export interface IUserDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    gender: GenderDto;
    birthDate: moment.Moment | undefined;
    phoneNumber: string | undefined;
    vatCode: string | undefined;
    fiscalCode: string | undefined;
    annotation: string | undefined;
    emailAddress: string | undefined;
    roleNames: string[] | undefined;
    roleDisplayNames: string[] | undefined;
    isActive: boolean;
    isDeleted: boolean;
    isEmailConfirmed: boolean;
    fullName: string | undefined;
    accessFailedCount: number;
    lockoutEndDateUtc: moment.Moment | undefined;
    grantedPermissions: string[] | undefined;
    lastLoginTime: moment.Moment | undefined;
    isNewsletterActivated: boolean;
    creationTime: moment.Moment;
    company: CompanyBaseDto;
}

export class UserDtoPagedResultDto implements IUserDtoPagedResultDto {
    items!: UserDto[] | undefined;
    totalCount!: number;

    constructor(data?: IUserDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): UserDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): UserDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserDtoPagedResultDto {
    items: UserDto[] | undefined;
    totalCount: number;
}

export class UserInvitationDto implements IUserInvitationDto {
    id!: number;
    batchId!: string;
    company!: CompanyDto;
    emailAddress!: string | undefined;
    name!: string | undefined;
    surname!: string | undefined;
    userIdGenerated!: number | undefined;

    constructor(data?: IUserInvitationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.batchId = _data["batchId"];
            this.company = _data["company"] ? CompanyDto.fromJS(_data["company"]) : <any>undefined;
            this.emailAddress = _data["emailAddress"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userIdGenerated = _data["userIdGenerated"];
        }
    }

    static fromJS(data: any): UserInvitationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserInvitationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["batchId"] = this.batchId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["emailAddress"] = this.emailAddress;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userIdGenerated"] = this.userIdGenerated;
        return data;
    }

    clone(): UserInvitationDto {
        const json = this.toJSON();
        let result = new UserInvitationDto();
        result.init(json);
        return result;
    }
}

export interface IUserInvitationDto {
    id: number;
    batchId: string;
    company: CompanyDto;
    emailAddress: string | undefined;
    name: string | undefined;
    surname: string | undefined;
    userIdGenerated: number | undefined;
}

export class UserInvitationDtoPagedResultDto implements IUserInvitationDtoPagedResultDto {
    items!: UserInvitationDto[] | undefined;
    totalCount!: number;

    constructor(data?: IUserInvitationDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserInvitationDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): UserInvitationDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserInvitationDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): UserInvitationDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserInvitationDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserInvitationDtoPagedResultDto {
    items: UserInvitationDto[] | undefined;
    totalCount: number;
}

export class UserInvitationsResultDto implements IUserInvitationsResultDto {
    invitationsCount!: number;
    invitationsSentCount!: number;
    invitationsAlreadySentCount!: number;
    usersAlreadyRegisteredCount!: number;
    invitationsFailedCount!: number;

    constructor(data?: IUserInvitationsResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invitationsCount = _data["invitationsCount"];
            this.invitationsSentCount = _data["invitationsSentCount"];
            this.invitationsAlreadySentCount = _data["invitationsAlreadySentCount"];
            this.usersAlreadyRegisteredCount = _data["usersAlreadyRegisteredCount"];
            this.invitationsFailedCount = _data["invitationsFailedCount"];
        }
    }

    static fromJS(data: any): UserInvitationsResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserInvitationsResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invitationsCount"] = this.invitationsCount;
        data["invitationsSentCount"] = this.invitationsSentCount;
        data["invitationsAlreadySentCount"] = this.invitationsAlreadySentCount;
        data["usersAlreadyRegisteredCount"] = this.usersAlreadyRegisteredCount;
        data["invitationsFailedCount"] = this.invitationsFailedCount;
        return data;
    }

    clone(): UserInvitationsResultDto {
        const json = this.toJSON();
        let result = new UserInvitationsResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserInvitationsResultDto {
    invitationsCount: number;
    invitationsSentCount: number;
    invitationsAlreadySentCount: number;
    usersAlreadyRegisteredCount: number;
    invitationsFailedCount: number;
}

export class UserLogin implements IUserLogin {
    id!: number;
    tenantId!: number | undefined;
    userId!: number;
    loginProvider!: string;
    providerKey!: string;

    constructor(data?: IUserLogin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.loginProvider = _data["loginProvider"];
            this.providerKey = _data["providerKey"];
        }
    }

    static fromJS(data: any): UserLogin {
        data = typeof data === 'object' ? data : {};
        let result = new UserLogin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["loginProvider"] = this.loginProvider;
        data["providerKey"] = this.providerKey;
        return data;
    }

    clone(): UserLogin {
        const json = this.toJSON();
        let result = new UserLogin();
        result.init(json);
        return result;
    }
}

export interface IUserLogin {
    id: number;
    tenantId: number | undefined;
    userId: number;
    loginProvider: string;
    providerKey: string;
}

export class UserPermissionSetting implements IUserPermissionSetting {
    id!: number;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    tenantId!: number | undefined;
    name!: string;
    isGranted!: boolean;
    userId!: number;

    constructor(data?: IUserPermissionSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.isGranted = _data["isGranted"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): UserPermissionSetting {
        data = typeof data === 'object' ? data : {};
        let result = new UserPermissionSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["isGranted"] = this.isGranted;
        data["userId"] = this.userId;
        return data;
    }

    clone(): UserPermissionSetting {
        const json = this.toJSON();
        let result = new UserPermissionSetting();
        result.init(json);
        return result;
    }
}

export interface IUserPermissionSetting {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    name: string;
    isGranted: boolean;
    userId: number;
}

export class UserPreferenceContractDto implements IUserPreferenceContractDto {
    infocicaRegion!: InfocicaRegionDto[] | undefined;
    infocicaApplications!: InfocicaApplicationDto[] | undefined;
    infocicaFacilitation!: InfocicaFacilitationDto[] | undefined;
    infocicaBeneficiary!: InfocicaBeneficiaryDto[] | undefined;
    infocicaEligibleExpenditure!: InfocicaEligibleExpenditureDto[] | undefined;

    constructor(data?: IUserPreferenceContractDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["infocicaRegion"])) {
                this.infocicaRegion = [] as any;
                for (let item of _data["infocicaRegion"])
                    this.infocicaRegion!.push(InfocicaRegionDto.fromJS(item));
            }
            if (Array.isArray(_data["infocicaApplications"])) {
                this.infocicaApplications = [] as any;
                for (let item of _data["infocicaApplications"])
                    this.infocicaApplications!.push(InfocicaApplicationDto.fromJS(item));
            }
            if (Array.isArray(_data["infocicaFacilitation"])) {
                this.infocicaFacilitation = [] as any;
                for (let item of _data["infocicaFacilitation"])
                    this.infocicaFacilitation!.push(InfocicaFacilitationDto.fromJS(item));
            }
            if (Array.isArray(_data["infocicaBeneficiary"])) {
                this.infocicaBeneficiary = [] as any;
                for (let item of _data["infocicaBeneficiary"])
                    this.infocicaBeneficiary!.push(InfocicaBeneficiaryDto.fromJS(item));
            }
            if (Array.isArray(_data["infocicaEligibleExpenditure"])) {
                this.infocicaEligibleExpenditure = [] as any;
                for (let item of _data["infocicaEligibleExpenditure"])
                    this.infocicaEligibleExpenditure!.push(InfocicaEligibleExpenditureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserPreferenceContractDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserPreferenceContractDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.infocicaRegion)) {
            data["infocicaRegion"] = [];
            for (let item of this.infocicaRegion)
                data["infocicaRegion"].push(item.toJSON());
        }
        if (Array.isArray(this.infocicaApplications)) {
            data["infocicaApplications"] = [];
            for (let item of this.infocicaApplications)
                data["infocicaApplications"].push(item.toJSON());
        }
        if (Array.isArray(this.infocicaFacilitation)) {
            data["infocicaFacilitation"] = [];
            for (let item of this.infocicaFacilitation)
                data["infocicaFacilitation"].push(item.toJSON());
        }
        if (Array.isArray(this.infocicaBeneficiary)) {
            data["infocicaBeneficiary"] = [];
            for (let item of this.infocicaBeneficiary)
                data["infocicaBeneficiary"].push(item.toJSON());
        }
        if (Array.isArray(this.infocicaEligibleExpenditure)) {
            data["infocicaEligibleExpenditure"] = [];
            for (let item of this.infocicaEligibleExpenditure)
                data["infocicaEligibleExpenditure"].push(item.toJSON());
        }
        return data;
    }

    clone(): UserPreferenceContractDto {
        const json = this.toJSON();
        let result = new UserPreferenceContractDto();
        result.init(json);
        return result;
    }
}

export interface IUserPreferenceContractDto {
    infocicaRegion: InfocicaRegionDto[] | undefined;
    infocicaApplications: InfocicaApplicationDto[] | undefined;
    infocicaFacilitation: InfocicaFacilitationDto[] | undefined;
    infocicaBeneficiary: InfocicaBeneficiaryDto[] | undefined;
    infocicaEligibleExpenditure: InfocicaEligibleExpenditureDto[] | undefined;
}

export class UserPreferenceTrainigCourseDto implements IUserPreferenceTrainigCourseDto {
    trainingCourseTopics!: TrainingCourseTopicDto[] | undefined;
    trainingCourseContentType!: TrainingCourseContentTypeDto[] | undefined;

    constructor(data?: IUserPreferenceTrainigCourseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["trainingCourseTopics"])) {
                this.trainingCourseTopics = [] as any;
                for (let item of _data["trainingCourseTopics"])
                    this.trainingCourseTopics!.push(TrainingCourseTopicDto.fromJS(item));
            }
            if (Array.isArray(_data["trainingCourseContentType"])) {
                this.trainingCourseContentType = [] as any;
                for (let item of _data["trainingCourseContentType"])
                    this.trainingCourseContentType!.push(TrainingCourseContentTypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserPreferenceTrainigCourseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserPreferenceTrainigCourseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.trainingCourseTopics)) {
            data["trainingCourseTopics"] = [];
            for (let item of this.trainingCourseTopics)
                data["trainingCourseTopics"].push(item.toJSON());
        }
        if (Array.isArray(this.trainingCourseContentType)) {
            data["trainingCourseContentType"] = [];
            for (let item of this.trainingCourseContentType)
                data["trainingCourseContentType"].push(item.toJSON());
        }
        return data;
    }

    clone(): UserPreferenceTrainigCourseDto {
        const json = this.toJSON();
        let result = new UserPreferenceTrainigCourseDto();
        result.init(json);
        return result;
    }
}

export interface IUserPreferenceTrainigCourseDto {
    trainingCourseTopics: TrainingCourseTopicDto[] | undefined;
    trainingCourseContentType: TrainingCourseContentTypeDto[] | undefined;
}

export class UserRole implements IUserRole {
    id!: number;
    creationTime!: moment.Moment;
    creatorUserId!: number | undefined;
    tenantId!: number | undefined;
    userId!: number;
    roleId!: number;

    constructor(data?: IUserRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.roleId = _data["roleId"];
        }
    }

    static fromJS(data: any): UserRole {
        data = typeof data === 'object' ? data : {};
        let result = new UserRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["roleId"] = this.roleId;
        return data;
    }

    clone(): UserRole {
        const json = this.toJSON();
        let result = new UserRole();
        result.init(json);
        return result;
    }
}

export interface IUserRole {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    userId: number;
    roleId: number;
}

export class UserSavedContractDto implements IUserSavedContractDto {
    user!: UserDto;
    contract!: ContractDto;

    constructor(data?: IUserSavedContractDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : <any>undefined;
            this.contract = _data["contract"] ? ContractDto.fromJS(_data["contract"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserSavedContractDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserSavedContractDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["contract"] = this.contract ? this.contract.toJSON() : <any>undefined;
        return data;
    }

    clone(): UserSavedContractDto {
        const json = this.toJSON();
        let result = new UserSavedContractDto();
        result.init(json);
        return result;
    }
}

export interface IUserSavedContractDto {
    user: UserDto;
    contract: ContractDto;
}

export class UserToken implements IUserToken {
    id!: number;
    tenantId!: number | undefined;
    userId!: number;
    loginProvider!: string | undefined;
    name!: string | undefined;
    value!: string | undefined;
    expireDate!: moment.Moment | undefined;

    constructor(data?: IUserToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.loginProvider = _data["loginProvider"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.expireDate = _data["expireDate"] ? moment(_data["expireDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserToken {
        data = typeof data === 'object' ? data : {};
        let result = new UserToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["loginProvider"] = this.loginProvider;
        data["name"] = this.name;
        data["value"] = this.value;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): UserToken {
        const json = this.toJSON();
        let result = new UserToken();
        result.init(json);
        return result;
    }
}

export interface IUserToken {
    id: number;
    tenantId: number | undefined;
    userId: number;
    loginProvider: string | undefined;
    name: string | undefined;
    value: string | undefined;
    expireDate: moment.Moment | undefined;
}

export class VideoFileDto implements IVideoFileDto {
    id!: number;
    mask!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    extension!: string | undefined;
    mimeType!: string | undefined;
    size!: number;
    signedUrl!: string | undefined;

    constructor(data?: IVideoFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mask = _data["mask"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.extension = _data["extension"];
            this.mimeType = _data["mimeType"];
            this.size = _data["size"];
            this.signedUrl = _data["signedUrl"];
        }
    }

    static fromJS(data: any): VideoFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new VideoFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mask"] = this.mask;
        data["name"] = this.name;
        data["description"] = this.description;
        data["extension"] = this.extension;
        data["mimeType"] = this.mimeType;
        data["size"] = this.size;
        data["signedUrl"] = this.signedUrl;
        return data;
    }

    clone(): VideoFileDto {
        const json = this.toJSON();
        let result = new VideoFileDto();
        result.init(json);
        return result;
    }
}

export interface IVideoFileDto {
    id: number;
    mask: string | undefined;
    name: string | undefined;
    description: string | undefined;
    extension: string | undefined;
    mimeType: string | undefined;
    size: number;
    signedUrl: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}